"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuantityAssignmentDto = exports.ArticleDataDto = exports.ProductDataDto = exports.ServiceTypeDto = exports.PriceTypeDto = exports.PositionTypeDto = exports.ItemNumberDto = exports.ComissionStatusDto = exports.STLBKeyDto = exports.STLBReferenceDto = exports.StandardReferenceTypeDto = exports.StandardizedDescriptionDto = exports.AdditionTypeDto = exports.SubDescriptionDto = exports.PriceComponentDto = exports.CalculationDto = exports.LabourPriceComponentDto = exports.PositionDto = exports.CatalogueReferenceDto = exports.CatalogueTypeDto = exports.CatalogueDto = exports.IElementDto = exports.ServiceSpecificationDto = exports.SpecialAwardKindDto = exports.AwardTypeDto = exports.PriceComponentTypeDto = exports.ItemNumberSchemaTierTypeDto = exports.ItemNumberTypeDto = exports.ItemNumberSchemaTierDto = exports.ItemNumberSchemaDto = exports.BankingInformationDto = exports.PartyInformationDto = exports.ProjectInformationDto = exports.PriceRoundingModeDto = exports.ProjectDto = exports.DanglIdentityApi = exports.XRechnungConversionApi = exports.ValidationApi = exports.UglConversionApi = exports.StatusApi = exports.SiaConversionApi = exports.RebConversionApi = exports.OenormConversionApi = exports.IdsConnectConversionApi = exports.GaebConversionApi = exports.FlatAvaConversionApi = exports.ExcelConversionApi = exports.DatanormConversionApi = exports.AvaConversionApi = exports.AslvConversionApi = void 0;
exports.Invoice = exports.PostGaebDestinationOptions = exports.PostOenormDestinationOptions = exports.PostAvaSourceOptions = exports.PostAvaProjectValidationSourceOptions = exports.FileValidationSourceType = exports.ValidationType = exports.ProjectValidationCheckDetails = exports.XmlSchemaValidationCheckDetails = exports.ObjectValidationCheckDetails = exports.ValidationCheckType = exports.ValidationSeverity = exports.ValidationCheckResult = exports.ValidationResult = exports.GetStatus = exports.IdsConnectVersion = exports.UglDestinationVersion = exports.DatanormDestinationVersion = exports.SiaDestinationType = exports.DestinationRebType = exports.DestinationOenormType = exports.DestinationGaebExchangePhase = exports.DestinationGaebType = exports.FlatElementDto = exports.FlatAvaProject = exports.ApiError = exports.CommerceInquiryTypeDto = exports.ServiceSpecificationCommercePropertiesDto = exports.DurationUnitDto = exports.WarrantyDurationDto = exports.TradeDiscountDto = exports.PriceInformationDto = exports.OriginDto = exports.ExchangePhaseDto = exports.OenormPropertiesDto = exports.GrossPriceComponentDto = exports.ServiceSpecificationGroupDto = exports.OenormNoteTextPropertiesDto = exports.NoteTextDto = exports.ExecutionDescriptionDto = exports.PriceCatalogueDataDto = exports.HoldOutDurationUnitDto = exports.HoldOutTypeDto = exports.PositionHoldOutPropertiesDto = exports.PositionComplementingTypeDto = exports.AddendumStatusDto = exports.OenormOriginCodeDto = exports.OenormPositionPropertiesDto = exports.ComplementedByQuantityDto = exports.CommercePropertiesDto = void 0;
exports.ApiException = exports.SwaggerResponse = exports.ClaimGet = exports.UserInfoGet = exports.ForgotPasswordPost = exports.RegisterPost = exports.TokenRefreshPost = exports.TokenLoginPost = exports.ResponseErrorType = exports.HttpStatusCode = exports.TokenResponseGet = exports.LoginPost = exports.AvaProjectWrapper = exports.SourceType = exports.LineItemAttribute = exports.LineItemInformation = exports.LineItemVatInformation = exports.LineItemPriceDetail = exports.LineItemCharge = exports.LineItemAllowance = exports.InvoiceLineItem = exports.InvoiceCharge = exports.InvoiceAllowance = exports.VatCategory = exports.VatBreakdown = exports.AttachmentMimeType = exports.SupportingDocument = exports.PaymentMeans = exports.PaymentInstructions = exports.InvoiceTotals = exports.InvoicePeriod = exports.InvoiceNote = exports.Payee = exports.Organization = exports.PreviousInvoice = exports.References = exports.InvoiceType = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
class AslvConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    aslvConversionConvertToAvaWithRequestObject(aslvFile, options) {
        return this.aslvConversionConvertToAva(aslvFile, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts);
    }
    /**
     * Converts Aslv files to Dangl.AVA projects
     * @param aslvFile (optional) The input file
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     */
    aslvConversionConvertToAva(aslvFile, removePlainTextLongTexts, removeHtmlLongTexts) {
        let url_ = this.baseUrl + "/conversion/aslv/ava?";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (aslvFile !== null && aslvFile !== undefined)
            content_.append("aslvFile", aslvFile.data, aslvFile.fileName ? aslvFile.fileName : "aslvFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAslvConversionConvertToAva(_response);
        });
    }
    processAslvConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * Converts Aslv files to Dangl.AVA projects
     * @param aslvFile (optional) The input file
     */
    aslvConversionConvertToFlatAva(aslvFile) {
        let url_ = this.baseUrl + "/conversion/aslv/flat-ava";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (aslvFile !== null && aslvFile !== undefined)
            content_.append("aslvFile", aslvFile.data, aslvFile.fileName ? aslvFile.fileName : "aslvFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAslvConversionConvertToFlatAva(_response);
        });
    }
    processAslvConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    aslvConversionConvertToGaebWithRequestObject(aslvFile, options) {
        return this.aslvConversionConvertToGaeb(aslvFile, options === null || options === void 0 ? void 0 : options.destinationGaebType, options === null || options === void 0 ? void 0 : options.targetExchangePhaseTransform, options === null || options === void 0 ? void 0 : options.enforceStrictOfferPhaseLongTextOutput, options === null || options === void 0 ? void 0 : options.exportQuantityDetermination, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts, options === null || options === void 0 ? void 0 : options.forceIncludeDescriptions, options === null || options === void 0 ? void 0 : options.treatNullItemNumberSchemaAsInvalid);
    }
    /**
     * Converts Aslv files to GAEB files
     * @param aslvFile (optional) The input file
     * @param destinationGaebType (optional) Defaults to GAEB XML V3.2
     * @param targetExchangePhaseTransform (optional) Defaults to none, meaning no transformation will be done. The phases are:
    Base = 81
    CostEstimate = 82
    OfferRequest = 83
    Offer = 84
    SideOffer = 85
    Grant = 86
     * @param enforceStrictOfferPhaseLongTextOutput (optional) Defaults to false. If this is enabled, exported long texts to GAEB XML that use text additions will
    be strictly schema compliant. If this is not enabled, any text that is marked to contain a text addition
    is exported in full to ensure that incorrectly used text additions are still preserved in the export.
     * @param exportQuantityDetermination (optional) Defaults to false. If this is enabled, quantities are exported in detail in GAEB XML targets via the
    'QtyDeterm' (Quantity Determination, or Quantity Take Off) fields. To control this, you can set custom
    quantity calculations in the 'QuantityComponents' property of positions. Please see the entry for
    'Quantity Determination' in the Dangl.AVA HowTo documentation section. Please be advised that enabling
    this might export data that was not intended to be exported, like internal quantity calculation details,
    depending on what data you put in the 'QuantityComponents' property.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     * @param forceIncludeDescriptions (optional) If this is enabled, all description elements like texts and execution descriptions will be output
    to the result. This is mostly only applicable to GAEB exports to phase 84 - Offer, which does
    typically not include descriptions.
     * @param treatNullItemNumberSchemaAsInvalid (optional) When exporting to GAEB, an item number schema is usually required. AVACloud will try to fix invalid item number schemas.
    With this setting, you can also tell AVACloud to treat a null value as invalid. Otherwise, null schemas will simply be ignored
    and not lead to any schema being generated. It is recommended to enable this option, but it is disabled by default for compatibility
    reasons.
     */
    aslvConversionConvertToGaeb(aslvFile, destinationGaebType, targetExchangePhaseTransform, enforceStrictOfferPhaseLongTextOutput, exportQuantityDetermination, removeUnprintableCharactersFromTexts, forceIncludeDescriptions, treatNullItemNumberSchemaAsInvalid) {
        let url_ = this.baseUrl + "/conversion/aslv/gaeb?";
        if (destinationGaebType === null)
            throw new Error("The parameter 'destinationGaebType' cannot be null.");
        else if (destinationGaebType !== undefined)
            url_ += "DestinationGaebType=" + encodeURIComponent("" + destinationGaebType) + "&";
        if (targetExchangePhaseTransform === null)
            throw new Error("The parameter 'targetExchangePhaseTransform' cannot be null.");
        else if (targetExchangePhaseTransform !== undefined)
            url_ += "TargetExchangePhaseTransform=" + encodeURIComponent("" + targetExchangePhaseTransform) + "&";
        if (enforceStrictOfferPhaseLongTextOutput === null)
            throw new Error("The parameter 'enforceStrictOfferPhaseLongTextOutput' cannot be null.");
        else if (enforceStrictOfferPhaseLongTextOutput !== undefined)
            url_ += "EnforceStrictOfferPhaseLongTextOutput=" + encodeURIComponent("" + enforceStrictOfferPhaseLongTextOutput) + "&";
        if (exportQuantityDetermination === null)
            throw new Error("The parameter 'exportQuantityDetermination' cannot be null.");
        else if (exportQuantityDetermination !== undefined)
            url_ += "ExportQuantityDetermination=" + encodeURIComponent("" + exportQuantityDetermination) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        if (forceIncludeDescriptions === null)
            throw new Error("The parameter 'forceIncludeDescriptions' cannot be null.");
        else if (forceIncludeDescriptions !== undefined)
            url_ += "ForceIncludeDescriptions=" + encodeURIComponent("" + forceIncludeDescriptions) + "&";
        if (treatNullItemNumberSchemaAsInvalid === null)
            throw new Error("The parameter 'treatNullItemNumberSchemaAsInvalid' cannot be null.");
        else if (treatNullItemNumberSchemaAsInvalid !== undefined)
            url_ += "TreatNullItemNumberSchemaAsInvalid=" + encodeURIComponent("" + treatNullItemNumberSchemaAsInvalid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (aslvFile !== null && aslvFile !== undefined)
            content_.append("aslvFile", aslvFile.data, aslvFile.fileName ? aslvFile.fileName : "aslvFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAslvConversionConvertToGaeb(_response);
        });
    }
    processAslvConversionConvertToGaeb(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    aslvConversionConvertToExcelWithRequestObject(aslvFile, options) {
        return this.aslvConversionConvertToExcel(aslvFile, options === null || options === void 0 ? void 0 : options.writePrices, options === null || options === void 0 ? void 0 : options.writeLongTexts, options === null || options === void 0 ? void 0 : options.conversionCulture, options === null || options === void 0 ? void 0 : options.includeArticleNumbers);
    }
    /**
     * Converts Aslv files to Excel
     * @param aslvFile (optional) The input file
     * @param writePrices (optional) Defaults to true
     * @param writeLongTexts (optional) Defaults to true
     * @param conversionCulture (optional) The culture that should be used for the conversion process, to have
    localized Excel files
     * @param includeArticleNumbers (optional) If this is enabled, then a new column will be created in the overview worksheet
    that contains the article numbers for positions. Article numbers will be read from
    'position.commerceProperties.articleNumber'
     */
    aslvConversionConvertToExcel(aslvFile, writePrices, writeLongTexts, conversionCulture, includeArticleNumbers) {
        let url_ = this.baseUrl + "/conversion/aslv/excel?";
        if (writePrices === null)
            throw new Error("The parameter 'writePrices' cannot be null.");
        else if (writePrices !== undefined)
            url_ += "WritePrices=" + encodeURIComponent("" + writePrices) + "&";
        if (writeLongTexts === null)
            throw new Error("The parameter 'writeLongTexts' cannot be null.");
        else if (writeLongTexts !== undefined)
            url_ += "WriteLongTexts=" + encodeURIComponent("" + writeLongTexts) + "&";
        if (conversionCulture !== undefined && conversionCulture !== null)
            url_ += "ConversionCulture=" + encodeURIComponent("" + conversionCulture) + "&";
        if (includeArticleNumbers === null)
            throw new Error("The parameter 'includeArticleNumbers' cannot be null.");
        else if (includeArticleNumbers !== undefined)
            url_ += "IncludeArticleNumbers=" + encodeURIComponent("" + includeArticleNumbers) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (aslvFile !== null && aslvFile !== undefined)
            content_.append("aslvFile", aslvFile.data, aslvFile.fileName ? aslvFile.fileName : "aslvFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAslvConversionConvertToExcel(_response);
        });
    }
    processAslvConversionConvertToExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    aslvConversionConvertToOenormWithRequestObject(aslvFile, options) {
        return this.aslvConversionConvertToOenorm(aslvFile, options === null || options === void 0 ? void 0 : options.destinationOenormType, options === null || options === void 0 ? void 0 : options.tryRepairProjectStructure, options === null || options === void 0 ? void 0 : options.skipTryEnforceSchemaCompliantXmlOutput, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts);
    }
    /**
     * Converts Aslv files to Oenorm files
     * @param aslvFile (optional) The input file
     * @param destinationOenormType (optional) Defaults to Lv2015
     * @param tryRepairProjectStructure (optional) Defaults to false. If this is enabled, the converter will try to ensure that the project structure
    can be mapped to Oenorm. It might introduce additional group levels to ensure a compatible target
     * @param skipTryEnforceSchemaCompliantXmlOutput (optional) If this option is enabled, AVACloud will not attempt to force a schema-compliant Xml output for ÖNorm targets that are Xml
    based. By default, AVACloud will try to add required fields, even if no data is present, with sensible defaults. This behavior
    can be disabled with this option.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     */
    aslvConversionConvertToOenorm(aslvFile, destinationOenormType, tryRepairProjectStructure, skipTryEnforceSchemaCompliantXmlOutput, removeUnprintableCharactersFromTexts) {
        let url_ = this.baseUrl + "/conversion/aslv/oenorm?";
        if (destinationOenormType === null)
            throw new Error("The parameter 'destinationOenormType' cannot be null.");
        else if (destinationOenormType !== undefined)
            url_ += "DestinationOenormType=" + encodeURIComponent("" + destinationOenormType) + "&";
        if (tryRepairProjectStructure === null)
            throw new Error("The parameter 'tryRepairProjectStructure' cannot be null.");
        else if (tryRepairProjectStructure !== undefined)
            url_ += "TryRepairProjectStructure=" + encodeURIComponent("" + tryRepairProjectStructure) + "&";
        if (skipTryEnforceSchemaCompliantXmlOutput === null)
            throw new Error("The parameter 'skipTryEnforceSchemaCompliantXmlOutput' cannot be null.");
        else if (skipTryEnforceSchemaCompliantXmlOutput !== undefined)
            url_ += "SkipTryEnforceSchemaCompliantXmlOutput=" + encodeURIComponent("" + skipTryEnforceSchemaCompliantXmlOutput) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (aslvFile !== null && aslvFile !== undefined)
            content_.append("aslvFile", aslvFile.data, aslvFile.fileName ? aslvFile.fileName : "aslvFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAslvConversionConvertToOenorm(_response);
        });
    }
    processAslvConversionConvertToOenorm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.AslvConversionApi = AslvConversionApi;
class AvaConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    avaConversionConvertToAvaWithRequestObject(avaProject, options) {
        return this.avaConversionConvertToAva(avaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts);
    }
    /**
     * Converts Dangl.AVA projects to Dangl.AVA. This is useful when
    you want to generate the calculated properties.
     * @param avaProject The Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     */
    avaConversionConvertToAva(avaProject, tryAutoGenerateItemNumbersAndSchema, removePlainTextLongTexts, removeHtmlLongTexts) {
        let url_ = this.baseUrl + "/conversion/ava/ava?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAvaConversionConvertToAva(_response);
        });
    }
    processAvaConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    avaConversionConvertToFlatAvaWithRequestObject(avaProject, options) {
        return this.avaConversionConvertToFlatAva(avaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema);
    }
    /**
     * Converts Dangl.AVA projects to Dangl.AVA. This is useful when
    you want to generate the calculated properties.
     * @param avaProject The Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     */
    avaConversionConvertToFlatAva(avaProject, tryAutoGenerateItemNumbersAndSchema) {
        let url_ = this.baseUrl + "/conversion/ava/flat-ava?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAvaConversionConvertToFlatAva(_response);
        });
    }
    processAvaConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    avaConversionConvertToGaebWithRequestObject(avaProject, options) {
        return this.avaConversionConvertToGaeb(avaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.destinationGaebType, options === null || options === void 0 ? void 0 : options.targetExchangePhaseTransform, options === null || options === void 0 ? void 0 : options.enforceStrictOfferPhaseLongTextOutput, options === null || options === void 0 ? void 0 : options.exportQuantityDetermination, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts, options === null || options === void 0 ? void 0 : options.forceIncludeDescriptions, options === null || options === void 0 ? void 0 : options.treatNullItemNumberSchemaAsInvalid);
    }
    /**
     * Converts Dangl.AVA projects to GAEB
     * @param avaProject The Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param destinationGaebType (optional) Defaults to GAEB XML V3.2
     * @param targetExchangePhaseTransform (optional) Defaults to none, meaning no transformation will be done. The phases are:
    Base = 81
    CostEstimate = 82
    OfferRequest = 83
    Offer = 84
    SideOffer = 85
    Grant = 86
     * @param enforceStrictOfferPhaseLongTextOutput (optional) Defaults to false. If this is enabled, exported long texts to GAEB XML that use text additions will
    be strictly schema compliant. If this is not enabled, any text that is marked to contain a text addition
    is exported in full to ensure that incorrectly used text additions are still preserved in the export.
     * @param exportQuantityDetermination (optional) Defaults to false. If this is enabled, quantities are exported in detail in GAEB XML targets via the
    'QtyDeterm' (Quantity Determination, or Quantity Take Off) fields. To control this, you can set custom
    quantity calculations in the 'QuantityComponents' property of positions. Please see the entry for
    'Quantity Determination' in the Dangl.AVA HowTo documentation section. Please be advised that enabling
    this might export data that was not intended to be exported, like internal quantity calculation details,
    depending on what data you put in the 'QuantityComponents' property.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     * @param forceIncludeDescriptions (optional) If this is enabled, all description elements like texts and execution descriptions will be output
    to the result. This is mostly only applicable to GAEB exports to phase 84 - Offer, which does
    typically not include descriptions.
     * @param treatNullItemNumberSchemaAsInvalid (optional) When exporting to GAEB, an item number schema is usually required. AVACloud will try to fix invalid item number schemas.
    With this setting, you can also tell AVACloud to treat a null value as invalid. Otherwise, null schemas will simply be ignored
    and not lead to any schema being generated. It is recommended to enable this option, but it is disabled by default for compatibility
    reasons.
     */
    avaConversionConvertToGaeb(avaProject, tryAutoGenerateItemNumbersAndSchema, destinationGaebType, targetExchangePhaseTransform, enforceStrictOfferPhaseLongTextOutput, exportQuantityDetermination, removeUnprintableCharactersFromTexts, forceIncludeDescriptions, treatNullItemNumberSchemaAsInvalid) {
        let url_ = this.baseUrl + "/conversion/ava/gaeb?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (destinationGaebType === null)
            throw new Error("The parameter 'destinationGaebType' cannot be null.");
        else if (destinationGaebType !== undefined)
            url_ += "DestinationGaebType=" + encodeURIComponent("" + destinationGaebType) + "&";
        if (targetExchangePhaseTransform === null)
            throw new Error("The parameter 'targetExchangePhaseTransform' cannot be null.");
        else if (targetExchangePhaseTransform !== undefined)
            url_ += "TargetExchangePhaseTransform=" + encodeURIComponent("" + targetExchangePhaseTransform) + "&";
        if (enforceStrictOfferPhaseLongTextOutput === null)
            throw new Error("The parameter 'enforceStrictOfferPhaseLongTextOutput' cannot be null.");
        else if (enforceStrictOfferPhaseLongTextOutput !== undefined)
            url_ += "EnforceStrictOfferPhaseLongTextOutput=" + encodeURIComponent("" + enforceStrictOfferPhaseLongTextOutput) + "&";
        if (exportQuantityDetermination === null)
            throw new Error("The parameter 'exportQuantityDetermination' cannot be null.");
        else if (exportQuantityDetermination !== undefined)
            url_ += "ExportQuantityDetermination=" + encodeURIComponent("" + exportQuantityDetermination) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        if (forceIncludeDescriptions === null)
            throw new Error("The parameter 'forceIncludeDescriptions' cannot be null.");
        else if (forceIncludeDescriptions !== undefined)
            url_ += "ForceIncludeDescriptions=" + encodeURIComponent("" + forceIncludeDescriptions) + "&";
        if (treatNullItemNumberSchemaAsInvalid === null)
            throw new Error("The parameter 'treatNullItemNumberSchemaAsInvalid' cannot be null.");
        else if (treatNullItemNumberSchemaAsInvalid !== undefined)
            url_ += "TreatNullItemNumberSchemaAsInvalid=" + encodeURIComponent("" + treatNullItemNumberSchemaAsInvalid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAvaConversionConvertToGaeb(_response);
        });
    }
    processAvaConversionConvertToGaeb(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    avaConversionConvertToExcelWithRequestObject(avaProject, options) {
        return this.avaConversionConvertToExcel(avaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.writePrices, options === null || options === void 0 ? void 0 : options.writeLongTexts, options === null || options === void 0 ? void 0 : options.conversionCulture, options === null || options === void 0 ? void 0 : options.includeArticleNumbers);
    }
    /**
     * Converts Dangl.AVA projects to Excel
     * @param avaProject The Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param writePrices (optional) Defaults to true
     * @param writeLongTexts (optional) Defaults to true
     * @param conversionCulture (optional) The culture that should be used for the conversion process, to have
    localized Excel files
     * @param includeArticleNumbers (optional) If this is enabled, then a new column will be created in the overview worksheet
    that contains the article numbers for positions. Article numbers will be read from
    'position.commerceProperties.articleNumber'
     */
    avaConversionConvertToExcel(avaProject, tryAutoGenerateItemNumbersAndSchema, writePrices, writeLongTexts, conversionCulture, includeArticleNumbers) {
        let url_ = this.baseUrl + "/conversion/ava/excel?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (writePrices === null)
            throw new Error("The parameter 'writePrices' cannot be null.");
        else if (writePrices !== undefined)
            url_ += "WritePrices=" + encodeURIComponent("" + writePrices) + "&";
        if (writeLongTexts === null)
            throw new Error("The parameter 'writeLongTexts' cannot be null.");
        else if (writeLongTexts !== undefined)
            url_ += "WriteLongTexts=" + encodeURIComponent("" + writeLongTexts) + "&";
        if (conversionCulture !== undefined && conversionCulture !== null)
            url_ += "ConversionCulture=" + encodeURIComponent("" + conversionCulture) + "&";
        if (includeArticleNumbers === null)
            throw new Error("The parameter 'includeArticleNumbers' cannot be null.");
        else if (includeArticleNumbers !== undefined)
            url_ += "IncludeArticleNumbers=" + encodeURIComponent("" + includeArticleNumbers) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAvaConversionConvertToExcel(_response);
        });
    }
    processAvaConversionConvertToExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    avaConversionConvertToRebWithRequestObject(avaProject, options) {
        return this.avaConversionConvertToReb(avaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.destinationRebType, options === null || options === void 0 ? void 0 : options.lastRowAddress);
    }
    /**
     * Converts Dangl.AVA projects to REB
     * @param avaProject The Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param destinationRebType (optional) Defaults to D11
     * @param lastRowAddress (optional) If this is present, the export to REB will be started from the next available row address after the given one. This must be
    a valid 6 character address, e.g. "1234A0"
     */
    avaConversionConvertToReb(avaProject, tryAutoGenerateItemNumbersAndSchema, destinationRebType, lastRowAddress) {
        let url_ = this.baseUrl + "/conversion/ava/reb?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (destinationRebType === null)
            throw new Error("The parameter 'destinationRebType' cannot be null.");
        else if (destinationRebType !== undefined)
            url_ += "DestinationRebType=" + encodeURIComponent("" + destinationRebType) + "&";
        if (lastRowAddress !== undefined && lastRowAddress !== null)
            url_ += "LastRowAddress=" + encodeURIComponent("" + lastRowAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAvaConversionConvertToReb(_response);
        });
    }
    processAvaConversionConvertToReb(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    avaConversionConvertToOenormWithRequestObject(avaProject, options) {
        return this.avaConversionConvertToOenorm(avaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.destinationOenormType, options === null || options === void 0 ? void 0 : options.tryRepairProjectStructure, options === null || options === void 0 ? void 0 : options.skipTryEnforceSchemaCompliantXmlOutput, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts);
    }
    /**
     * Converts Dangl.AVA projects to Oenorm
     * @param avaProject The Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param destinationOenormType (optional) Defaults to Lv2015
     * @param tryRepairProjectStructure (optional) Defaults to false. If this is enabled, the converter will try to ensure that the project structure
    can be mapped to Oenorm. It might introduce additional group levels to ensure a compatible target
     * @param skipTryEnforceSchemaCompliantXmlOutput (optional) If this option is enabled, AVACloud will not attempt to force a schema-compliant Xml output for ÖNorm targets that are Xml
    based. By default, AVACloud will try to add required fields, even if no data is present, with sensible defaults. This behavior
    can be disabled with this option.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     */
    avaConversionConvertToOenorm(avaProject, tryAutoGenerateItemNumbersAndSchema, destinationOenormType, tryRepairProjectStructure, skipTryEnforceSchemaCompliantXmlOutput, removeUnprintableCharactersFromTexts) {
        let url_ = this.baseUrl + "/conversion/ava/oenorm?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (destinationOenormType === null)
            throw new Error("The parameter 'destinationOenormType' cannot be null.");
        else if (destinationOenormType !== undefined)
            url_ += "DestinationOenormType=" + encodeURIComponent("" + destinationOenormType) + "&";
        if (tryRepairProjectStructure === null)
            throw new Error("The parameter 'tryRepairProjectStructure' cannot be null.");
        else if (tryRepairProjectStructure !== undefined)
            url_ += "TryRepairProjectStructure=" + encodeURIComponent("" + tryRepairProjectStructure) + "&";
        if (skipTryEnforceSchemaCompliantXmlOutput === null)
            throw new Error("The parameter 'skipTryEnforceSchemaCompliantXmlOutput' cannot be null.");
        else if (skipTryEnforceSchemaCompliantXmlOutput !== undefined)
            url_ += "SkipTryEnforceSchemaCompliantXmlOutput=" + encodeURIComponent("" + skipTryEnforceSchemaCompliantXmlOutput) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAvaConversionConvertToOenorm(_response);
        });
    }
    processAvaConversionConvertToOenorm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    avaConversionConvertToSiaWithRequestObject(avaProject, options) {
        return this.avaConversionConvertToSia(avaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.siaDestinationType);
    }
    /**
     * Converts Dangl.AVA projects to SIA 451
     * @param avaProject The Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param siaDestinationType (optional) Defaults to Sia451
     */
    avaConversionConvertToSia(avaProject, tryAutoGenerateItemNumbersAndSchema, siaDestinationType) {
        let url_ = this.baseUrl + "/conversion/ava/sia?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (siaDestinationType === null)
            throw new Error("The parameter 'siaDestinationType' cannot be null.");
        else if (siaDestinationType !== undefined)
            url_ += "SiaDestinationType=" + encodeURIComponent("" + siaDestinationType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAvaConversionConvertToSia(_response);
        });
    }
    processAvaConversionConvertToSia(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    avaConversionConvertToDatanormWithRequestObject(avaProject, options) {
        return this.avaConversionConvertToDatanorm(avaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.datanormDestinationVersion);
    }
    /**
     * Converts Dangl.AVA projects to Datanorm
     * @param avaProject The Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param datanormDestinationVersion (optional) The Datanorm version to convert to. Defaults to V4.
     */
    avaConversionConvertToDatanorm(avaProject, tryAutoGenerateItemNumbersAndSchema, datanormDestinationVersion) {
        let url_ = this.baseUrl + "/conversion/ava/datanorm?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (datanormDestinationVersion === null)
            throw new Error("The parameter 'datanormDestinationVersion' cannot be null.");
        else if (datanormDestinationVersion !== undefined)
            url_ += "DatanormDestinationVersion=" + encodeURIComponent("" + datanormDestinationVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAvaConversionConvertToDatanorm(_response);
        });
    }
    processAvaConversionConvertToDatanorm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    avaConversionConvertToUglWithRequestObject(avaProject, options) {
        return this.avaConversionConvertToUgl(avaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.uglDestinationVersion);
    }
    /**
     * Converts Dangl.AVA projects to UGL
     * @param avaProject The Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param uglDestinationVersion (optional) The UGL version to convert to. Defaults to V1.
     */
    avaConversionConvertToUgl(avaProject, tryAutoGenerateItemNumbersAndSchema, uglDestinationVersion) {
        let url_ = this.baseUrl + "/conversion/ava/ugl?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (uglDestinationVersion === null)
            throw new Error("The parameter 'uglDestinationVersion' cannot be null.");
        else if (uglDestinationVersion !== undefined)
            url_ += "UglDestinationVersion=" + encodeURIComponent("" + uglDestinationVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAvaConversionConvertToUgl(_response);
        });
    }
    processAvaConversionConvertToUgl(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    avaConversionConvertToIdsConnectWithRequestObject(avaProject, options) {
        return this.avaConversionConvertToIdsConnect(avaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.version);
    }
    /**
     * Converts Dangl.AVA projects to IDS Connect files
     * @param avaProject The Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param version (optional) The IDS Connect version to convert to. Defaults to V2_5.
     */
    avaConversionConvertToIdsConnect(avaProject, tryAutoGenerateItemNumbersAndSchema, version) {
        let url_ = this.baseUrl + "/conversion/ava/ids-connect?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "Version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processAvaConversionConvertToIdsConnect(_response);
        });
    }
    processAvaConversionConvertToIdsConnect(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.AvaConversionApi = AvaConversionApi;
class DatanormConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    datanormConversionConvertToAvaWithRequestObject(datanormFile, options) {
        return this.datanormConversionConvertToAva(datanormFile, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts);
    }
    /**
     * Converts Datanorm files to Dangl.AVA projects
     * @param datanormFile (optional) The input file
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     */
    datanormConversionConvertToAva(datanormFile, removePlainTextLongTexts, removeHtmlLongTexts) {
        let url_ = this.baseUrl + "/conversion/datanorm/ava?";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (datanormFile !== null && datanormFile !== undefined)
            content_.append("datanormFile", datanormFile.data, datanormFile.fileName ? datanormFile.fileName : "datanormFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDatanormConversionConvertToAva(_response);
        });
    }
    processDatanormConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * Converts Datanorm files to Dangl.AVA projects
     * @param datanormFile (optional) The input file
     */
    datanormConversionConvertToFlatAva(datanormFile) {
        let url_ = this.baseUrl + "/conversion/datanorm/flat-ava";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (datanormFile !== null && datanormFile !== undefined)
            content_.append("datanormFile", datanormFile.data, datanormFile.fileName ? datanormFile.fileName : "datanormFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDatanormConversionConvertToFlatAva(_response);
        });
    }
    processDatanormConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.DatanormConversionApi = DatanormConversionApi;
class ExcelConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    excelConversionConvertToAvaWithRequestObject(excelFile, options) {
        return this.excelConversionConvertToAva(excelFile, options === null || options === void 0 ? void 0 : options.readNewElements, options === null || options === void 0 ? void 0 : options.rebuildItemNumberSchema, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts);
    }
    /**
     * Converts Excel files to Dangl.AVA projects.
     * @param excelFile (optional) The input file
     * @param readNewElements (optional) Defaults to false
     * @param rebuildItemNumberSchema (optional) When importing new elements from Excel, sometimes the ItemNumberSchema in the file
    is not in compliance with the GAEB requirements. Enabling this option tries to repair
    the ItemNumberSchema. Defaults to false.
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     */
    excelConversionConvertToAva(excelFile, readNewElements, rebuildItemNumberSchema, removePlainTextLongTexts, removeHtmlLongTexts) {
        let url_ = this.baseUrl + "/conversion/excel/ava?";
        if (readNewElements === null)
            throw new Error("The parameter 'readNewElements' cannot be null.");
        else if (readNewElements !== undefined)
            url_ += "ReadNewElements=" + encodeURIComponent("" + readNewElements) + "&";
        if (rebuildItemNumberSchema === null)
            throw new Error("The parameter 'rebuildItemNumberSchema' cannot be null.");
        else if (rebuildItemNumberSchema !== undefined)
            url_ += "RebuildItemNumberSchema=" + encodeURIComponent("" + rebuildItemNumberSchema) + "&";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processExcelConversionConvertToAva(_response);
        });
    }
    processExcelConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    excelConversionConvertToFlatAvaWithRequestObject(excelFile, options) {
        return this.excelConversionConvertToFlatAva(excelFile, options === null || options === void 0 ? void 0 : options.readNewElements, options === null || options === void 0 ? void 0 : options.rebuildItemNumberSchema);
    }
    /**
     * Converts Excel files to Dangl.AVA projects.
     * @param excelFile (optional) The input file
     * @param readNewElements (optional) Defaults to false
     * @param rebuildItemNumberSchema (optional) When importing new elements from Excel, sometimes the ItemNumberSchema in the file
    is not in compliance with the GAEB requirements. Enabling this option tries to repair
    the ItemNumberSchema. Defaults to false.
     */
    excelConversionConvertToFlatAva(excelFile, readNewElements, rebuildItemNumberSchema) {
        let url_ = this.baseUrl + "/conversion/excel/flat-ava?";
        if (readNewElements === null)
            throw new Error("The parameter 'readNewElements' cannot be null.");
        else if (readNewElements !== undefined)
            url_ += "ReadNewElements=" + encodeURIComponent("" + readNewElements) + "&";
        if (rebuildItemNumberSchema === null)
            throw new Error("The parameter 'rebuildItemNumberSchema' cannot be null.");
        else if (rebuildItemNumberSchema !== undefined)
            url_ += "RebuildItemNumberSchema=" + encodeURIComponent("" + rebuildItemNumberSchema) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processExcelConversionConvertToFlatAva(_response);
        });
    }
    processExcelConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    excelConversionConvertToGaebWithRequestObject(excelFile, options) {
        return this.excelConversionConvertToGaeb(excelFile, options === null || options === void 0 ? void 0 : options.readNewElements, options === null || options === void 0 ? void 0 : options.rebuildItemNumberSchema, options === null || options === void 0 ? void 0 : options.destinationGaebType, options === null || options === void 0 ? void 0 : options.targetExchangePhaseTransform, options === null || options === void 0 ? void 0 : options.enforceStrictOfferPhaseLongTextOutput, options === null || options === void 0 ? void 0 : options.exportQuantityDetermination, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts, options === null || options === void 0 ? void 0 : options.forceIncludeDescriptions, options === null || options === void 0 ? void 0 : options.treatNullItemNumberSchemaAsInvalid);
    }
    /**
     * Converts Excel files to GAEB files.
     * @param excelFile (optional) The input file
     * @param readNewElements (optional) Defaults to false
     * @param rebuildItemNumberSchema (optional) When importing new elements from Excel, sometimes the ItemNumberSchema in the file
    is not in compliance with the GAEB requirements. Enabling this option tries to repair
    the ItemNumberSchema. Defaults to false.
     * @param destinationGaebType (optional) Defaults to GAEB XML V3.2
     * @param targetExchangePhaseTransform (optional) Defaults to none, meaning no transformation will be done. The phases are:
    Base = 81
    CostEstimate = 82
    OfferRequest = 83
    Offer = 84
    SideOffer = 85
    Grant = 86
     * @param enforceStrictOfferPhaseLongTextOutput (optional) Defaults to false. If this is enabled, exported long texts to GAEB XML that use text additions will
    be strictly schema compliant. If this is not enabled, any text that is marked to contain a text addition
    is exported in full to ensure that incorrectly used text additions are still preserved in the export.
     * @param exportQuantityDetermination (optional) Defaults to false. If this is enabled, quantities are exported in detail in GAEB XML targets via the
    'QtyDeterm' (Quantity Determination, or Quantity Take Off) fields. To control this, you can set custom
    quantity calculations in the 'QuantityComponents' property of positions. Please see the entry for
    'Quantity Determination' in the Dangl.AVA HowTo documentation section. Please be advised that enabling
    this might export data that was not intended to be exported, like internal quantity calculation details,
    depending on what data you put in the 'QuantityComponents' property.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     * @param forceIncludeDescriptions (optional) If this is enabled, all description elements like texts and execution descriptions will be output
    to the result. This is mostly only applicable to GAEB exports to phase 84 - Offer, which does
    typically not include descriptions.
     * @param treatNullItemNumberSchemaAsInvalid (optional) When exporting to GAEB, an item number schema is usually required. AVACloud will try to fix invalid item number schemas.
    With this setting, you can also tell AVACloud to treat a null value as invalid. Otherwise, null schemas will simply be ignored
    and not lead to any schema being generated. It is recommended to enable this option, but it is disabled by default for compatibility
    reasons.
     */
    excelConversionConvertToGaeb(excelFile, readNewElements, rebuildItemNumberSchema, destinationGaebType, targetExchangePhaseTransform, enforceStrictOfferPhaseLongTextOutput, exportQuantityDetermination, removeUnprintableCharactersFromTexts, forceIncludeDescriptions, treatNullItemNumberSchemaAsInvalid) {
        let url_ = this.baseUrl + "/conversion/excel/gaeb?";
        if (readNewElements === null)
            throw new Error("The parameter 'readNewElements' cannot be null.");
        else if (readNewElements !== undefined)
            url_ += "ReadNewElements=" + encodeURIComponent("" + readNewElements) + "&";
        if (rebuildItemNumberSchema === null)
            throw new Error("The parameter 'rebuildItemNumberSchema' cannot be null.");
        else if (rebuildItemNumberSchema !== undefined)
            url_ += "RebuildItemNumberSchema=" + encodeURIComponent("" + rebuildItemNumberSchema) + "&";
        if (destinationGaebType === null)
            throw new Error("The parameter 'destinationGaebType' cannot be null.");
        else if (destinationGaebType !== undefined)
            url_ += "DestinationGaebType=" + encodeURIComponent("" + destinationGaebType) + "&";
        if (targetExchangePhaseTransform === null)
            throw new Error("The parameter 'targetExchangePhaseTransform' cannot be null.");
        else if (targetExchangePhaseTransform !== undefined)
            url_ += "TargetExchangePhaseTransform=" + encodeURIComponent("" + targetExchangePhaseTransform) + "&";
        if (enforceStrictOfferPhaseLongTextOutput === null)
            throw new Error("The parameter 'enforceStrictOfferPhaseLongTextOutput' cannot be null.");
        else if (enforceStrictOfferPhaseLongTextOutput !== undefined)
            url_ += "EnforceStrictOfferPhaseLongTextOutput=" + encodeURIComponent("" + enforceStrictOfferPhaseLongTextOutput) + "&";
        if (exportQuantityDetermination === null)
            throw new Error("The parameter 'exportQuantityDetermination' cannot be null.");
        else if (exportQuantityDetermination !== undefined)
            url_ += "ExportQuantityDetermination=" + encodeURIComponent("" + exportQuantityDetermination) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        if (forceIncludeDescriptions === null)
            throw new Error("The parameter 'forceIncludeDescriptions' cannot be null.");
        else if (forceIncludeDescriptions !== undefined)
            url_ += "ForceIncludeDescriptions=" + encodeURIComponent("" + forceIncludeDescriptions) + "&";
        if (treatNullItemNumberSchemaAsInvalid === null)
            throw new Error("The parameter 'treatNullItemNumberSchemaAsInvalid' cannot be null.");
        else if (treatNullItemNumberSchemaAsInvalid !== undefined)
            url_ += "TreatNullItemNumberSchemaAsInvalid=" + encodeURIComponent("" + treatNullItemNumberSchemaAsInvalid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processExcelConversionConvertToGaeb(_response);
        });
    }
    processExcelConversionConvertToGaeb(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    excelConversionConvertToExcelWithRequestObject(excelFile, options) {
        return this.excelConversionConvertToExcel(excelFile, options === null || options === void 0 ? void 0 : options.readNewElements, options === null || options === void 0 ? void 0 : options.rebuildItemNumberSchema, options === null || options === void 0 ? void 0 : options.writePrices, options === null || options === void 0 ? void 0 : options.writeLongTexts, options === null || options === void 0 ? void 0 : options.conversionCulture, options === null || options === void 0 ? void 0 : options.includeArticleNumbers);
    }
    /**
     * Converts Excel files to Excel files. Used, for example, when elements
    were added in excel to generate or modify a project. The Excel file can then
    be shared containing the full project with all formattings, formulas and styles applied.
     * @param excelFile (optional) The input file
     * @param readNewElements (optional) Defaults to false
     * @param rebuildItemNumberSchema (optional) When importing new elements from Excel, sometimes the ItemNumberSchema in the file
    is not in compliance with the GAEB requirements. Enabling this option tries to repair
    the ItemNumberSchema. Defaults to false.
     * @param writePrices (optional) Defaults to true
     * @param writeLongTexts (optional) Defaults to true
     * @param conversionCulture (optional) The culture that should be used for the conversion process, to have
    localized Excel files
     * @param includeArticleNumbers (optional) If this is enabled, then a new column will be created in the overview worksheet
    that contains the article numbers for positions. Article numbers will be read from
    'position.commerceProperties.articleNumber'
     */
    excelConversionConvertToExcel(excelFile, readNewElements, rebuildItemNumberSchema, writePrices, writeLongTexts, conversionCulture, includeArticleNumbers) {
        let url_ = this.baseUrl + "/conversion/excel/excel?";
        if (readNewElements === null)
            throw new Error("The parameter 'readNewElements' cannot be null.");
        else if (readNewElements !== undefined)
            url_ += "ReadNewElements=" + encodeURIComponent("" + readNewElements) + "&";
        if (rebuildItemNumberSchema === null)
            throw new Error("The parameter 'rebuildItemNumberSchema' cannot be null.");
        else if (rebuildItemNumberSchema !== undefined)
            url_ += "RebuildItemNumberSchema=" + encodeURIComponent("" + rebuildItemNumberSchema) + "&";
        if (writePrices === null)
            throw new Error("The parameter 'writePrices' cannot be null.");
        else if (writePrices !== undefined)
            url_ += "WritePrices=" + encodeURIComponent("" + writePrices) + "&";
        if (writeLongTexts === null)
            throw new Error("The parameter 'writeLongTexts' cannot be null.");
        else if (writeLongTexts !== undefined)
            url_ += "WriteLongTexts=" + encodeURIComponent("" + writeLongTexts) + "&";
        if (conversionCulture !== undefined && conversionCulture !== null)
            url_ += "ConversionCulture=" + encodeURIComponent("" + conversionCulture) + "&";
        if (includeArticleNumbers === null)
            throw new Error("The parameter 'includeArticleNumbers' cannot be null.");
        else if (includeArticleNumbers !== undefined)
            url_ += "IncludeArticleNumbers=" + encodeURIComponent("" + includeArticleNumbers) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processExcelConversionConvertToExcel(_response);
        });
    }
    processExcelConversionConvertToExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    excelConversionConvertToOenormWithRequestObject(excelFile, options) {
        return this.excelConversionConvertToOenorm(excelFile, options === null || options === void 0 ? void 0 : options.readNewElements, options === null || options === void 0 ? void 0 : options.rebuildItemNumberSchema, options === null || options === void 0 ? void 0 : options.destinationOenormType, options === null || options === void 0 ? void 0 : options.tryRepairProjectStructure, options === null || options === void 0 ? void 0 : options.skipTryEnforceSchemaCompliantXmlOutput, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts);
    }
    /**
     * Converts Excel files to Oenorm files.
     * @param excelFile (optional) The input file
     * @param readNewElements (optional) Defaults to false
     * @param rebuildItemNumberSchema (optional) When importing new elements from Excel, sometimes the ItemNumberSchema in the file
    is not in compliance with the GAEB requirements. Enabling this option tries to repair
    the ItemNumberSchema. Defaults to false.
     * @param destinationOenormType (optional) Defaults to Lv2015
     * @param tryRepairProjectStructure (optional) Defaults to false. If this is enabled, the converter will try to ensure that the project structure
    can be mapped to Oenorm. It might introduce additional group levels to ensure a compatible target
     * @param skipTryEnforceSchemaCompliantXmlOutput (optional) If this option is enabled, AVACloud will not attempt to force a schema-compliant Xml output for ÖNorm targets that are Xml
    based. By default, AVACloud will try to add required fields, even if no data is present, with sensible defaults. This behavior
    can be disabled with this option.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     */
    excelConversionConvertToOenorm(excelFile, readNewElements, rebuildItemNumberSchema, destinationOenormType, tryRepairProjectStructure, skipTryEnforceSchemaCompliantXmlOutput, removeUnprintableCharactersFromTexts) {
        let url_ = this.baseUrl + "/conversion/excel/oenorm?";
        if (readNewElements === null)
            throw new Error("The parameter 'readNewElements' cannot be null.");
        else if (readNewElements !== undefined)
            url_ += "ReadNewElements=" + encodeURIComponent("" + readNewElements) + "&";
        if (rebuildItemNumberSchema === null)
            throw new Error("The parameter 'rebuildItemNumberSchema' cannot be null.");
        else if (rebuildItemNumberSchema !== undefined)
            url_ += "RebuildItemNumberSchema=" + encodeURIComponent("" + rebuildItemNumberSchema) + "&";
        if (destinationOenormType === null)
            throw new Error("The parameter 'destinationOenormType' cannot be null.");
        else if (destinationOenormType !== undefined)
            url_ += "DestinationOenormType=" + encodeURIComponent("" + destinationOenormType) + "&";
        if (tryRepairProjectStructure === null)
            throw new Error("The parameter 'tryRepairProjectStructure' cannot be null.");
        else if (tryRepairProjectStructure !== undefined)
            url_ += "TryRepairProjectStructure=" + encodeURIComponent("" + tryRepairProjectStructure) + "&";
        if (skipTryEnforceSchemaCompliantXmlOutput === null)
            throw new Error("The parameter 'skipTryEnforceSchemaCompliantXmlOutput' cannot be null.");
        else if (skipTryEnforceSchemaCompliantXmlOutput !== undefined)
            url_ += "SkipTryEnforceSchemaCompliantXmlOutput=" + encodeURIComponent("" + skipTryEnforceSchemaCompliantXmlOutput) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (excelFile !== null && excelFile !== undefined)
            content_.append("excelFile", excelFile.data, excelFile.fileName ? excelFile.fileName : "excelFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processExcelConversionConvertToOenorm(_response);
        });
    }
    processExcelConversionConvertToOenorm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.ExcelConversionApi = ExcelConversionApi;
class FlatAvaConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    flatAvaConversionConvertToAvaWithRequestObject(flatAvaProject, options) {
        return this.flatAvaConversionConvertToAva(flatAvaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts);
    }
    /**
     * Converts flat Dangl.AVA projects to Dangl.AVA. This is useful when
    you want to generate the calculated properties.
     * @param flatAvaProject The flat Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     */
    flatAvaConversionConvertToAva(flatAvaProject, tryAutoGenerateItemNumbersAndSchema, removePlainTextLongTexts, removeHtmlLongTexts) {
        let url_ = this.baseUrl + "/conversion/flat-ava/ava?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(flatAvaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFlatAvaConversionConvertToAva(_response);
        });
    }
    processFlatAvaConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    flatAvaConversionConvertToFlatAvaWithRequestObject(flatAvaProject, options) {
        return this.flatAvaConversionConvertToFlatAva(flatAvaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema);
    }
    /**
     * Converts flat Dangl.AVA projects to Dangl.AVA. This is useful when
    you want to generate the calculated properties.
     * @param flatAvaProject The flat Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     */
    flatAvaConversionConvertToFlatAva(flatAvaProject, tryAutoGenerateItemNumbersAndSchema) {
        let url_ = this.baseUrl + "/conversion/flat-ava/flat-ava?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(flatAvaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFlatAvaConversionConvertToFlatAva(_response);
        });
    }
    processFlatAvaConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    flatAvaConversionConvertToGaebWithRequestObject(flatAvaProject, options) {
        return this.flatAvaConversionConvertToGaeb(flatAvaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.destinationGaebType, options === null || options === void 0 ? void 0 : options.targetExchangePhaseTransform, options === null || options === void 0 ? void 0 : options.enforceStrictOfferPhaseLongTextOutput, options === null || options === void 0 ? void 0 : options.exportQuantityDetermination, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts, options === null || options === void 0 ? void 0 : options.forceIncludeDescriptions, options === null || options === void 0 ? void 0 : options.treatNullItemNumberSchemaAsInvalid);
    }
    /**
     * Converts flat Dangl.AVA projects to GAEB
     * @param flatAvaProject The flat Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param destinationGaebType (optional) Defaults to GAEB XML V3.2
     * @param targetExchangePhaseTransform (optional) Defaults to none, meaning no transformation will be done. The phases are:
    Base = 81
    CostEstimate = 82
    OfferRequest = 83
    Offer = 84
    SideOffer = 85
    Grant = 86
     * @param enforceStrictOfferPhaseLongTextOutput (optional) Defaults to false. If this is enabled, exported long texts to GAEB XML that use text additions will
    be strictly schema compliant. If this is not enabled, any text that is marked to contain a text addition
    is exported in full to ensure that incorrectly used text additions are still preserved in the export.
     * @param exportQuantityDetermination (optional) Defaults to false. If this is enabled, quantities are exported in detail in GAEB XML targets via the
    'QtyDeterm' (Quantity Determination, or Quantity Take Off) fields. To control this, you can set custom
    quantity calculations in the 'QuantityComponents' property of positions. Please see the entry for
    'Quantity Determination' in the Dangl.AVA HowTo documentation section. Please be advised that enabling
    this might export data that was not intended to be exported, like internal quantity calculation details,
    depending on what data you put in the 'QuantityComponents' property.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     * @param forceIncludeDescriptions (optional) If this is enabled, all description elements like texts and execution descriptions will be output
    to the result. This is mostly only applicable to GAEB exports to phase 84 - Offer, which does
    typically not include descriptions.
     * @param treatNullItemNumberSchemaAsInvalid (optional) When exporting to GAEB, an item number schema is usually required. AVACloud will try to fix invalid item number schemas.
    With this setting, you can also tell AVACloud to treat a null value as invalid. Otherwise, null schemas will simply be ignored
    and not lead to any schema being generated. It is recommended to enable this option, but it is disabled by default for compatibility
    reasons.
     */
    flatAvaConversionConvertToGaeb(flatAvaProject, tryAutoGenerateItemNumbersAndSchema, destinationGaebType, targetExchangePhaseTransform, enforceStrictOfferPhaseLongTextOutput, exportQuantityDetermination, removeUnprintableCharactersFromTexts, forceIncludeDescriptions, treatNullItemNumberSchemaAsInvalid) {
        let url_ = this.baseUrl + "/conversion/flat-ava/gaeb?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (destinationGaebType === null)
            throw new Error("The parameter 'destinationGaebType' cannot be null.");
        else if (destinationGaebType !== undefined)
            url_ += "DestinationGaebType=" + encodeURIComponent("" + destinationGaebType) + "&";
        if (targetExchangePhaseTransform === null)
            throw new Error("The parameter 'targetExchangePhaseTransform' cannot be null.");
        else if (targetExchangePhaseTransform !== undefined)
            url_ += "TargetExchangePhaseTransform=" + encodeURIComponent("" + targetExchangePhaseTransform) + "&";
        if (enforceStrictOfferPhaseLongTextOutput === null)
            throw new Error("The parameter 'enforceStrictOfferPhaseLongTextOutput' cannot be null.");
        else if (enforceStrictOfferPhaseLongTextOutput !== undefined)
            url_ += "EnforceStrictOfferPhaseLongTextOutput=" + encodeURIComponent("" + enforceStrictOfferPhaseLongTextOutput) + "&";
        if (exportQuantityDetermination === null)
            throw new Error("The parameter 'exportQuantityDetermination' cannot be null.");
        else if (exportQuantityDetermination !== undefined)
            url_ += "ExportQuantityDetermination=" + encodeURIComponent("" + exportQuantityDetermination) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        if (forceIncludeDescriptions === null)
            throw new Error("The parameter 'forceIncludeDescriptions' cannot be null.");
        else if (forceIncludeDescriptions !== undefined)
            url_ += "ForceIncludeDescriptions=" + encodeURIComponent("" + forceIncludeDescriptions) + "&";
        if (treatNullItemNumberSchemaAsInvalid === null)
            throw new Error("The parameter 'treatNullItemNumberSchemaAsInvalid' cannot be null.");
        else if (treatNullItemNumberSchemaAsInvalid !== undefined)
            url_ += "TreatNullItemNumberSchemaAsInvalid=" + encodeURIComponent("" + treatNullItemNumberSchemaAsInvalid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(flatAvaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFlatAvaConversionConvertToGaeb(_response);
        });
    }
    processFlatAvaConversionConvertToGaeb(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    flatAvaConversionConvertToExcelWithRequestObject(flatAvaProject, options) {
        return this.flatAvaConversionConvertToExcel(flatAvaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.writePrices, options === null || options === void 0 ? void 0 : options.writeLongTexts, options === null || options === void 0 ? void 0 : options.conversionCulture, options === null || options === void 0 ? void 0 : options.includeArticleNumbers);
    }
    /**
     * Converts flat Dangl.AVA projects to Excel
     * @param flatAvaProject The flat Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param writePrices (optional) Defaults to true
     * @param writeLongTexts (optional) Defaults to true
     * @param conversionCulture (optional) The culture that should be used for the conversion process, to have
    localized Excel files
     * @param includeArticleNumbers (optional) If this is enabled, then a new column will be created in the overview worksheet
    that contains the article numbers for positions. Article numbers will be read from
    'position.commerceProperties.articleNumber'
     */
    flatAvaConversionConvertToExcel(flatAvaProject, tryAutoGenerateItemNumbersAndSchema, writePrices, writeLongTexts, conversionCulture, includeArticleNumbers) {
        let url_ = this.baseUrl + "/conversion/flat-ava/excel?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (writePrices === null)
            throw new Error("The parameter 'writePrices' cannot be null.");
        else if (writePrices !== undefined)
            url_ += "WritePrices=" + encodeURIComponent("" + writePrices) + "&";
        if (writeLongTexts === null)
            throw new Error("The parameter 'writeLongTexts' cannot be null.");
        else if (writeLongTexts !== undefined)
            url_ += "WriteLongTexts=" + encodeURIComponent("" + writeLongTexts) + "&";
        if (conversionCulture !== undefined && conversionCulture !== null)
            url_ += "ConversionCulture=" + encodeURIComponent("" + conversionCulture) + "&";
        if (includeArticleNumbers === null)
            throw new Error("The parameter 'includeArticleNumbers' cannot be null.");
        else if (includeArticleNumbers !== undefined)
            url_ += "IncludeArticleNumbers=" + encodeURIComponent("" + includeArticleNumbers) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(flatAvaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFlatAvaConversionConvertToExcel(_response);
        });
    }
    processFlatAvaConversionConvertToExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    flatAvaConversionConvertToRebWithRequestObject(flatAvaProject, options) {
        return this.flatAvaConversionConvertToReb(flatAvaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.destinationRebType, options === null || options === void 0 ? void 0 : options.lastRowAddress);
    }
    /**
     * Converts flat Dangl.AVA projects to REB
     * @param flatAvaProject The flat Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param destinationRebType (optional) Defaults to D11
     * @param lastRowAddress (optional) If this is present, the export to REB will be started from the next available row address after the given one. This must be
    a valid 6 character address, e.g. "1234A0"
     */
    flatAvaConversionConvertToReb(flatAvaProject, tryAutoGenerateItemNumbersAndSchema, destinationRebType, lastRowAddress) {
        let url_ = this.baseUrl + "/conversion/flat-ava/reb?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (destinationRebType === null)
            throw new Error("The parameter 'destinationRebType' cannot be null.");
        else if (destinationRebType !== undefined)
            url_ += "DestinationRebType=" + encodeURIComponent("" + destinationRebType) + "&";
        if (lastRowAddress !== undefined && lastRowAddress !== null)
            url_ += "LastRowAddress=" + encodeURIComponent("" + lastRowAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(flatAvaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFlatAvaConversionConvertToReb(_response);
        });
    }
    processFlatAvaConversionConvertToReb(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    flatAvaConversionConvertToOenormWithRequestObject(flatAvaProject, options) {
        return this.flatAvaConversionConvertToOenorm(flatAvaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.destinationOenormType, options === null || options === void 0 ? void 0 : options.tryRepairProjectStructure, options === null || options === void 0 ? void 0 : options.skipTryEnforceSchemaCompliantXmlOutput, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts);
    }
    /**
     * Converts flat Dangl.AVA projects to Oenorm
     * @param flatAvaProject The flat Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param destinationOenormType (optional) Defaults to Lv2015
     * @param tryRepairProjectStructure (optional) Defaults to false. If this is enabled, the converter will try to ensure that the project structure
    can be mapped to Oenorm. It might introduce additional group levels to ensure a compatible target
     * @param skipTryEnforceSchemaCompliantXmlOutput (optional) If this option is enabled, AVACloud will not attempt to force a schema-compliant Xml output for ÖNorm targets that are Xml
    based. By default, AVACloud will try to add required fields, even if no data is present, with sensible defaults. This behavior
    can be disabled with this option.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     */
    flatAvaConversionConvertToOenorm(flatAvaProject, tryAutoGenerateItemNumbersAndSchema, destinationOenormType, tryRepairProjectStructure, skipTryEnforceSchemaCompliantXmlOutput, removeUnprintableCharactersFromTexts) {
        let url_ = this.baseUrl + "/conversion/flat-ava/oenorm?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (destinationOenormType === null)
            throw new Error("The parameter 'destinationOenormType' cannot be null.");
        else if (destinationOenormType !== undefined)
            url_ += "DestinationOenormType=" + encodeURIComponent("" + destinationOenormType) + "&";
        if (tryRepairProjectStructure === null)
            throw new Error("The parameter 'tryRepairProjectStructure' cannot be null.");
        else if (tryRepairProjectStructure !== undefined)
            url_ += "TryRepairProjectStructure=" + encodeURIComponent("" + tryRepairProjectStructure) + "&";
        if (skipTryEnforceSchemaCompliantXmlOutput === null)
            throw new Error("The parameter 'skipTryEnforceSchemaCompliantXmlOutput' cannot be null.");
        else if (skipTryEnforceSchemaCompliantXmlOutput !== undefined)
            url_ += "SkipTryEnforceSchemaCompliantXmlOutput=" + encodeURIComponent("" + skipTryEnforceSchemaCompliantXmlOutput) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(flatAvaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFlatAvaConversionConvertToOenorm(_response);
        });
    }
    processFlatAvaConversionConvertToOenorm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    flatAvaConversionConvertToSiaWithRequestObject(flatAvaProject, options) {
        return this.flatAvaConversionConvertToSia(flatAvaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.siaDestinationType);
    }
    /**
     * Converts flat Dangl.AVA projects to SIA 451
     * @param flatAvaProject The flat Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param siaDestinationType (optional) Defaults to Sia451
     */
    flatAvaConversionConvertToSia(flatAvaProject, tryAutoGenerateItemNumbersAndSchema, siaDestinationType) {
        let url_ = this.baseUrl + "/conversion/flat-ava/sia?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (siaDestinationType === null)
            throw new Error("The parameter 'siaDestinationType' cannot be null.");
        else if (siaDestinationType !== undefined)
            url_ += "SiaDestinationType=" + encodeURIComponent("" + siaDestinationType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(flatAvaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFlatAvaConversionConvertToSia(_response);
        });
    }
    processFlatAvaConversionConvertToSia(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    flatAvaConversionConvertToDatanormWithRequestObject(flatAvaProject, options) {
        return this.flatAvaConversionConvertToDatanorm(flatAvaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.datanormDestinationVersion);
    }
    /**
     * Converts flat Dangl.AVA projects to Datanorm
     * @param flatAvaProject The flat Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param datanormDestinationVersion (optional) The Datanorm version to convert to. Defaults to V4.
     */
    flatAvaConversionConvertToDatanorm(flatAvaProject, tryAutoGenerateItemNumbersAndSchema, datanormDestinationVersion) {
        let url_ = this.baseUrl + "/conversion/flat-ava/datanorm?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (datanormDestinationVersion === null)
            throw new Error("The parameter 'datanormDestinationVersion' cannot be null.");
        else if (datanormDestinationVersion !== undefined)
            url_ += "DatanormDestinationVersion=" + encodeURIComponent("" + datanormDestinationVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(flatAvaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFlatAvaConversionConvertToDatanorm(_response);
        });
    }
    processFlatAvaConversionConvertToDatanorm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    flatAvaConversionConvertToUglWithRequestObject(flatAvaProject, options) {
        return this.flatAvaConversionConvertToUgl(flatAvaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.uglDestinationVersion);
    }
    /**
     * Converts flat Dangl.AVA projects to UGL
     * @param flatAvaProject The flat Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param uglDestinationVersion (optional) The UGL version to convert to. Defaults to V1.
     */
    flatAvaConversionConvertToUgl(flatAvaProject, tryAutoGenerateItemNumbersAndSchema, uglDestinationVersion) {
        let url_ = this.baseUrl + "/conversion/flat-ava/ugl?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (uglDestinationVersion === null)
            throw new Error("The parameter 'uglDestinationVersion' cannot be null.");
        else if (uglDestinationVersion !== undefined)
            url_ += "UglDestinationVersion=" + encodeURIComponent("" + uglDestinationVersion) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(flatAvaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFlatAvaConversionConvertToUgl(_response);
        });
    }
    processFlatAvaConversionConvertToUgl(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    flatAvaConversionConvertToIdsConnectWithRequestObject(flatAvaProject, options) {
        return this.flatAvaConversionConvertToIdsConnect(flatAvaProject, options === null || options === void 0 ? void 0 : options.tryAutoGenerateItemNumbersAndSchema, options === null || options === void 0 ? void 0 : options.version);
    }
    /**
     * Converts flat Dangl.AVA projects to IDS Connect files
     * @param flatAvaProject The flat Dangl.AVA project
     * @param tryAutoGenerateItemNumbersAndSchema (optional) If this is set to true, AVACloud will try to generate item numbers
    and an item number schema automatically for the input project.
    The operation will not have any effect if either an item number schema
    is already present, or if any of the elements already has an item number.
     * @param version (optional) The IDS Connect version to convert to. Defaults to V2_5.
     */
    flatAvaConversionConvertToIdsConnect(flatAvaProject, tryAutoGenerateItemNumbersAndSchema, version) {
        let url_ = this.baseUrl + "/conversion/flat-ava/ids-connect?";
        if (tryAutoGenerateItemNumbersAndSchema === null)
            throw new Error("The parameter 'tryAutoGenerateItemNumbersAndSchema' cannot be null.");
        else if (tryAutoGenerateItemNumbersAndSchema !== undefined)
            url_ += "TryAutoGenerateItemNumbersAndSchema=" + encodeURIComponent("" + tryAutoGenerateItemNumbersAndSchema) + "&";
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "Version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(flatAvaProject);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processFlatAvaConversionConvertToIdsConnect(_response);
        });
    }
    processFlatAvaConversionConvertToIdsConnect(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.FlatAvaConversionApi = FlatAvaConversionApi;
class GaebConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    gaebConversionConvertToAvaWithRequestObject(gaebFile, options) {
        return this.gaebConversionConvertToAva(gaebFile, options === null || options === void 0 ? void 0 : options.supportSkippedItemNumberLevelsInPositions, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts, options === null || options === void 0 ? void 0 : options.outputHtmlAsXml, options === null || options === void 0 ? void 0 : options.keepEmptyHtmlText, options === null || options === void 0 ? void 0 : options.allowUpperCaseItemNumbers, options === null || options === void 0 ? void 0 : options.allowLumpSumItemsWithDifferingQuantities);
    }
    /**
     * Converts GAEB files to Dangl.AVA projects
     * @param gaebFile (optional) The input file
     * @param supportSkippedItemNumberLevelsInPositions (optional) Defaults to 'false'. This controls if, when deserializing GAEB files, skipped levels in position
    item numbers should be supported. For example, if an ItemNumberSchema defines three levels - two group
    levels and one position level - but the ItemNumber of the position is just '01.02', then it will be
    displayed as '01.__.02' if this is set to true.
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     * @param outputHtmlAsXml (optional) Defaults to 'false'. If this is enabled, then Html text will be output as XML in the output.
    This means that e.g. void Html tags will always be output with their closing tag, e.g.
    it will produce '<br />' instead of '<br>'.
     * @param keepEmptyHtmlText (optional) Defaults to 'false'. If this is enabled, then Html text that is empty will be kept in the output.
    Otherwise, Html text without any plain text will be removed. This is useful for example if you want
    to keep texts that only consist of empty paragraphs in the output.
     * @param allowUpperCaseItemNumbers (optional) Defaults to 'false'. If this is enabled, then the ItemNumber of positions will be in uppercase
    format if the source file has them. By default, all item numbers will be converted to lowercase,
    but this option will enable the option to support uppercase item numbers as well.
     * @param allowLumpSumItemsWithDifferingQuantities (optional) Defaults to 'false'.
    By default, the GAEB standard requires lump sum items ('Pauschalpositionen' in German) to have a quantity
    of exactly 1. AVACloud does enforce this convention, but if you set this property to 'true', then
    differing quantities will be kept during the import.
     */
    gaebConversionConvertToAva(gaebFile, supportSkippedItemNumberLevelsInPositions, removePlainTextLongTexts, removeHtmlLongTexts, outputHtmlAsXml, keepEmptyHtmlText, allowUpperCaseItemNumbers, allowLumpSumItemsWithDifferingQuantities) {
        let url_ = this.baseUrl + "/conversion/gaeb/ava?";
        if (supportSkippedItemNumberLevelsInPositions === null)
            throw new Error("The parameter 'supportSkippedItemNumberLevelsInPositions' cannot be null.");
        else if (supportSkippedItemNumberLevelsInPositions !== undefined)
            url_ += "SupportSkippedItemNumberLevelsInPositions=" + encodeURIComponent("" + supportSkippedItemNumberLevelsInPositions) + "&";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        if (outputHtmlAsXml === null)
            throw new Error("The parameter 'outputHtmlAsXml' cannot be null.");
        else if (outputHtmlAsXml !== undefined)
            url_ += "OutputHtmlAsXml=" + encodeURIComponent("" + outputHtmlAsXml) + "&";
        if (keepEmptyHtmlText === null)
            throw new Error("The parameter 'keepEmptyHtmlText' cannot be null.");
        else if (keepEmptyHtmlText !== undefined)
            url_ += "KeepEmptyHtmlText=" + encodeURIComponent("" + keepEmptyHtmlText) + "&";
        if (allowUpperCaseItemNumbers === null)
            throw new Error("The parameter 'allowUpperCaseItemNumbers' cannot be null.");
        else if (allowUpperCaseItemNumbers !== undefined)
            url_ += "AllowUpperCaseItemNumbers=" + encodeURIComponent("" + allowUpperCaseItemNumbers) + "&";
        if (allowLumpSumItemsWithDifferingQuantities === null)
            throw new Error("The parameter 'allowLumpSumItemsWithDifferingQuantities' cannot be null.");
        else if (allowLumpSumItemsWithDifferingQuantities !== undefined)
            url_ += "AllowLumpSumItemsWithDifferingQuantities=" + encodeURIComponent("" + allowLumpSumItemsWithDifferingQuantities) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (gaebFile !== null && gaebFile !== undefined)
            content_.append("gaebFile", gaebFile.data, gaebFile.fileName ? gaebFile.fileName : "gaebFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGaebConversionConvertToAva(_response);
        });
    }
    processGaebConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    gaebConversionConvertToFlatAvaWithRequestObject(gaebFile, options) {
        return this.gaebConversionConvertToFlatAva(gaebFile, options === null || options === void 0 ? void 0 : options.supportSkippedItemNumberLevelsInPositions, options === null || options === void 0 ? void 0 : options.outputHtmlAsXml, options === null || options === void 0 ? void 0 : options.keepEmptyHtmlText, options === null || options === void 0 ? void 0 : options.allowUpperCaseItemNumbers, options === null || options === void 0 ? void 0 : options.allowLumpSumItemsWithDifferingQuantities);
    }
    /**
     * Converts GAEB files to Dangl.AVA projects
     * @param gaebFile (optional) The input file
     * @param supportSkippedItemNumberLevelsInPositions (optional) Defaults to 'false'. This controls if, when deserializing GAEB files, skipped levels in position
    item numbers should be supported. For example, if an ItemNumberSchema defines three levels - two group
    levels and one position level - but the ItemNumber of the position is just '01.02', then it will be
    displayed as '01.__.02' if this is set to true.
     * @param outputHtmlAsXml (optional) Defaults to 'false'. If this is enabled, then Html text will be output as XML in the output.
    This means that e.g. void Html tags will always be output with their closing tag, e.g.
    it will produce '<br />' instead of '<br>'.
     * @param keepEmptyHtmlText (optional) Defaults to 'false'. If this is enabled, then Html text that is empty will be kept in the output.
    Otherwise, Html text without any plain text will be removed. This is useful for example if you want
    to keep texts that only consist of empty paragraphs in the output.
     * @param allowUpperCaseItemNumbers (optional) Defaults to 'false'. If this is enabled, then the ItemNumber of positions will be in uppercase
    format if the source file has them. By default, all item numbers will be converted to lowercase,
    but this option will enable the option to support uppercase item numbers as well.
     * @param allowLumpSumItemsWithDifferingQuantities (optional) Defaults to 'false'.
    By default, the GAEB standard requires lump sum items ('Pauschalpositionen' in German) to have a quantity
    of exactly 1. AVACloud does enforce this convention, but if you set this property to 'true', then
    differing quantities will be kept during the import.
     */
    gaebConversionConvertToFlatAva(gaebFile, supportSkippedItemNumberLevelsInPositions, outputHtmlAsXml, keepEmptyHtmlText, allowUpperCaseItemNumbers, allowLumpSumItemsWithDifferingQuantities) {
        let url_ = this.baseUrl + "/conversion/gaeb/flat-ava?";
        if (supportSkippedItemNumberLevelsInPositions === null)
            throw new Error("The parameter 'supportSkippedItemNumberLevelsInPositions' cannot be null.");
        else if (supportSkippedItemNumberLevelsInPositions !== undefined)
            url_ += "SupportSkippedItemNumberLevelsInPositions=" + encodeURIComponent("" + supportSkippedItemNumberLevelsInPositions) + "&";
        if (outputHtmlAsXml === null)
            throw new Error("The parameter 'outputHtmlAsXml' cannot be null.");
        else if (outputHtmlAsXml !== undefined)
            url_ += "OutputHtmlAsXml=" + encodeURIComponent("" + outputHtmlAsXml) + "&";
        if (keepEmptyHtmlText === null)
            throw new Error("The parameter 'keepEmptyHtmlText' cannot be null.");
        else if (keepEmptyHtmlText !== undefined)
            url_ += "KeepEmptyHtmlText=" + encodeURIComponent("" + keepEmptyHtmlText) + "&";
        if (allowUpperCaseItemNumbers === null)
            throw new Error("The parameter 'allowUpperCaseItemNumbers' cannot be null.");
        else if (allowUpperCaseItemNumbers !== undefined)
            url_ += "AllowUpperCaseItemNumbers=" + encodeURIComponent("" + allowUpperCaseItemNumbers) + "&";
        if (allowLumpSumItemsWithDifferingQuantities === null)
            throw new Error("The parameter 'allowLumpSumItemsWithDifferingQuantities' cannot be null.");
        else if (allowLumpSumItemsWithDifferingQuantities !== undefined)
            url_ += "AllowLumpSumItemsWithDifferingQuantities=" + encodeURIComponent("" + allowLumpSumItemsWithDifferingQuantities) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (gaebFile !== null && gaebFile !== undefined)
            content_.append("gaebFile", gaebFile.data, gaebFile.fileName ? gaebFile.fileName : "gaebFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGaebConversionConvertToFlatAva(_response);
        });
    }
    processGaebConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    gaebConversionConvertToGaebWithRequestObject(gaebFile, options) {
        return this.gaebConversionConvertToGaeb(gaebFile, options === null || options === void 0 ? void 0 : options.supportSkippedItemNumberLevelsInPositions, options === null || options === void 0 ? void 0 : options.destinationGaebType, options === null || options === void 0 ? void 0 : options.targetExchangePhaseTransform, options === null || options === void 0 ? void 0 : options.enforceStrictOfferPhaseLongTextOutput, options === null || options === void 0 ? void 0 : options.exportQuantityDetermination, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts, options === null || options === void 0 ? void 0 : options.forceIncludeDescriptions, options === null || options === void 0 ? void 0 : options.treatNullItemNumberSchemaAsInvalid, options === null || options === void 0 ? void 0 : options.outputHtmlAsXml, options === null || options === void 0 ? void 0 : options.keepEmptyHtmlText, options === null || options === void 0 ? void 0 : options.allowUpperCaseItemNumbers, options === null || options === void 0 ? void 0 : options.allowLumpSumItemsWithDifferingQuantities);
    }
    /**
     * Converts GAEB files to GAEB files. Used for example when
    transforming or repairing GAEB files.
     * @param gaebFile (optional) The input file
     * @param supportSkippedItemNumberLevelsInPositions (optional) Defaults to 'false'. This controls if, when deserializing GAEB files, skipped levels in position
    item numbers should be supported. For example, if an ItemNumberSchema defines three levels - two group
    levels and one position level - but the ItemNumber of the position is just '01.02', then it will be
    displayed as '01.__.02' if this is set to true.
     * @param destinationGaebType (optional) Defaults to GAEB XML V3.2
     * @param targetExchangePhaseTransform (optional) Defaults to none, meaning no transformation will be done. The phases are:
    Base = 81
    CostEstimate = 82
    OfferRequest = 83
    Offer = 84
    SideOffer = 85
    Grant = 86
     * @param enforceStrictOfferPhaseLongTextOutput (optional) Defaults to false. If this is enabled, exported long texts to GAEB XML that use text additions will
    be strictly schema compliant. If this is not enabled, any text that is marked to contain a text addition
    is exported in full to ensure that incorrectly used text additions are still preserved in the export.
     * @param exportQuantityDetermination (optional) Defaults to false. If this is enabled, quantities are exported in detail in GAEB XML targets via the
    'QtyDeterm' (Quantity Determination, or Quantity Take Off) fields. To control this, you can set custom
    quantity calculations in the 'QuantityComponents' property of positions. Please see the entry for
    'Quantity Determination' in the Dangl.AVA HowTo documentation section. Please be advised that enabling
    this might export data that was not intended to be exported, like internal quantity calculation details,
    depending on what data you put in the 'QuantityComponents' property.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     * @param forceIncludeDescriptions (optional) If this is enabled, all description elements like texts and execution descriptions will be output
    to the result. This is mostly only applicable to GAEB exports to phase 84 - Offer, which does
    typically not include descriptions.
     * @param treatNullItemNumberSchemaAsInvalid (optional) When exporting to GAEB, an item number schema is usually required. AVACloud will try to fix invalid item number schemas.
    With this setting, you can also tell AVACloud to treat a null value as invalid. Otherwise, null schemas will simply be ignored
    and not lead to any schema being generated. It is recommended to enable this option, but it is disabled by default for compatibility
    reasons.
     * @param outputHtmlAsXml (optional) Defaults to 'false'. If this is enabled, then Html text will be output as XML in the output.
    This means that e.g. void Html tags will always be output with their closing tag, e.g.
    it will produce '<br />' instead of '<br>'.
     * @param keepEmptyHtmlText (optional) Defaults to 'false'. If this is enabled, then Html text that is empty will be kept in the output.
    Otherwise, Html text without any plain text will be removed. This is useful for example if you want
    to keep texts that only consist of empty paragraphs in the output.
     * @param allowUpperCaseItemNumbers (optional) Defaults to 'false'. If this is enabled, then the ItemNumber of positions will be in uppercase
    format if the source file has them. By default, all item numbers will be converted to lowercase,
    but this option will enable the option to support uppercase item numbers as well.
     * @param allowLumpSumItemsWithDifferingQuantities (optional) Defaults to 'false'.
    By default, the GAEB standard requires lump sum items ('Pauschalpositionen' in German) to have a quantity
    of exactly 1. AVACloud does enforce this convention, but if you set this property to 'true', then
    differing quantities will be kept during the import.
     */
    gaebConversionConvertToGaeb(gaebFile, supportSkippedItemNumberLevelsInPositions, destinationGaebType, targetExchangePhaseTransform, enforceStrictOfferPhaseLongTextOutput, exportQuantityDetermination, removeUnprintableCharactersFromTexts, forceIncludeDescriptions, treatNullItemNumberSchemaAsInvalid, outputHtmlAsXml, keepEmptyHtmlText, allowUpperCaseItemNumbers, allowLumpSumItemsWithDifferingQuantities) {
        let url_ = this.baseUrl + "/conversion/gaeb/gaeb?";
        if (supportSkippedItemNumberLevelsInPositions === null)
            throw new Error("The parameter 'supportSkippedItemNumberLevelsInPositions' cannot be null.");
        else if (supportSkippedItemNumberLevelsInPositions !== undefined)
            url_ += "SupportSkippedItemNumberLevelsInPositions=" + encodeURIComponent("" + supportSkippedItemNumberLevelsInPositions) + "&";
        if (destinationGaebType === null)
            throw new Error("The parameter 'destinationGaebType' cannot be null.");
        else if (destinationGaebType !== undefined)
            url_ += "DestinationGaebType=" + encodeURIComponent("" + destinationGaebType) + "&";
        if (targetExchangePhaseTransform === null)
            throw new Error("The parameter 'targetExchangePhaseTransform' cannot be null.");
        else if (targetExchangePhaseTransform !== undefined)
            url_ += "TargetExchangePhaseTransform=" + encodeURIComponent("" + targetExchangePhaseTransform) + "&";
        if (enforceStrictOfferPhaseLongTextOutput === null)
            throw new Error("The parameter 'enforceStrictOfferPhaseLongTextOutput' cannot be null.");
        else if (enforceStrictOfferPhaseLongTextOutput !== undefined)
            url_ += "EnforceStrictOfferPhaseLongTextOutput=" + encodeURIComponent("" + enforceStrictOfferPhaseLongTextOutput) + "&";
        if (exportQuantityDetermination === null)
            throw new Error("The parameter 'exportQuantityDetermination' cannot be null.");
        else if (exportQuantityDetermination !== undefined)
            url_ += "ExportQuantityDetermination=" + encodeURIComponent("" + exportQuantityDetermination) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        if (forceIncludeDescriptions === null)
            throw new Error("The parameter 'forceIncludeDescriptions' cannot be null.");
        else if (forceIncludeDescriptions !== undefined)
            url_ += "ForceIncludeDescriptions=" + encodeURIComponent("" + forceIncludeDescriptions) + "&";
        if (treatNullItemNumberSchemaAsInvalid === null)
            throw new Error("The parameter 'treatNullItemNumberSchemaAsInvalid' cannot be null.");
        else if (treatNullItemNumberSchemaAsInvalid !== undefined)
            url_ += "TreatNullItemNumberSchemaAsInvalid=" + encodeURIComponent("" + treatNullItemNumberSchemaAsInvalid) + "&";
        if (outputHtmlAsXml === null)
            throw new Error("The parameter 'outputHtmlAsXml' cannot be null.");
        else if (outputHtmlAsXml !== undefined)
            url_ += "OutputHtmlAsXml=" + encodeURIComponent("" + outputHtmlAsXml) + "&";
        if (keepEmptyHtmlText === null)
            throw new Error("The parameter 'keepEmptyHtmlText' cannot be null.");
        else if (keepEmptyHtmlText !== undefined)
            url_ += "KeepEmptyHtmlText=" + encodeURIComponent("" + keepEmptyHtmlText) + "&";
        if (allowUpperCaseItemNumbers === null)
            throw new Error("The parameter 'allowUpperCaseItemNumbers' cannot be null.");
        else if (allowUpperCaseItemNumbers !== undefined)
            url_ += "AllowUpperCaseItemNumbers=" + encodeURIComponent("" + allowUpperCaseItemNumbers) + "&";
        if (allowLumpSumItemsWithDifferingQuantities === null)
            throw new Error("The parameter 'allowLumpSumItemsWithDifferingQuantities' cannot be null.");
        else if (allowLumpSumItemsWithDifferingQuantities !== undefined)
            url_ += "AllowLumpSumItemsWithDifferingQuantities=" + encodeURIComponent("" + allowLumpSumItemsWithDifferingQuantities) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (gaebFile !== null && gaebFile !== undefined)
            content_.append("gaebFile", gaebFile.data, gaebFile.fileName ? gaebFile.fileName : "gaebFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGaebConversionConvertToGaeb(_response);
        });
    }
    processGaebConversionConvertToGaeb(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    gaebConversionConvertToExcelWithRequestObject(gaebFile, options) {
        return this.gaebConversionConvertToExcel(gaebFile, options === null || options === void 0 ? void 0 : options.supportSkippedItemNumberLevelsInPositions, options === null || options === void 0 ? void 0 : options.writePrices, options === null || options === void 0 ? void 0 : options.writeLongTexts, options === null || options === void 0 ? void 0 : options.conversionCulture, options === null || options === void 0 ? void 0 : options.includeArticleNumbers, options === null || options === void 0 ? void 0 : options.outputHtmlAsXml, options === null || options === void 0 ? void 0 : options.keepEmptyHtmlText, options === null || options === void 0 ? void 0 : options.allowUpperCaseItemNumbers, options === null || options === void 0 ? void 0 : options.allowLumpSumItemsWithDifferingQuantities);
    }
    /**
     * Converts GAEB files to Excel
     * @param gaebFile (optional) The input file
     * @param supportSkippedItemNumberLevelsInPositions (optional) Defaults to 'false'. This controls if, when deserializing GAEB files, skipped levels in position
    item numbers should be supported. For example, if an ItemNumberSchema defines three levels - two group
    levels and one position level - but the ItemNumber of the position is just '01.02', then it will be
    displayed as '01.__.02' if this is set to true.
     * @param writePrices (optional) Defaults to true
     * @param writeLongTexts (optional) Defaults to true
     * @param conversionCulture (optional) The culture that should be used for the conversion process, to have
    localized Excel files
     * @param includeArticleNumbers (optional) If this is enabled, then a new column will be created in the overview worksheet
    that contains the article numbers for positions. Article numbers will be read from
    'position.commerceProperties.articleNumber'
     * @param outputHtmlAsXml (optional) Defaults to 'false'. If this is enabled, then Html text will be output as XML in the output.
    This means that e.g. void Html tags will always be output with their closing tag, e.g.
    it will produce '<br />' instead of '<br>'.
     * @param keepEmptyHtmlText (optional) Defaults to 'false'. If this is enabled, then Html text that is empty will be kept in the output.
    Otherwise, Html text without any plain text will be removed. This is useful for example if you want
    to keep texts that only consist of empty paragraphs in the output.
     * @param allowUpperCaseItemNumbers (optional) Defaults to 'false'. If this is enabled, then the ItemNumber of positions will be in uppercase
    format if the source file has them. By default, all item numbers will be converted to lowercase,
    but this option will enable the option to support uppercase item numbers as well.
     * @param allowLumpSumItemsWithDifferingQuantities (optional) Defaults to 'false'.
    By default, the GAEB standard requires lump sum items ('Pauschalpositionen' in German) to have a quantity
    of exactly 1. AVACloud does enforce this convention, but if you set this property to 'true', then
    differing quantities will be kept during the import.
     */
    gaebConversionConvertToExcel(gaebFile, supportSkippedItemNumberLevelsInPositions, writePrices, writeLongTexts, conversionCulture, includeArticleNumbers, outputHtmlAsXml, keepEmptyHtmlText, allowUpperCaseItemNumbers, allowLumpSumItemsWithDifferingQuantities) {
        let url_ = this.baseUrl + "/conversion/gaeb/excel?";
        if (supportSkippedItemNumberLevelsInPositions === null)
            throw new Error("The parameter 'supportSkippedItemNumberLevelsInPositions' cannot be null.");
        else if (supportSkippedItemNumberLevelsInPositions !== undefined)
            url_ += "SupportSkippedItemNumberLevelsInPositions=" + encodeURIComponent("" + supportSkippedItemNumberLevelsInPositions) + "&";
        if (writePrices === null)
            throw new Error("The parameter 'writePrices' cannot be null.");
        else if (writePrices !== undefined)
            url_ += "WritePrices=" + encodeURIComponent("" + writePrices) + "&";
        if (writeLongTexts === null)
            throw new Error("The parameter 'writeLongTexts' cannot be null.");
        else if (writeLongTexts !== undefined)
            url_ += "WriteLongTexts=" + encodeURIComponent("" + writeLongTexts) + "&";
        if (conversionCulture !== undefined && conversionCulture !== null)
            url_ += "ConversionCulture=" + encodeURIComponent("" + conversionCulture) + "&";
        if (includeArticleNumbers === null)
            throw new Error("The parameter 'includeArticleNumbers' cannot be null.");
        else if (includeArticleNumbers !== undefined)
            url_ += "IncludeArticleNumbers=" + encodeURIComponent("" + includeArticleNumbers) + "&";
        if (outputHtmlAsXml === null)
            throw new Error("The parameter 'outputHtmlAsXml' cannot be null.");
        else if (outputHtmlAsXml !== undefined)
            url_ += "OutputHtmlAsXml=" + encodeURIComponent("" + outputHtmlAsXml) + "&";
        if (keepEmptyHtmlText === null)
            throw new Error("The parameter 'keepEmptyHtmlText' cannot be null.");
        else if (keepEmptyHtmlText !== undefined)
            url_ += "KeepEmptyHtmlText=" + encodeURIComponent("" + keepEmptyHtmlText) + "&";
        if (allowUpperCaseItemNumbers === null)
            throw new Error("The parameter 'allowUpperCaseItemNumbers' cannot be null.");
        else if (allowUpperCaseItemNumbers !== undefined)
            url_ += "AllowUpperCaseItemNumbers=" + encodeURIComponent("" + allowUpperCaseItemNumbers) + "&";
        if (allowLumpSumItemsWithDifferingQuantities === null)
            throw new Error("The parameter 'allowLumpSumItemsWithDifferingQuantities' cannot be null.");
        else if (allowLumpSumItemsWithDifferingQuantities !== undefined)
            url_ += "AllowLumpSumItemsWithDifferingQuantities=" + encodeURIComponent("" + allowLumpSumItemsWithDifferingQuantities) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (gaebFile !== null && gaebFile !== undefined)
            content_.append("gaebFile", gaebFile.data, gaebFile.fileName ? gaebFile.fileName : "gaebFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGaebConversionConvertToExcel(_response);
        });
    }
    processGaebConversionConvertToExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    gaebConversionConvertToOenormWithRequestObject(gaebFile, options) {
        return this.gaebConversionConvertToOenorm(gaebFile, options === null || options === void 0 ? void 0 : options.supportSkippedItemNumberLevelsInPositions, options === null || options === void 0 ? void 0 : options.destinationOenormType, options === null || options === void 0 ? void 0 : options.tryRepairProjectStructure, options === null || options === void 0 ? void 0 : options.skipTryEnforceSchemaCompliantXmlOutput, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts, options === null || options === void 0 ? void 0 : options.outputHtmlAsXml, options === null || options === void 0 ? void 0 : options.keepEmptyHtmlText, options === null || options === void 0 ? void 0 : options.allowUpperCaseItemNumbers, options === null || options === void 0 ? void 0 : options.allowLumpSumItemsWithDifferingQuantities);
    }
    /**
     * Converts GAEB files to Oenorm files
     * @param gaebFile (optional) The input file
     * @param supportSkippedItemNumberLevelsInPositions (optional) Defaults to 'false'. This controls if, when deserializing GAEB files, skipped levels in position
    item numbers should be supported. For example, if an ItemNumberSchema defines three levels - two group
    levels and one position level - but the ItemNumber of the position is just '01.02', then it will be
    displayed as '01.__.02' if this is set to true.
     * @param destinationOenormType (optional) Defaults to Lv2015
     * @param tryRepairProjectStructure (optional) Defaults to false. If this is enabled, the converter will try to ensure that the project structure
    can be mapped to Oenorm. It might introduce additional group levels to ensure a compatible target
     * @param skipTryEnforceSchemaCompliantXmlOutput (optional) If this option is enabled, AVACloud will not attempt to force a schema-compliant Xml output for ÖNorm targets that are Xml
    based. By default, AVACloud will try to add required fields, even if no data is present, with sensible defaults. This behavior
    can be disabled with this option.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     * @param outputHtmlAsXml (optional) Defaults to 'false'. If this is enabled, then Html text will be output as XML in the output.
    This means that e.g. void Html tags will always be output with their closing tag, e.g.
    it will produce '<br />' instead of '<br>'.
     * @param keepEmptyHtmlText (optional) Defaults to 'false'. If this is enabled, then Html text that is empty will be kept in the output.
    Otherwise, Html text without any plain text will be removed. This is useful for example if you want
    to keep texts that only consist of empty paragraphs in the output.
     * @param allowUpperCaseItemNumbers (optional) Defaults to 'false'. If this is enabled, then the ItemNumber of positions will be in uppercase
    format if the source file has them. By default, all item numbers will be converted to lowercase,
    but this option will enable the option to support uppercase item numbers as well.
     * @param allowLumpSumItemsWithDifferingQuantities (optional) Defaults to 'false'.
    By default, the GAEB standard requires lump sum items ('Pauschalpositionen' in German) to have a quantity
    of exactly 1. AVACloud does enforce this convention, but if you set this property to 'true', then
    differing quantities will be kept during the import.
     */
    gaebConversionConvertToOenorm(gaebFile, supportSkippedItemNumberLevelsInPositions, destinationOenormType, tryRepairProjectStructure, skipTryEnforceSchemaCompliantXmlOutput, removeUnprintableCharactersFromTexts, outputHtmlAsXml, keepEmptyHtmlText, allowUpperCaseItemNumbers, allowLumpSumItemsWithDifferingQuantities) {
        let url_ = this.baseUrl + "/conversion/gaeb/oenorm?";
        if (supportSkippedItemNumberLevelsInPositions === null)
            throw new Error("The parameter 'supportSkippedItemNumberLevelsInPositions' cannot be null.");
        else if (supportSkippedItemNumberLevelsInPositions !== undefined)
            url_ += "SupportSkippedItemNumberLevelsInPositions=" + encodeURIComponent("" + supportSkippedItemNumberLevelsInPositions) + "&";
        if (destinationOenormType === null)
            throw new Error("The parameter 'destinationOenormType' cannot be null.");
        else if (destinationOenormType !== undefined)
            url_ += "DestinationOenormType=" + encodeURIComponent("" + destinationOenormType) + "&";
        if (tryRepairProjectStructure === null)
            throw new Error("The parameter 'tryRepairProjectStructure' cannot be null.");
        else if (tryRepairProjectStructure !== undefined)
            url_ += "TryRepairProjectStructure=" + encodeURIComponent("" + tryRepairProjectStructure) + "&";
        if (skipTryEnforceSchemaCompliantXmlOutput === null)
            throw new Error("The parameter 'skipTryEnforceSchemaCompliantXmlOutput' cannot be null.");
        else if (skipTryEnforceSchemaCompliantXmlOutput !== undefined)
            url_ += "SkipTryEnforceSchemaCompliantXmlOutput=" + encodeURIComponent("" + skipTryEnforceSchemaCompliantXmlOutput) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        if (outputHtmlAsXml === null)
            throw new Error("The parameter 'outputHtmlAsXml' cannot be null.");
        else if (outputHtmlAsXml !== undefined)
            url_ += "OutputHtmlAsXml=" + encodeURIComponent("" + outputHtmlAsXml) + "&";
        if (keepEmptyHtmlText === null)
            throw new Error("The parameter 'keepEmptyHtmlText' cannot be null.");
        else if (keepEmptyHtmlText !== undefined)
            url_ += "KeepEmptyHtmlText=" + encodeURIComponent("" + keepEmptyHtmlText) + "&";
        if (allowUpperCaseItemNumbers === null)
            throw new Error("The parameter 'allowUpperCaseItemNumbers' cannot be null.");
        else if (allowUpperCaseItemNumbers !== undefined)
            url_ += "AllowUpperCaseItemNumbers=" + encodeURIComponent("" + allowUpperCaseItemNumbers) + "&";
        if (allowLumpSumItemsWithDifferingQuantities === null)
            throw new Error("The parameter 'allowLumpSumItemsWithDifferingQuantities' cannot be null.");
        else if (allowLumpSumItemsWithDifferingQuantities !== undefined)
            url_ += "AllowLumpSumItemsWithDifferingQuantities=" + encodeURIComponent("" + allowLumpSumItemsWithDifferingQuantities) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (gaebFile !== null && gaebFile !== undefined)
            content_.append("gaebFile", gaebFile.data, gaebFile.fileName ? gaebFile.fileName : "gaebFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processGaebConversionConvertToOenorm(_response);
        });
    }
    processGaebConversionConvertToOenorm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.GaebConversionApi = GaebConversionApi;
class IdsConnectConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    idsConnectConversionConvertToAvaWithRequestObject(idsConnectFile, options) {
        return this.idsConnectConversionConvertToAva(idsConnectFile, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts);
    }
    /**
     * Converts IDS Connect files to Dangl.AVA projects
     * @param idsConnectFile (optional) The input file
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     */
    idsConnectConversionConvertToAva(idsConnectFile, removePlainTextLongTexts, removeHtmlLongTexts) {
        let url_ = this.baseUrl + "/conversion/ids-connect/ava?";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (idsConnectFile !== null && idsConnectFile !== undefined)
            content_.append("idsConnectFile", idsConnectFile.data, idsConnectFile.fileName ? idsConnectFile.fileName : "idsConnectFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processIdsConnectConversionConvertToAva(_response);
        });
    }
    processIdsConnectConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * Converts IDS Connect files to Dangl.AVA projects
     * @param idsConnectFile (optional) The input file
     */
    idsConnectConversionConvertToFlatAva(idsConnectFile) {
        let url_ = this.baseUrl + "/conversion/ids-connect/flat-ava";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (idsConnectFile !== null && idsConnectFile !== undefined)
            content_.append("idsConnectFile", idsConnectFile.data, idsConnectFile.fileName ? idsConnectFile.fileName : "idsConnectFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processIdsConnectConversionConvertToFlatAva(_response);
        });
    }
    processIdsConnectConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.IdsConnectConversionApi = IdsConnectConversionApi;
class OenormConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    oenormConversionConvertToAvaWithRequestObject(oenormFile, options) {
        return this.oenormConversionConvertToAva(oenormFile, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts);
    }
    /**
     * Converts ÖNorm files to Dangl.AVA projects
     * @param oenormFile (optional) The input file
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     */
    oenormConversionConvertToAva(oenormFile, removePlainTextLongTexts, removeHtmlLongTexts) {
        let url_ = this.baseUrl + "/conversion/oenorm/ava?";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (oenormFile !== null && oenormFile !== undefined)
            content_.append("oenormFile", oenormFile.data, oenormFile.fileName ? oenormFile.fileName : "oenormFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processOenormConversionConvertToAva(_response);
        });
    }
    processOenormConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * Converts ÖNorm files to Dangl.AVA projects
     * @param oenormFile (optional) The input file
     */
    oenormConversionConvertToFlatAva(oenormFile) {
        let url_ = this.baseUrl + "/conversion/oenorm/flat-ava";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (oenormFile !== null && oenormFile !== undefined)
            content_.append("oenormFile", oenormFile.data, oenormFile.fileName ? oenormFile.fileName : "oenormFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processOenormConversionConvertToFlatAva(_response);
        });
    }
    processOenormConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    oenormConversionConvertToGaebWithRequestObject(oenormFile, options) {
        return this.oenormConversionConvertToGaeb(oenormFile, options === null || options === void 0 ? void 0 : options.destinationGaebType, options === null || options === void 0 ? void 0 : options.targetExchangePhaseTransform, options === null || options === void 0 ? void 0 : options.enforceStrictOfferPhaseLongTextOutput, options === null || options === void 0 ? void 0 : options.exportQuantityDetermination, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts, options === null || options === void 0 ? void 0 : options.forceIncludeDescriptions, options === null || options === void 0 ? void 0 : options.treatNullItemNumberSchemaAsInvalid);
    }
    /**
     * Converts ÖNorm files to GAEB files.
     * @param oenormFile (optional) The input file
     * @param destinationGaebType (optional) Defaults to GAEB XML V3.2
     * @param targetExchangePhaseTransform (optional) Defaults to none, meaning no transformation will be done. The phases are:
    Base = 81
    CostEstimate = 82
    OfferRequest = 83
    Offer = 84
    SideOffer = 85
    Grant = 86
     * @param enforceStrictOfferPhaseLongTextOutput (optional) Defaults to false. If this is enabled, exported long texts to GAEB XML that use text additions will
    be strictly schema compliant. If this is not enabled, any text that is marked to contain a text addition
    is exported in full to ensure that incorrectly used text additions are still preserved in the export.
     * @param exportQuantityDetermination (optional) Defaults to false. If this is enabled, quantities are exported in detail in GAEB XML targets via the
    'QtyDeterm' (Quantity Determination, or Quantity Take Off) fields. To control this, you can set custom
    quantity calculations in the 'QuantityComponents' property of positions. Please see the entry for
    'Quantity Determination' in the Dangl.AVA HowTo documentation section. Please be advised that enabling
    this might export data that was not intended to be exported, like internal quantity calculation details,
    depending on what data you put in the 'QuantityComponents' property.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     * @param forceIncludeDescriptions (optional) If this is enabled, all description elements like texts and execution descriptions will be output
    to the result. This is mostly only applicable to GAEB exports to phase 84 - Offer, which does
    typically not include descriptions.
     * @param treatNullItemNumberSchemaAsInvalid (optional) When exporting to GAEB, an item number schema is usually required. AVACloud will try to fix invalid item number schemas.
    With this setting, you can also tell AVACloud to treat a null value as invalid. Otherwise, null schemas will simply be ignored
    and not lead to any schema being generated. It is recommended to enable this option, but it is disabled by default for compatibility
    reasons.
     */
    oenormConversionConvertToGaeb(oenormFile, destinationGaebType, targetExchangePhaseTransform, enforceStrictOfferPhaseLongTextOutput, exportQuantityDetermination, removeUnprintableCharactersFromTexts, forceIncludeDescriptions, treatNullItemNumberSchemaAsInvalid) {
        let url_ = this.baseUrl + "/conversion/oenorm/gaeb?";
        if (destinationGaebType === null)
            throw new Error("The parameter 'destinationGaebType' cannot be null.");
        else if (destinationGaebType !== undefined)
            url_ += "DestinationGaebType=" + encodeURIComponent("" + destinationGaebType) + "&";
        if (targetExchangePhaseTransform === null)
            throw new Error("The parameter 'targetExchangePhaseTransform' cannot be null.");
        else if (targetExchangePhaseTransform !== undefined)
            url_ += "TargetExchangePhaseTransform=" + encodeURIComponent("" + targetExchangePhaseTransform) + "&";
        if (enforceStrictOfferPhaseLongTextOutput === null)
            throw new Error("The parameter 'enforceStrictOfferPhaseLongTextOutput' cannot be null.");
        else if (enforceStrictOfferPhaseLongTextOutput !== undefined)
            url_ += "EnforceStrictOfferPhaseLongTextOutput=" + encodeURIComponent("" + enforceStrictOfferPhaseLongTextOutput) + "&";
        if (exportQuantityDetermination === null)
            throw new Error("The parameter 'exportQuantityDetermination' cannot be null.");
        else if (exportQuantityDetermination !== undefined)
            url_ += "ExportQuantityDetermination=" + encodeURIComponent("" + exportQuantityDetermination) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        if (forceIncludeDescriptions === null)
            throw new Error("The parameter 'forceIncludeDescriptions' cannot be null.");
        else if (forceIncludeDescriptions !== undefined)
            url_ += "ForceIncludeDescriptions=" + encodeURIComponent("" + forceIncludeDescriptions) + "&";
        if (treatNullItemNumberSchemaAsInvalid === null)
            throw new Error("The parameter 'treatNullItemNumberSchemaAsInvalid' cannot be null.");
        else if (treatNullItemNumberSchemaAsInvalid !== undefined)
            url_ += "TreatNullItemNumberSchemaAsInvalid=" + encodeURIComponent("" + treatNullItemNumberSchemaAsInvalid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (oenormFile !== null && oenormFile !== undefined)
            content_.append("oenormFile", oenormFile.data, oenormFile.fileName ? oenormFile.fileName : "oenormFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processOenormConversionConvertToGaeb(_response);
        });
    }
    processOenormConversionConvertToGaeb(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    oenormConversionConvertToExcelWithRequestObject(oenormFile, options) {
        return this.oenormConversionConvertToExcel(oenormFile, options === null || options === void 0 ? void 0 : options.writePrices, options === null || options === void 0 ? void 0 : options.writeLongTexts, options === null || options === void 0 ? void 0 : options.conversionCulture, options === null || options === void 0 ? void 0 : options.includeArticleNumbers);
    }
    /**
     * Converts ÖNorm files to Excel
     * @param oenormFile (optional) The input file
     * @param writePrices (optional) Defaults to true
     * @param writeLongTexts (optional) Defaults to true
     * @param conversionCulture (optional) The culture that should be used for the conversion process, to have
    localized Excel files
     * @param includeArticleNumbers (optional) If this is enabled, then a new column will be created in the overview worksheet
    that contains the article numbers for positions. Article numbers will be read from
    'position.commerceProperties.articleNumber'
     */
    oenormConversionConvertToExcel(oenormFile, writePrices, writeLongTexts, conversionCulture, includeArticleNumbers) {
        let url_ = this.baseUrl + "/conversion/oenorm/excel?";
        if (writePrices === null)
            throw new Error("The parameter 'writePrices' cannot be null.");
        else if (writePrices !== undefined)
            url_ += "WritePrices=" + encodeURIComponent("" + writePrices) + "&";
        if (writeLongTexts === null)
            throw new Error("The parameter 'writeLongTexts' cannot be null.");
        else if (writeLongTexts !== undefined)
            url_ += "WriteLongTexts=" + encodeURIComponent("" + writeLongTexts) + "&";
        if (conversionCulture !== undefined && conversionCulture !== null)
            url_ += "ConversionCulture=" + encodeURIComponent("" + conversionCulture) + "&";
        if (includeArticleNumbers === null)
            throw new Error("The parameter 'includeArticleNumbers' cannot be null.");
        else if (includeArticleNumbers !== undefined)
            url_ += "IncludeArticleNumbers=" + encodeURIComponent("" + includeArticleNumbers) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (oenormFile !== null && oenormFile !== undefined)
            content_.append("oenormFile", oenormFile.data, oenormFile.fileName ? oenormFile.fileName : "oenormFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processOenormConversionConvertToExcel(_response);
        });
    }
    processOenormConversionConvertToExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    oenormConversionConvertToOenormWithRequestObject(oenormFile, options) {
        return this.oenormConversionConvertToOenorm(oenormFile, options === null || options === void 0 ? void 0 : options.destinationOenormType, options === null || options === void 0 ? void 0 : options.tryRepairProjectStructure, options === null || options === void 0 ? void 0 : options.skipTryEnforceSchemaCompliantXmlOutput, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts);
    }
    /**
     * Converts ÖNorm files to Oenorm files.
     * @param oenormFile (optional) The input file
     * @param destinationOenormType (optional) Defaults to Lv2015
     * @param tryRepairProjectStructure (optional) Defaults to false. If this is enabled, the converter will try to ensure that the project structure
    can be mapped to Oenorm. It might introduce additional group levels to ensure a compatible target
     * @param skipTryEnforceSchemaCompliantXmlOutput (optional) If this option is enabled, AVACloud will not attempt to force a schema-compliant Xml output for ÖNorm targets that are Xml
    based. By default, AVACloud will try to add required fields, even if no data is present, with sensible defaults. This behavior
    can be disabled with this option.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     */
    oenormConversionConvertToOenorm(oenormFile, destinationOenormType, tryRepairProjectStructure, skipTryEnforceSchemaCompliantXmlOutput, removeUnprintableCharactersFromTexts) {
        let url_ = this.baseUrl + "/conversion/oenorm/oenorm?";
        if (destinationOenormType === null)
            throw new Error("The parameter 'destinationOenormType' cannot be null.");
        else if (destinationOenormType !== undefined)
            url_ += "DestinationOenormType=" + encodeURIComponent("" + destinationOenormType) + "&";
        if (tryRepairProjectStructure === null)
            throw new Error("The parameter 'tryRepairProjectStructure' cannot be null.");
        else if (tryRepairProjectStructure !== undefined)
            url_ += "TryRepairProjectStructure=" + encodeURIComponent("" + tryRepairProjectStructure) + "&";
        if (skipTryEnforceSchemaCompliantXmlOutput === null)
            throw new Error("The parameter 'skipTryEnforceSchemaCompliantXmlOutput' cannot be null.");
        else if (skipTryEnforceSchemaCompliantXmlOutput !== undefined)
            url_ += "SkipTryEnforceSchemaCompliantXmlOutput=" + encodeURIComponent("" + skipTryEnforceSchemaCompliantXmlOutput) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (oenormFile !== null && oenormFile !== undefined)
            content_.append("oenormFile", oenormFile.data, oenormFile.fileName ? oenormFile.fileName : "oenormFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processOenormConversionConvertToOenorm(_response);
        });
    }
    processOenormConversionConvertToOenorm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.OenormConversionApi = OenormConversionApi;
class RebConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    rebConversionConvertToAvaWithRequestObject(rebFile, options) {
        return this.rebConversionConvertToAva(rebFile, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts);
    }
    /**
     * Converts REB files to Dangl.AVA projects
     * @param rebFile (optional) The input file
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     */
    rebConversionConvertToAva(rebFile, removePlainTextLongTexts, removeHtmlLongTexts) {
        let url_ = this.baseUrl + "/conversion/reb/ava?";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (rebFile !== null && rebFile !== undefined)
            content_.append("rebFile", rebFile.data, rebFile.fileName ? rebFile.fileName : "rebFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRebConversionConvertToAva(_response);
        });
    }
    processRebConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * Converts REB files to Dangl.AVA projects
     * @param rebFile (optional) The input file
     */
    rebConversionConvertToFlatAva(rebFile) {
        let url_ = this.baseUrl + "/conversion/reb/flat-ava";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (rebFile !== null && rebFile !== undefined)
            content_.append("rebFile", rebFile.data, rebFile.fileName ? rebFile.fileName : "rebFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRebConversionConvertToFlatAva(_response);
        });
    }
    processRebConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    rebConversionConvertToGaebWithRequestObject(rebFile, options) {
        return this.rebConversionConvertToGaeb(rebFile, options === null || options === void 0 ? void 0 : options.destinationGaebType, options === null || options === void 0 ? void 0 : options.targetExchangePhaseTransform, options === null || options === void 0 ? void 0 : options.enforceStrictOfferPhaseLongTextOutput, options === null || options === void 0 ? void 0 : options.exportQuantityDetermination, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts, options === null || options === void 0 ? void 0 : options.forceIncludeDescriptions, options === null || options === void 0 ? void 0 : options.treatNullItemNumberSchemaAsInvalid);
    }
    /**
     * Converts REB files to GAEB files
     * @param rebFile (optional) The input file
     * @param destinationGaebType (optional) Defaults to GAEB XML V3.2
     * @param targetExchangePhaseTransform (optional) Defaults to none, meaning no transformation will be done. The phases are:
    Base = 81
    CostEstimate = 82
    OfferRequest = 83
    Offer = 84
    SideOffer = 85
    Grant = 86
     * @param enforceStrictOfferPhaseLongTextOutput (optional) Defaults to false. If this is enabled, exported long texts to GAEB XML that use text additions will
    be strictly schema compliant. If this is not enabled, any text that is marked to contain a text addition
    is exported in full to ensure that incorrectly used text additions are still preserved in the export.
     * @param exportQuantityDetermination (optional) Defaults to false. If this is enabled, quantities are exported in detail in GAEB XML targets via the
    'QtyDeterm' (Quantity Determination, or Quantity Take Off) fields. To control this, you can set custom
    quantity calculations in the 'QuantityComponents' property of positions. Please see the entry for
    'Quantity Determination' in the Dangl.AVA HowTo documentation section. Please be advised that enabling
    this might export data that was not intended to be exported, like internal quantity calculation details,
    depending on what data you put in the 'QuantityComponents' property.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     * @param forceIncludeDescriptions (optional) If this is enabled, all description elements like texts and execution descriptions will be output
    to the result. This is mostly only applicable to GAEB exports to phase 84 - Offer, which does
    typically not include descriptions.
     * @param treatNullItemNumberSchemaAsInvalid (optional) When exporting to GAEB, an item number schema is usually required. AVACloud will try to fix invalid item number schemas.
    With this setting, you can also tell AVACloud to treat a null value as invalid. Otherwise, null schemas will simply be ignored
    and not lead to any schema being generated. It is recommended to enable this option, but it is disabled by default for compatibility
    reasons.
     */
    rebConversionConvertToGaeb(rebFile, destinationGaebType, targetExchangePhaseTransform, enforceStrictOfferPhaseLongTextOutput, exportQuantityDetermination, removeUnprintableCharactersFromTexts, forceIncludeDescriptions, treatNullItemNumberSchemaAsInvalid) {
        let url_ = this.baseUrl + "/conversion/reb/gaeb?";
        if (destinationGaebType === null)
            throw new Error("The parameter 'destinationGaebType' cannot be null.");
        else if (destinationGaebType !== undefined)
            url_ += "DestinationGaebType=" + encodeURIComponent("" + destinationGaebType) + "&";
        if (targetExchangePhaseTransform === null)
            throw new Error("The parameter 'targetExchangePhaseTransform' cannot be null.");
        else if (targetExchangePhaseTransform !== undefined)
            url_ += "TargetExchangePhaseTransform=" + encodeURIComponent("" + targetExchangePhaseTransform) + "&";
        if (enforceStrictOfferPhaseLongTextOutput === null)
            throw new Error("The parameter 'enforceStrictOfferPhaseLongTextOutput' cannot be null.");
        else if (enforceStrictOfferPhaseLongTextOutput !== undefined)
            url_ += "EnforceStrictOfferPhaseLongTextOutput=" + encodeURIComponent("" + enforceStrictOfferPhaseLongTextOutput) + "&";
        if (exportQuantityDetermination === null)
            throw new Error("The parameter 'exportQuantityDetermination' cannot be null.");
        else if (exportQuantityDetermination !== undefined)
            url_ += "ExportQuantityDetermination=" + encodeURIComponent("" + exportQuantityDetermination) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        if (forceIncludeDescriptions === null)
            throw new Error("The parameter 'forceIncludeDescriptions' cannot be null.");
        else if (forceIncludeDescriptions !== undefined)
            url_ += "ForceIncludeDescriptions=" + encodeURIComponent("" + forceIncludeDescriptions) + "&";
        if (treatNullItemNumberSchemaAsInvalid === null)
            throw new Error("The parameter 'treatNullItemNumberSchemaAsInvalid' cannot be null.");
        else if (treatNullItemNumberSchemaAsInvalid !== undefined)
            url_ += "TreatNullItemNumberSchemaAsInvalid=" + encodeURIComponent("" + treatNullItemNumberSchemaAsInvalid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (rebFile !== null && rebFile !== undefined)
            content_.append("rebFile", rebFile.data, rebFile.fileName ? rebFile.fileName : "rebFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRebConversionConvertToGaeb(_response);
        });
    }
    processRebConversionConvertToGaeb(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    rebConversionConvertToExcelWithRequestObject(rebFile, options) {
        return this.rebConversionConvertToExcel(rebFile, options === null || options === void 0 ? void 0 : options.writePrices, options === null || options === void 0 ? void 0 : options.writeLongTexts, options === null || options === void 0 ? void 0 : options.conversionCulture, options === null || options === void 0 ? void 0 : options.includeArticleNumbers);
    }
    /**
     * Converts REB files to Excel
     * @param rebFile (optional) The input file
     * @param writePrices (optional) Defaults to true
     * @param writeLongTexts (optional) Defaults to true
     * @param conversionCulture (optional) The culture that should be used for the conversion process, to have
    localized Excel files
     * @param includeArticleNumbers (optional) If this is enabled, then a new column will be created in the overview worksheet
    that contains the article numbers for positions. Article numbers will be read from
    'position.commerceProperties.articleNumber'
     */
    rebConversionConvertToExcel(rebFile, writePrices, writeLongTexts, conversionCulture, includeArticleNumbers) {
        let url_ = this.baseUrl + "/conversion/reb/excel?";
        if (writePrices === null)
            throw new Error("The parameter 'writePrices' cannot be null.");
        else if (writePrices !== undefined)
            url_ += "WritePrices=" + encodeURIComponent("" + writePrices) + "&";
        if (writeLongTexts === null)
            throw new Error("The parameter 'writeLongTexts' cannot be null.");
        else if (writeLongTexts !== undefined)
            url_ += "WriteLongTexts=" + encodeURIComponent("" + writeLongTexts) + "&";
        if (conversionCulture !== undefined && conversionCulture !== null)
            url_ += "ConversionCulture=" + encodeURIComponent("" + conversionCulture) + "&";
        if (includeArticleNumbers === null)
            throw new Error("The parameter 'includeArticleNumbers' cannot be null.");
        else if (includeArticleNumbers !== undefined)
            url_ += "IncludeArticleNumbers=" + encodeURIComponent("" + includeArticleNumbers) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (rebFile !== null && rebFile !== undefined)
            content_.append("rebFile", rebFile.data, rebFile.fileName ? rebFile.fileName : "rebFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRebConversionConvertToExcel(_response);
        });
    }
    processRebConversionConvertToExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    rebConversionConvertToOenormWithRequestObject(rebFile, options) {
        return this.rebConversionConvertToOenorm(rebFile, options === null || options === void 0 ? void 0 : options.destinationOenormType, options === null || options === void 0 ? void 0 : options.tryRepairProjectStructure, options === null || options === void 0 ? void 0 : options.skipTryEnforceSchemaCompliantXmlOutput, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts);
    }
    /**
     * Converts REB files to Oenorm
     * @param rebFile (optional) The input file
     * @param destinationOenormType (optional) Defaults to Lv2015
     * @param tryRepairProjectStructure (optional) Defaults to false. If this is enabled, the converter will try to ensure that the project structure
    can be mapped to Oenorm. It might introduce additional group levels to ensure a compatible target
     * @param skipTryEnforceSchemaCompliantXmlOutput (optional) If this option is enabled, AVACloud will not attempt to force a schema-compliant Xml output for ÖNorm targets that are Xml
    based. By default, AVACloud will try to add required fields, even if no data is present, with sensible defaults. This behavior
    can be disabled with this option.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     */
    rebConversionConvertToOenorm(rebFile, destinationOenormType, tryRepairProjectStructure, skipTryEnforceSchemaCompliantXmlOutput, removeUnprintableCharactersFromTexts) {
        let url_ = this.baseUrl + "/conversion/reb/oenorm?";
        if (destinationOenormType === null)
            throw new Error("The parameter 'destinationOenormType' cannot be null.");
        else if (destinationOenormType !== undefined)
            url_ += "DestinationOenormType=" + encodeURIComponent("" + destinationOenormType) + "&";
        if (tryRepairProjectStructure === null)
            throw new Error("The parameter 'tryRepairProjectStructure' cannot be null.");
        else if (tryRepairProjectStructure !== undefined)
            url_ += "TryRepairProjectStructure=" + encodeURIComponent("" + tryRepairProjectStructure) + "&";
        if (skipTryEnforceSchemaCompliantXmlOutput === null)
            throw new Error("The parameter 'skipTryEnforceSchemaCompliantXmlOutput' cannot be null.");
        else if (skipTryEnforceSchemaCompliantXmlOutput !== undefined)
            url_ += "SkipTryEnforceSchemaCompliantXmlOutput=" + encodeURIComponent("" + skipTryEnforceSchemaCompliantXmlOutput) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (rebFile !== null && rebFile !== undefined)
            content_.append("rebFile", rebFile.data, rebFile.fileName ? rebFile.fileName : "rebFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processRebConversionConvertToOenorm(_response);
        });
    }
    processRebConversionConvertToOenorm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.RebConversionApi = RebConversionApi;
class SiaConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    siaConversionConvertToAvaWithRequestObject(siaFile, options) {
        return this.siaConversionConvertToAva(siaFile, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts);
    }
    /**
     * Converts SIA 451 files to Dangl.AVA projects
     * @param siaFile (optional) The input file
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     */
    siaConversionConvertToAva(siaFile, removePlainTextLongTexts, removeHtmlLongTexts) {
        let url_ = this.baseUrl + "/conversion/sia/ava?";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (siaFile !== null && siaFile !== undefined)
            content_.append("siaFile", siaFile.data, siaFile.fileName ? siaFile.fileName : "siaFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSiaConversionConvertToAva(_response);
        });
    }
    processSiaConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * Converts SIA 451 files to Dangl.AVA projects
     * @param siaFile (optional) The input file
     */
    siaConversionConvertToFlatAva(siaFile) {
        let url_ = this.baseUrl + "/conversion/sia/flat-ava";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (siaFile !== null && siaFile !== undefined)
            content_.append("siaFile", siaFile.data, siaFile.fileName ? siaFile.fileName : "siaFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSiaConversionConvertToFlatAva(_response);
        });
    }
    processSiaConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    siaConversionConvertToGaebWithRequestObject(siaFile, options) {
        return this.siaConversionConvertToGaeb(siaFile, options === null || options === void 0 ? void 0 : options.destinationGaebType, options === null || options === void 0 ? void 0 : options.targetExchangePhaseTransform, options === null || options === void 0 ? void 0 : options.enforceStrictOfferPhaseLongTextOutput, options === null || options === void 0 ? void 0 : options.exportQuantityDetermination, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts, options === null || options === void 0 ? void 0 : options.forceIncludeDescriptions, options === null || options === void 0 ? void 0 : options.treatNullItemNumberSchemaAsInvalid);
    }
    /**
     * Converts SIA 451 files to GAEB files
     * @param siaFile (optional) The input file
     * @param destinationGaebType (optional) Defaults to GAEB XML V3.2
     * @param targetExchangePhaseTransform (optional) Defaults to none, meaning no transformation will be done. The phases are:
    Base = 81
    CostEstimate = 82
    OfferRequest = 83
    Offer = 84
    SideOffer = 85
    Grant = 86
     * @param enforceStrictOfferPhaseLongTextOutput (optional) Defaults to false. If this is enabled, exported long texts to GAEB XML that use text additions will
    be strictly schema compliant. If this is not enabled, any text that is marked to contain a text addition
    is exported in full to ensure that incorrectly used text additions are still preserved in the export.
     * @param exportQuantityDetermination (optional) Defaults to false. If this is enabled, quantities are exported in detail in GAEB XML targets via the
    'QtyDeterm' (Quantity Determination, or Quantity Take Off) fields. To control this, you can set custom
    quantity calculations in the 'QuantityComponents' property of positions. Please see the entry for
    'Quantity Determination' in the Dangl.AVA HowTo documentation section. Please be advised that enabling
    this might export data that was not intended to be exported, like internal quantity calculation details,
    depending on what data you put in the 'QuantityComponents' property.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     * @param forceIncludeDescriptions (optional) If this is enabled, all description elements like texts and execution descriptions will be output
    to the result. This is mostly only applicable to GAEB exports to phase 84 - Offer, which does
    typically not include descriptions.
     * @param treatNullItemNumberSchemaAsInvalid (optional) When exporting to GAEB, an item number schema is usually required. AVACloud will try to fix invalid item number schemas.
    With this setting, you can also tell AVACloud to treat a null value as invalid. Otherwise, null schemas will simply be ignored
    and not lead to any schema being generated. It is recommended to enable this option, but it is disabled by default for compatibility
    reasons.
     */
    siaConversionConvertToGaeb(siaFile, destinationGaebType, targetExchangePhaseTransform, enforceStrictOfferPhaseLongTextOutput, exportQuantityDetermination, removeUnprintableCharactersFromTexts, forceIncludeDescriptions, treatNullItemNumberSchemaAsInvalid) {
        let url_ = this.baseUrl + "/conversion/sia/gaeb?";
        if (destinationGaebType === null)
            throw new Error("The parameter 'destinationGaebType' cannot be null.");
        else if (destinationGaebType !== undefined)
            url_ += "DestinationGaebType=" + encodeURIComponent("" + destinationGaebType) + "&";
        if (targetExchangePhaseTransform === null)
            throw new Error("The parameter 'targetExchangePhaseTransform' cannot be null.");
        else if (targetExchangePhaseTransform !== undefined)
            url_ += "TargetExchangePhaseTransform=" + encodeURIComponent("" + targetExchangePhaseTransform) + "&";
        if (enforceStrictOfferPhaseLongTextOutput === null)
            throw new Error("The parameter 'enforceStrictOfferPhaseLongTextOutput' cannot be null.");
        else if (enforceStrictOfferPhaseLongTextOutput !== undefined)
            url_ += "EnforceStrictOfferPhaseLongTextOutput=" + encodeURIComponent("" + enforceStrictOfferPhaseLongTextOutput) + "&";
        if (exportQuantityDetermination === null)
            throw new Error("The parameter 'exportQuantityDetermination' cannot be null.");
        else if (exportQuantityDetermination !== undefined)
            url_ += "ExportQuantityDetermination=" + encodeURIComponent("" + exportQuantityDetermination) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        if (forceIncludeDescriptions === null)
            throw new Error("The parameter 'forceIncludeDescriptions' cannot be null.");
        else if (forceIncludeDescriptions !== undefined)
            url_ += "ForceIncludeDescriptions=" + encodeURIComponent("" + forceIncludeDescriptions) + "&";
        if (treatNullItemNumberSchemaAsInvalid === null)
            throw new Error("The parameter 'treatNullItemNumberSchemaAsInvalid' cannot be null.");
        else if (treatNullItemNumberSchemaAsInvalid !== undefined)
            url_ += "TreatNullItemNumberSchemaAsInvalid=" + encodeURIComponent("" + treatNullItemNumberSchemaAsInvalid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (siaFile !== null && siaFile !== undefined)
            content_.append("siaFile", siaFile.data, siaFile.fileName ? siaFile.fileName : "siaFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSiaConversionConvertToGaeb(_response);
        });
    }
    processSiaConversionConvertToGaeb(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    siaConversionConvertToExcelWithRequestObject(siaFile, options) {
        return this.siaConversionConvertToExcel(siaFile, options === null || options === void 0 ? void 0 : options.writePrices, options === null || options === void 0 ? void 0 : options.writeLongTexts, options === null || options === void 0 ? void 0 : options.conversionCulture, options === null || options === void 0 ? void 0 : options.includeArticleNumbers);
    }
    /**
     * Converts SIA 451 files to Excel
     * @param siaFile (optional) The input file
     * @param writePrices (optional) Defaults to true
     * @param writeLongTexts (optional) Defaults to true
     * @param conversionCulture (optional) The culture that should be used for the conversion process, to have
    localized Excel files
     * @param includeArticleNumbers (optional) If this is enabled, then a new column will be created in the overview worksheet
    that contains the article numbers for positions. Article numbers will be read from
    'position.commerceProperties.articleNumber'
     */
    siaConversionConvertToExcel(siaFile, writePrices, writeLongTexts, conversionCulture, includeArticleNumbers) {
        let url_ = this.baseUrl + "/conversion/sia/excel?";
        if (writePrices === null)
            throw new Error("The parameter 'writePrices' cannot be null.");
        else if (writePrices !== undefined)
            url_ += "WritePrices=" + encodeURIComponent("" + writePrices) + "&";
        if (writeLongTexts === null)
            throw new Error("The parameter 'writeLongTexts' cannot be null.");
        else if (writeLongTexts !== undefined)
            url_ += "WriteLongTexts=" + encodeURIComponent("" + writeLongTexts) + "&";
        if (conversionCulture !== undefined && conversionCulture !== null)
            url_ += "ConversionCulture=" + encodeURIComponent("" + conversionCulture) + "&";
        if (includeArticleNumbers === null)
            throw new Error("The parameter 'includeArticleNumbers' cannot be null.");
        else if (includeArticleNumbers !== undefined)
            url_ += "IncludeArticleNumbers=" + encodeURIComponent("" + includeArticleNumbers) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (siaFile !== null && siaFile !== undefined)
            content_.append("siaFile", siaFile.data, siaFile.fileName ? siaFile.fileName : "siaFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSiaConversionConvertToExcel(_response);
        });
    }
    processSiaConversionConvertToExcel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    siaConversionConvertToOenormWithRequestObject(siaFile, options) {
        return this.siaConversionConvertToOenorm(siaFile, options === null || options === void 0 ? void 0 : options.destinationOenormType, options === null || options === void 0 ? void 0 : options.tryRepairProjectStructure, options === null || options === void 0 ? void 0 : options.skipTryEnforceSchemaCompliantXmlOutput, options === null || options === void 0 ? void 0 : options.removeUnprintableCharactersFromTexts);
    }
    /**
     * Converts SIA 451 files to Oenorm files
     * @param siaFile (optional) The input file
     * @param destinationOenormType (optional) Defaults to Lv2015
     * @param tryRepairProjectStructure (optional) Defaults to false. If this is enabled, the converter will try to ensure that the project structure
    can be mapped to Oenorm. It might introduce additional group levels to ensure a compatible target
     * @param skipTryEnforceSchemaCompliantXmlOutput (optional) If this option is enabled, AVACloud will not attempt to force a schema-compliant Xml output for ÖNorm targets that are Xml
    based. By default, AVACloud will try to add required fields, even if no data is present, with sensible defaults. This behavior
    can be disabled with this option.
     * @param removeUnprintableCharactersFromTexts (optional) If this is enabled, unprintable characters are removed from text elements. Otherwise, the conversion
    might fail in case some text content contains characters that are not allowed in XML output formats.
    Defaults to true.
     */
    siaConversionConvertToOenorm(siaFile, destinationOenormType, tryRepairProjectStructure, skipTryEnforceSchemaCompliantXmlOutput, removeUnprintableCharactersFromTexts) {
        let url_ = this.baseUrl + "/conversion/sia/oenorm?";
        if (destinationOenormType === null)
            throw new Error("The parameter 'destinationOenormType' cannot be null.");
        else if (destinationOenormType !== undefined)
            url_ += "DestinationOenormType=" + encodeURIComponent("" + destinationOenormType) + "&";
        if (tryRepairProjectStructure === null)
            throw new Error("The parameter 'tryRepairProjectStructure' cannot be null.");
        else if (tryRepairProjectStructure !== undefined)
            url_ += "TryRepairProjectStructure=" + encodeURIComponent("" + tryRepairProjectStructure) + "&";
        if (skipTryEnforceSchemaCompliantXmlOutput === null)
            throw new Error("The parameter 'skipTryEnforceSchemaCompliantXmlOutput' cannot be null.");
        else if (skipTryEnforceSchemaCompliantXmlOutput !== undefined)
            url_ += "SkipTryEnforceSchemaCompliantXmlOutput=" + encodeURIComponent("" + skipTryEnforceSchemaCompliantXmlOutput) + "&";
        if (removeUnprintableCharactersFromTexts === null)
            throw new Error("The parameter 'removeUnprintableCharactersFromTexts' cannot be null.");
        else if (removeUnprintableCharactersFromTexts !== undefined)
            url_ += "RemoveUnprintableCharactersFromTexts=" + encodeURIComponent("" + removeUnprintableCharactersFromTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (siaFile !== null && siaFile !== undefined)
            content_.append("siaFile", siaFile.data, siaFile.fileName ? siaFile.fileName : "siaFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processSiaConversionConvertToOenorm(_response);
        });
    }
    processSiaConversionConvertToOenorm(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.SiaConversionApi = SiaConversionApi;
class StatusApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
     * Reports the health status of the AVACloud API
     */
    statusGetStatus() {
        let url_ = this.baseUrl + "/status";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processStatusGetStatus(_response);
        });
    }
    processStatusGetStatus(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetStatus.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.StatusApi = StatusApi;
class UglConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    uglConversionConvertToAvaWithRequestObject(uglFile, options) {
        return this.uglConversionConvertToAva(uglFile, options === null || options === void 0 ? void 0 : options.removePlainTextLongTexts, options === null || options === void 0 ? void 0 : options.removeHtmlLongTexts);
    }
    /**
     * Converts Ugl files to Dangl.AVA projects
     * @param uglFile (optional) The input file
     * @param removePlainTextLongTexts (optional) If set to true, plain text long texts will be removed from the output to reduce response sizes
     * @param removeHtmlLongTexts (optional) If set to true, html long texts will be removed from the output to reduce response sizes
     */
    uglConversionConvertToAva(uglFile, removePlainTextLongTexts, removeHtmlLongTexts) {
        let url_ = this.baseUrl + "/conversion/ugl/ava?";
        if (removePlainTextLongTexts === null)
            throw new Error("The parameter 'removePlainTextLongTexts' cannot be null.");
        else if (removePlainTextLongTexts !== undefined)
            url_ += "RemovePlainTextLongTexts=" + encodeURIComponent("" + removePlainTextLongTexts) + "&";
        if (removeHtmlLongTexts === null)
            throw new Error("The parameter 'removeHtmlLongTexts' cannot be null.");
        else if (removeHtmlLongTexts !== undefined)
            url_ += "RemoveHtmlLongTexts=" + encodeURIComponent("" + removeHtmlLongTexts) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (uglFile !== null && uglFile !== undefined)
            content_.append("uglFile", uglFile.data, uglFile.fileName ? uglFile.fileName : "uglFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/vnd.com.dangl-it.ProjectDto.v1+json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUglConversionConvertToAva(_response);
        });
    }
    processUglConversionConvertToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProjectDto.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * Converts Ugl files to Dangl.AVA projects
     * @param uglFile (optional) The input file
     */
    uglConversionConvertToFlatAva(uglFile) {
        let url_ = this.baseUrl + "/conversion/ugl/flat-ava";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (uglFile !== null && uglFile !== undefined)
            content_.append("uglFile", uglFile.data, uglFile.fileName ? uglFile.fileName : "uglFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processUglConversionConvertToFlatAva(_response);
        });
    }
    processUglConversionConvertToFlatAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatAvaProject.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.UglConversionApi = UglConversionApi;
class ValidationApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    validationValidateFileWithRequestObject(avaFile, options) {
        return this.validationValidateFile(avaFile, options === null || options === void 0 ? void 0 : options.fileValidationSourceType);
    }
    /**
     * This endpoint validates AVA files, typically GAEB or ÖNorm. The type of file needs to be provided
    as a query parameter, since there is no auto detection of the uploaded file type.
     * @param avaFile (optional) The file to validate
     * @param fileValidationSourceType (optional) You need to indicate which type of file is being provided, there is no auto detection mechanism
     */
    validationValidateFile(avaFile, fileValidationSourceType) {
        let url_ = this.baseUrl + "/validation/file?";
        if (fileValidationSourceType === null)
            throw new Error("The parameter 'fileValidationSourceType' cannot be null.");
        else if (fileValidationSourceType !== undefined)
            url_ += "fileValidationSourceType=" + encodeURIComponent("" + fileValidationSourceType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (avaFile !== null && avaFile !== undefined)
            content_.append("avaFile", avaFile.data, avaFile.fileName ? avaFile.fileName : "avaFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processValidationValidateFile(_response);
        });
    }
    processValidationValidateFile(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ValidationResult.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * This endpoint provides a full validation of a provided ProjectDto. It will take the given exchange phase
    into account and do some general project validation. Optionally, a conversion to a desired target can also
    be done, in which case the target file will also be validated.
     * @param avaProjectValidationSourceOptions The options used for the validation operation
     */
    validationValidateProject(avaProjectValidationSourceOptions) {
        let url_ = this.baseUrl + "/validation/project";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaProjectValidationSourceOptions);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processValidationValidateProject(_response);
        });
    }
    processValidationValidateProject(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ValidationResult.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.ValidationApi = ValidationApi;
class XRechnungConversionApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
     * This will read an XRechnung file and convert it to an Invoice object
     * @param xrechnungFile (optional)
     */
    xRechnungConversionConvertXRechnungToInvoice(xrechnungFile) {
        let url_ = this.baseUrl + "/conversion/xrechnung/invoice";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (xrechnungFile !== null && xrechnungFile !== undefined)
            content_.append("xrechnungFile", xrechnungFile.data, xrechnungFile.fileName ? xrechnungFile.fileName : "xrechnungFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processXRechnungConversionConvertXRechnungToInvoice(_response);
        });
    }
    processXRechnungConversionConvertXRechnungToInvoice(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Invoice.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * This will read an XRechnung file and convert it to an AVA wrapper object
     * @param xrechnungFile (optional)
     */
    xRechnungConversionConvertXRechnungToAva(xrechnungFile) {
        let url_ = this.baseUrl + "/conversion/xrechnung/ava-wrapper";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = new FormData();
        if (xrechnungFile !== null && xrechnungFile !== undefined)
            content_.append("xrechnungFile", xrechnungFile.data, xrechnungFile.fileName ? xrechnungFile.fileName : "xrechnungFile");
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processXRechnungConversionConvertXRechnungToAva(_response);
        });
    }
    processXRechnungConversionConvertXRechnungToAva(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AvaProjectWrapper.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * This will convert an Invoice object to an XRechnung file
     */
    xRechnungConversionConvertInvoiceToXRechnung(invoice) {
        let url_ = this.baseUrl + "/conversion/xrechnung/invoice/xrechnung";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(invoice);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processXRechnungConversionConvertInvoiceToXRechnung(_response);
        });
    }
    processXRechnungConversionConvertInvoiceToXRechnung(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    /**
     * This will convert an AVA wrapper object to an XRechnung file
     */
    xRechnungConversionConvertAvaToXRechnung(avaWrapper) {
        let url_ = this.baseUrl + "/conversion/xrechnung/ava-wrapper/xrechnung";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(avaWrapper);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processXRechnungConversionConvertAvaToXRechnung(_response);
        });
    }
    processXRechnungConversionConvertAvaToXRechnung(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return new SwaggerResponse(status, _headers, { fileName: fileName, data: blob, status: status, headers: _headers }); });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.XRechnungConversionApi = XRechnungConversionApi;
class DanglIdentityApi {
    set accessToken(token) {
        this._accessToken = token;
    }
    get basePath() {
        return this.baseUrl;
    }
    set basePath(value) {
        this.baseUrl = value;
    }
    constructor(baseUrl, http) {
        this._accessToken = null;
        this.jsonParseReviver = undefined;
        this.http = http ? http : (typeof window !== 'undefined' ? window : { fetch });
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : "https://avacloud-api.dangl-it.com";
    }
    /**
    * This is a generated method that accepts an options object, it simply calls the generated method with the parameter list
    */
    danglIdentityLoginWithCookieWithRequestObject(model, options) {
        return this.danglIdentityLoginWithCookie(model, options === null || options === void 0 ? void 0 : options.redirectUrl);
    }
    danglIdentityLoginWithCookie(model, redirectUrl) {
        let url_ = this.baseUrl + "/identity/login?";
        if (redirectUrl !== undefined && redirectUrl !== null)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDanglIdentityLoginWithCookie(_response);
        });
    }
    processDanglIdentityLoginWithCookie(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return new SwaggerResponse(status, _headers, null);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    danglIdentitySignOutWithSignInManager() {
        let url_ = this.baseUrl + "/identity/login";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {}
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDanglIdentitySignOutWithSignInManager(_response);
        });
    }
    processDanglIdentitySignOutWithSignInManager(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return new SwaggerResponse(status, _headers, null);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    danglIdentityLoginAndReturnToken(model) {
        let url_ = this.baseUrl + "/identity/token-login";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDanglIdentityLoginAndReturnToken(_response);
        });
    }
    processDanglIdentityLoginAndReturnToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TokenResponseGet.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = TokenResponseGet.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    danglIdentityRefreshToken(model) {
        let url_ = this.baseUrl + "/identity/token-refresh";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(model);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDanglIdentityRefreshToken(_response);
        });
    }
    processDanglIdentityRefreshToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TokenResponseGet.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = TokenResponseGet.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status === 401) {
            return response.text().then((_responseText) => {
                return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    danglIdentityRegister(registerModel) {
        let url_ = this.baseUrl + "/identity/register";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(registerModel);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDanglIdentityRegister(_response);
        });
    }
    processDanglIdentityRegister(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return new SwaggerResponse(status, _headers, null);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    danglIdentityRequestPasswordReset(forgotPasswordModel) {
        let url_ = this.baseUrl + "/identity/password-forgotten";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(forgotPasswordModel);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDanglIdentityRequestPasswordReset(_response);
        });
    }
    processDanglIdentityRequestPasswordReset(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 204) {
            return response.text().then((_responseText) => {
                return new SwaggerResponse(status, _headers, null);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
    danglIdentityGetUserInfo() {
        let url_ = this.baseUrl + "/identity/user-info";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        if (this._accessToken) {
            options_.headers = options_.headers || {};
            options_.headers['Authorization'] = `Bearer ${this._accessToken}`;
        }
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processDanglIdentityGetUserInfo(_response);
        });
    }
    processDanglIdentityGetUserInfo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserInfoGet.fromJS(resultData200);
                return new SwaggerResponse(status, _headers, result200);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ApiError.fromJS(resultData400);
                return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(new SwaggerResponse(status, _headers, null));
    }
}
exports.DanglIdentityApi = DanglIdentityApi;
/** A Project contains all relevant information for a construction project. */
class ProjectDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.projectInformation = data.projectInformation && !data.projectInformation.toJSON ? new ProjectInformationDto(data.projectInformation) : this.projectInformation;
            if (data.serviceSpecifications) {
                this.serviceSpecifications = [];
                for (let i = 0; i < data.serviceSpecifications.length; i++) {
                    let item = data.serviceSpecifications[i];
                    this.serviceSpecifications[i] = item && !item.toJSON ? new ServiceSpecificationDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.priceAccuracy = _data["priceAccuracy"];
            this.unitPriceAccuracy = _data["unitPriceAccuracy"];
            this.forceStrictTotals = _data["forceStrictTotals"];
            this.priceRoundingMode = _data["priceRoundingMode"];
            this.projectInformation = _data["projectInformation"] ? ProjectInformationDto.fromJS(_data["projectInformation"]) : undefined;
            if (Array.isArray(_data["serviceSpecifications"])) {
                this.serviceSpecifications = [];
                for (let item of _data["serviceSpecifications"])
                    this.serviceSpecifications.push(ServiceSpecificationDto.fromJS(item));
            }
            this.gaebXmlId = _data["gaebXmlId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["priceAccuracy"] = this.priceAccuracy;
        data["unitPriceAccuracy"] = this.unitPriceAccuracy;
        data["forceStrictTotals"] = this.forceStrictTotals;
        data["priceRoundingMode"] = this.priceRoundingMode;
        data["projectInformation"] = this.projectInformation ? this.projectInformation.toJSON() : undefined;
        if (Array.isArray(this.serviceSpecifications)) {
            data["serviceSpecifications"] = [];
            for (let item of this.serviceSpecifications)
                data["serviceSpecifications"].push(item.toJSON());
        }
        data["gaebXmlId"] = this.gaebXmlId;
        return data;
    }
}
exports.ProjectDto = ProjectDto;
/** This enum configures rounding modes for price calculations in projects */
var PriceRoundingModeDto;
(function (PriceRoundingModeDto) {
    PriceRoundingModeDto["Normal"] = "Normal";
    PriceRoundingModeDto["Floor"] = "Floor";
    PriceRoundingModeDto["Ceiling"] = "Ceiling";
})(PriceRoundingModeDto = exports.PriceRoundingModeDto || (exports.PriceRoundingModeDto = {}));
/** General information about a Project. */
class ProjectInformationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.buyer = data.buyer && !data.buyer.toJSON ? new PartyInformationDto(data.buyer) : this.buyer;
            this.site = data.site && !data.site.toJSON ? new PartyInformationDto(data.site) : this.site;
            this.itemNumberSchema = data.itemNumberSchema && !data.itemNumberSchema.toJSON ? new ItemNumberSchemaDto(data.itemNumberSchema) : this.itemNumberSchema;
            if (data.requesters) {
                this.requesters = [];
                for (let i = 0; i < data.requesters.length; i++) {
                    let item = data.requesters[i];
                    this.requesters[i] = item && !item.toJSON ? new PartyInformationDto(item) : item;
                }
            }
            if (data.notificationSites) {
                this.notificationSites = [];
                for (let i = 0; i < data.notificationSites.length; i++) {
                    let item = data.notificationSites[i];
                    this.notificationSites[i] = item && !item.toJSON ? new PartyInformationDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.buyer = _data["buyer"] ? PartyInformationDto.fromJS(_data["buyer"]) : undefined;
            this.description = _data["description"];
            this.descriptionShort = _data["descriptionShort"];
            this.name = _data["name"];
            this.site = _data["site"] ? PartyInformationDto.fromJS(_data["site"]) : undefined;
            this.itemNumberSchema = _data["itemNumberSchema"] ? ItemNumberSchemaDto.fromJS(_data["itemNumberSchema"]) : undefined;
            this.currencyShort = _data["currencyShort"];
            this.currencyLong = _data["currencyLong"];
            this.labourTimeLabel = _data["labourTimeLabel"];
            if (Array.isArray(_data["priceComponents"])) {
                this.priceComponents = [];
                for (let item of _data["priceComponents"])
                    this.priceComponents.push(item);
            }
            if (_data["priceComponentTypes"]) {
                this.priceComponentTypes = {};
                for (let key in _data["priceComponentTypes"]) {
                    if (_data["priceComponentTypes"].hasOwnProperty(key))
                        this.priceComponentTypes[key] = _data["priceComponentTypes"][key];
                }
            }
            this.bidderCommentAllowed = _data["bidderCommentAllowed"];
            this.sideOffersAllowed = _data["sideOffersAllowed"];
            this.awardType = _data["awardType"];
            this.specialAwardKind = _data["specialAwardKind"];
            if (Array.isArray(_data["requesters"])) {
                this.requesters = [];
                for (let item of _data["requesters"])
                    this.requesters.push(PartyInformationDto.fromJS(item));
            }
            if (Array.isArray(_data["notificationSites"])) {
                this.notificationSites = [];
                for (let item of _data["notificationSites"])
                    this.notificationSites.push(PartyInformationDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectInformationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["buyer"] = this.buyer ? this.buyer.toJSON() : undefined;
        data["description"] = this.description;
        data["descriptionShort"] = this.descriptionShort;
        data["name"] = this.name;
        data["site"] = this.site ? this.site.toJSON() : undefined;
        data["itemNumberSchema"] = this.itemNumberSchema ? this.itemNumberSchema.toJSON() : undefined;
        data["currencyShort"] = this.currencyShort;
        data["currencyLong"] = this.currencyLong;
        data["labourTimeLabel"] = this.labourTimeLabel;
        if (Array.isArray(this.priceComponents)) {
            data["priceComponents"] = [];
            for (let item of this.priceComponents)
                data["priceComponents"].push(item);
        }
        if (this.priceComponentTypes) {
            data["priceComponentTypes"] = {};
            for (let key in this.priceComponentTypes) {
                if (this.priceComponentTypes.hasOwnProperty(key))
                    data["priceComponentTypes"][key] = this.priceComponentTypes[key];
            }
        }
        data["bidderCommentAllowed"] = this.bidderCommentAllowed;
        data["sideOffersAllowed"] = this.sideOffersAllowed;
        data["awardType"] = this.awardType;
        data["specialAwardKind"] = this.specialAwardKind;
        if (Array.isArray(this.requesters)) {
            data["requesters"] = [];
            for (let item of this.requesters)
                data["requesters"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationSites)) {
            data["notificationSites"] = [];
            for (let item of this.notificationSites)
                data["notificationSites"].push(item.toJSON());
        }
        return data;
    }
}
exports.ProjectInformationDto = ProjectInformationDto;
/** Represents information about a party (a site or an organization). */
class PartyInformationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.bankingInformation) {
                this.bankingInformation = [];
                for (let i = 0; i < data.bankingInformation.length; i++) {
                    let item = data.bankingInformation[i];
                    this.bankingInformation[i] = item && !item.toJSON ? new BankingInformationDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.street = _data["street"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.identifier = _data["identifier"];
            this.remarks = _data["remarks"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.contactPersonName = _data["contactPersonName"];
            this.awardIdentifier = _data["awardIdentifier"];
            this.isInEuropeanEconomicArea = _data["isInEuropeanEconomicArea"];
            this.vatId = _data["vatId"];
            this.fax = _data["fax"];
            this.countryCode = _data["countryCode"];
            this.creditorOrDebtorIdentifier = _data["creditorOrDebtorIdentifier"];
            this.globalLocationNumber = _data["globalLocationNumber"];
            if (Array.isArray(_data["bankingInformation"])) {
                this.bankingInformation = [];
                for (let item of _data["bankingInformation"])
                    this.bankingInformation.push(BankingInformationDto.fromJS(item));
            }
            this.registrationNumber = _data["registrationNumber"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PartyInformationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["street"] = this.street;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["identifier"] = this.identifier;
        data["remarks"] = this.remarks;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["contactPersonName"] = this.contactPersonName;
        data["awardIdentifier"] = this.awardIdentifier;
        data["isInEuropeanEconomicArea"] = this.isInEuropeanEconomicArea;
        data["vatId"] = this.vatId;
        data["fax"] = this.fax;
        data["countryCode"] = this.countryCode;
        data["creditorOrDebtorIdentifier"] = this.creditorOrDebtorIdentifier;
        data["globalLocationNumber"] = this.globalLocationNumber;
        if (Array.isArray(this.bankingInformation)) {
            data["bankingInformation"] = [];
            for (let item of this.bankingInformation)
                data["bankingInformation"].push(item.toJSON());
        }
        data["registrationNumber"] = this.registrationNumber;
        return data;
    }
}
exports.PartyInformationDto = PartyInformationDto;
/** This is a class that represents the information about a bank connection. It is usually used within a PartyInformation. */
class BankingInformationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.iban = _data["iban"];
            this.accountNumber = _data["accountNumber"];
            this.bic = _data["bic"];
            this.routingNumber = _data["routingNumber"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BankingInformationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["iban"] = this.iban;
        data["accountNumber"] = this.accountNumber;
        data["bic"] = this.bic;
        data["routingNumber"] = this.routingNumber;
        return data;
    }
}
exports.BankingInformationDto = BankingInformationDto;
/** The schema for ItemNumber's in a Project. */
class ItemNumberSchemaDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.tiers) {
                this.tiers = [];
                for (let i = 0; i < data.tiers.length; i++) {
                    let item = data.tiers[i];
                    this.tiers[i] = item && !item.toJSON ? new ItemNumberSchemaTierDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalLength = _data["totalLength"];
            if (Array.isArray(_data["tiers"])) {
                this.tiers = [];
                for (let item of _data["tiers"])
                    this.tiers.push(ItemNumberSchemaTierDto.fromJS(item));
            }
            this.separator = _data["separator"];
            this.filler = _data["filler"];
            this.identifier = _data["identifier"];
            this.skipNonExistingLevelsInPositionItemNumbers = _data["skipNonExistingLevelsInPositionItemNumbers"];
            this.skippedTiersFiller = _data["skippedTiersFiller"];
            this.schemaIsCorrectlyDefined = _data["schemaIsCorrectlyDefined"];
            this.allowUpperCaseLettering = _data["allowUpperCaseLettering"];
            this.disableLeftPaddingTiersWithFiller = _data["disableLeftPaddingTiersWithFiller"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemNumberSchemaDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalLength"] = this.totalLength;
        if (Array.isArray(this.tiers)) {
            data["tiers"] = [];
            for (let item of this.tiers)
                data["tiers"].push(item.toJSON());
        }
        data["separator"] = this.separator;
        data["filler"] = this.filler;
        data["identifier"] = this.identifier;
        data["skipNonExistingLevelsInPositionItemNumbers"] = this.skipNonExistingLevelsInPositionItemNumbers;
        data["skippedTiersFiller"] = this.skippedTiersFiller;
        data["schemaIsCorrectlyDefined"] = this.schemaIsCorrectlyDefined;
        data["allowUpperCaseLettering"] = this.allowUpperCaseLettering;
        data["disableLeftPaddingTiersWithFiller"] = this.disableLeftPaddingTiersWithFiller;
        return data;
    }
}
exports.ItemNumberSchemaDto = ItemNumberSchemaDto;
/** Represents information about a single Tier in an ItemNumber. */
class ItemNumberSchemaTierDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.length = _data["length"];
            this.type = _data["type"];
            this.tierType = _data["tierType"];
            this.isLot = _data["isLot"];
            this.increment = _data["increment"];
            this.tierName = _data["tierName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemNumberSchemaTierDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length;
        data["type"] = this.type;
        data["tierType"] = this.tierType;
        data["isLot"] = this.isLot;
        data["increment"] = this.increment;
        data["tierName"] = this.tierName;
        return data;
    }
}
exports.ItemNumberSchemaTierDto = ItemNumberSchemaTierDto;
/** Determines the type of an ItemNumberSchema */
var ItemNumberTypeDto;
(function (ItemNumberTypeDto) {
    ItemNumberTypeDto["Numeric"] = "Numeric";
    ItemNumberTypeDto["Alphanumeric"] = "Alphanumeric";
})(ItemNumberTypeDto = exports.ItemNumberTypeDto || (exports.ItemNumberTypeDto = {}));
/** Specifies the type an ItemNumberSchemaTier represents. For example, a tier may indicate to be used for positions or for groups. */
var ItemNumberSchemaTierTypeDto;
(function (ItemNumberSchemaTierTypeDto) {
    ItemNumberSchemaTierTypeDto["Undefined"] = "Undefined";
    ItemNumberSchemaTierTypeDto["Index"] = "Index";
    ItemNumberSchemaTierTypeDto["Position"] = "Position";
    ItemNumberSchemaTierTypeDto["Group"] = "Group";
    ItemNumberSchemaTierTypeDto["Lot"] = "Lot";
})(ItemNumberSchemaTierTypeDto = exports.ItemNumberSchemaTierTypeDto || (exports.ItemNumberSchemaTierTypeDto = {}));
/** This enumeration models types of price components for better classification. */
var PriceComponentTypeDto;
(function (PriceComponentTypeDto) {
    PriceComponentTypeDto["Unknown"] = "Unknown";
    PriceComponentTypeDto["Wages"] = "Wages";
    PriceComponentTypeDto["Materials"] = "Materials";
    PriceComponentTypeDto["Plant"] = "Plant";
    PriceComponentTypeDto["Miscellaneous"] = "Miscellaneous";
})(PriceComponentTypeDto = exports.PriceComponentTypeDto || (exports.PriceComponentTypeDto = {}));
/** This enumeration describes the type of the award / procurement process. If this is used in a GAEB context, more information about award types can be found in the German VOB/A rules and the GAEB standard */
var AwardTypeDto;
(function (AwardTypeDto) {
    AwardTypeDto["Unspecified"] = "Unspecified";
    AwardTypeDto["OpenProcurement"] = "OpenProcurement";
    AwardTypeDto["ClosedProducrement"] = "ClosedProducrement";
    AwardTypeDto["NegotiationProcurementWithoutPublicAnnouncement"] = "NegotiationProcurementWithoutPublicAnnouncement";
    AwardTypeDto["NegotiationProcurement"] = "NegotiationProcurement";
    AwardTypeDto["OpenCall"] = "OpenCall";
    AwardTypeDto["SelectedCallWithoutPublicCompetition"] = "SelectedCallWithoutPublicCompetition";
    AwardTypeDto["SelectedCall"] = "SelectedCall";
    AwardTypeDto["DirectAward"] = "DirectAward";
    AwardTypeDto["InternationalNATOProcurement"] = "InternationalNATOProcurement";
    AwardTypeDto["CompetitiveDialog"] = "CompetitiveDialog";
})(AwardTypeDto = exports.AwardTypeDto || (exports.AwardTypeDto = {}));
/** This enumeration describes awards for project that are not just a regular procurement. For example, it can be used to describe recurring maintenance or an outline contract (German: Rahmenvertrag) which just specifies services and prices but may be requested on demand when necessary */
var SpecialAwardKindDto;
(function (SpecialAwardKindDto) {
    SpecialAwardKindDto["Unspecified"] = "Unspecified";
    SpecialAwardKindDto["MaintenanceContract"] = "MaintenanceContract";
    SpecialAwardKindDto["OutlineContract"] = "OutlineContract";
    SpecialAwardKindDto["OutlineForMaintenanceContract"] = "OutlineForMaintenanceContract";
})(SpecialAwardKindDto = exports.SpecialAwardKindDto || (exports.SpecialAwardKindDto = {}));
/** This is the base class that holds information about a whole service specification. */
class ServiceSpecificationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.projectItemNumberSchema = data.projectItemNumberSchema && !data.projectItemNumberSchema.toJSON ? new ItemNumberSchemaDto(data.projectItemNumberSchema) : this.projectItemNumberSchema;
            if (data.totalPriceGrossByTaxRate) {
                this.totalPriceGrossByTaxRate = [];
                for (let i = 0; i < data.totalPriceGrossByTaxRate.length; i++) {
                    let item = data.totalPriceGrossByTaxRate[i];
                    this.totalPriceGrossByTaxRate[i] = item && !item.toJSON ? new GrossPriceComponentDto(item) : item;
                }
            }
            this.bidder = data.bidder && !data.bidder.toJSON ? new PartyInformationDto(data.bidder) : this.bidder;
            this.projectInformation = data.projectInformation && !data.projectInformation.toJSON ? new ProjectInformationDto(data.projectInformation) : this.projectInformation;
            this.priceInformation = data.priceInformation && !data.priceInformation.toJSON ? new PriceInformationDto(data.priceInformation) : this.priceInformation;
            if (data.projectCatalogues) {
                this.projectCatalogues = [];
                for (let i = 0; i < data.projectCatalogues.length; i++) {
                    let item = data.projectCatalogues[i];
                    this.projectCatalogues[i] = item && !item.toJSON ? new CatalogueDto(item) : item;
                }
            }
            if (data.catalogueReferences) {
                this.catalogueReferences = [];
                for (let i = 0; i < data.catalogueReferences.length; i++) {
                    let item = data.catalogueReferences[i];
                    this.catalogueReferences[i] = item && !item.toJSON ? new CatalogueReferenceDto(item) : item;
                }
            }
            this.warrantyDuration = data.warrantyDuration && !data.warrantyDuration.toJSON ? new WarrantyDurationDto(data.warrantyDuration) : this.warrantyDuration;
            this.commerceProperties = data.commerceProperties && !data.commerceProperties.toJSON ? new ServiceSpecificationCommercePropertiesDto(data.commerceProperties) : this.commerceProperties;
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectHourlyWage = _data["projectHourlyWage"];
            this.projectTaxRate = _data["projectTaxRate"];
            if (Array.isArray(_data["projectPriceComponents"])) {
                this.projectPriceComponents = [];
                for (let item of _data["projectPriceComponents"])
                    this.projectPriceComponents.push(item);
            }
            this.projectItemNumberSchema = _data["projectItemNumberSchema"] ? ItemNumberSchemaDto.fromJS(_data["projectItemNumberSchema"]) : undefined;
            if (Array.isArray(_data["elements"])) {
                this.elements = [];
                for (let item of _data["elements"])
                    this.elements.push(IElementDto.fromJS(item));
            }
            this.projectLabourTimeLabel = _data["projectLabourTimeLabel"];
            this.containsDuplicateItemNumbers = _data["containsDuplicateItemNumbers"];
            this.containsDuplicateElementIds = _data["containsDuplicateElementIds"];
            this.ignoreDuplicateItemNumbers = _data["ignoreDuplicateItemNumbers"];
            this.ignoreProjectCataloguePropagation = _data["ignoreProjectCataloguePropagation"];
            this.ignoreDuplicateElementIds = _data["ignoreDuplicateElementIds"];
            if (Array.isArray(_data["totalPriceGrossByTaxRate"])) {
                this.totalPriceGrossByTaxRate = [];
                for (let item of _data["totalPriceGrossByTaxRate"])
                    this.totalPriceGrossByTaxRate.push(GrossPriceComponentDto.fromJS(item));
            }
            this.ignoreChildPriceUpdates = _data["ignoreChildPriceUpdates"];
            this.deductedPrice = _data["deductedPrice"];
            this.deductionFactor = _data["deductionFactor"];
            this.absoluteDeduction = _data["absoluteDeduction"];
            this.totalPrice = _data["totalPrice"];
            this.totalPriceGross = _data["totalPriceGross"];
            this.totalPriceGrossDeducted = _data["totalPriceGrossDeducted"];
            this.priceType = _data["priceType"];
            this.bidder = _data["bidder"] ? PartyInformationDto.fromJS(_data["bidder"]) : undefined;
            this.bidderDiscriminator = _data["bidderDiscriminator"];
            this.gaebXmlId = _data["gaebXmlId"];
            this.projectInformation = _data["projectInformation"] ? ProjectInformationDto.fromJS(_data["projectInformation"]) : undefined;
            this.exchangePhase = _data["exchangePhase"];
            this.origin = _data["origin"];
            this.originDetail = _data["originDetail"];
            this.creationDate = _data["creationDate"] ? new Date(_data["creationDate"].toString()) : undefined;
            this.offerByDate = _data["offerByDate"] ? new Date(_data["offerByDate"].toString()) : undefined;
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : undefined;
            this.bidDate = _data["bidDate"] ? new Date(_data["bidDate"].toString()) : undefined;
            this.warrantyBondPercentage = _data["warrantyBondPercentage"];
            this.executionGuaranteePercentage = _data["executionGuaranteePercentage"];
            this.submissionLocation = _data["submissionLocation"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.priceInformation = _data["priceInformation"] ? PriceInformationDto.fromJS(_data["priceInformation"]) : undefined;
            if (Array.isArray(_data["projectCatalogues"])) {
                this.projectCatalogues = [];
                for (let item of _data["projectCatalogues"])
                    this.projectCatalogues.push(CatalogueDto.fromJS(item));
            }
            if (Array.isArray(_data["catalogueReferences"])) {
                this.catalogueReferences = [];
                for (let item of _data["catalogueReferences"])
                    this.catalogueReferences.push(CatalogueReferenceDto.fromJS(item));
            }
            this.plannedExecutionStart = _data["plannedExecutionStart"] ? new Date(_data["plannedExecutionStart"].toString()) : undefined;
            this.plannedExecutionEnd = _data["plannedExecutionEnd"] ? new Date(_data["plannedExecutionEnd"].toString()) : undefined;
            this.contractDate = _data["contractDate"] ? new Date(_data["contractDate"].toString()) : undefined;
            this.contractIdentifier = _data["contractIdentifier"];
            this.warrantyDuration = _data["warrantyDuration"] ? WarrantyDurationDto.fromJS(_data["warrantyDuration"]) : undefined;
            this.warrantyEnd = _data["warrantyEnd"] ? new Date(_data["warrantyEnd"].toString()) : undefined;
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : undefined;
            this.typeOfApproval = _data["typeOfApproval"];
            this.addendumNumber = _data["addendumNumber"];
            this.addendumStatus = _data["addendumStatus"];
            this.commerceProperties = _data["commerceProperties"] ? ServiceSpecificationCommercePropertiesDto.fromJS(_data["commerceProperties"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSpecificationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectHourlyWage"] = this.projectHourlyWage;
        data["projectTaxRate"] = this.projectTaxRate;
        if (Array.isArray(this.projectPriceComponents)) {
            data["projectPriceComponents"] = [];
            for (let item of this.projectPriceComponents)
                data["projectPriceComponents"].push(item);
        }
        data["projectItemNumberSchema"] = this.projectItemNumberSchema ? this.projectItemNumberSchema.toJSON() : undefined;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["projectLabourTimeLabel"] = this.projectLabourTimeLabel;
        data["containsDuplicateItemNumbers"] = this.containsDuplicateItemNumbers;
        data["containsDuplicateElementIds"] = this.containsDuplicateElementIds;
        data["ignoreDuplicateItemNumbers"] = this.ignoreDuplicateItemNumbers;
        data["ignoreProjectCataloguePropagation"] = this.ignoreProjectCataloguePropagation;
        data["ignoreDuplicateElementIds"] = this.ignoreDuplicateElementIds;
        if (Array.isArray(this.totalPriceGrossByTaxRate)) {
            data["totalPriceGrossByTaxRate"] = [];
            for (let item of this.totalPriceGrossByTaxRate)
                data["totalPriceGrossByTaxRate"].push(item.toJSON());
        }
        data["ignoreChildPriceUpdates"] = this.ignoreChildPriceUpdates;
        data["deductedPrice"] = this.deductedPrice;
        data["deductionFactor"] = this.deductionFactor;
        data["absoluteDeduction"] = this.absoluteDeduction;
        data["totalPrice"] = this.totalPrice;
        data["totalPriceGross"] = this.totalPriceGross;
        data["totalPriceGrossDeducted"] = this.totalPriceGrossDeducted;
        data["priceType"] = this.priceType;
        data["bidder"] = this.bidder ? this.bidder.toJSON() : undefined;
        data["bidderDiscriminator"] = this.bidderDiscriminator;
        data["gaebXmlId"] = this.gaebXmlId;
        data["projectInformation"] = this.projectInformation ? this.projectInformation.toJSON() : undefined;
        data["exchangePhase"] = this.exchangePhase;
        data["origin"] = this.origin;
        data["originDetail"] = this.originDetail;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined;
        data["offerByDate"] = this.offerByDate ? this.offerByDate.toISOString() : undefined;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : undefined;
        data["bidDate"] = this.bidDate ? this.bidDate.toISOString() : undefined;
        data["warrantyBondPercentage"] = this.warrantyBondPercentage;
        data["executionGuaranteePercentage"] = this.executionGuaranteePercentage;
        data["submissionLocation"] = this.submissionLocation;
        data["description"] = this.description;
        data["name"] = this.name;
        data["priceInformation"] = this.priceInformation ? this.priceInformation.toJSON() : undefined;
        if (Array.isArray(this.projectCatalogues)) {
            data["projectCatalogues"] = [];
            for (let item of this.projectCatalogues)
                data["projectCatalogues"].push(item.toJSON());
        }
        if (Array.isArray(this.catalogueReferences)) {
            data["catalogueReferences"] = [];
            for (let item of this.catalogueReferences)
                data["catalogueReferences"].push(item.toJSON());
        }
        data["plannedExecutionStart"] = this.plannedExecutionStart ? this.plannedExecutionStart.toISOString() : undefined;
        data["plannedExecutionEnd"] = this.plannedExecutionEnd ? this.plannedExecutionEnd.toISOString() : undefined;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : undefined;
        data["contractIdentifier"] = this.contractIdentifier;
        data["warrantyDuration"] = this.warrantyDuration ? this.warrantyDuration.toJSON() : undefined;
        data["warrantyEnd"] = this.warrantyEnd ? this.warrantyEnd.toISOString() : undefined;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : undefined;
        data["typeOfApproval"] = this.typeOfApproval;
        data["addendumNumber"] = this.addendumNumber;
        data["addendumStatus"] = this.addendumStatus;
        data["commerceProperties"] = this.commerceProperties ? this.commerceProperties.toJSON() : undefined;
        return data;
    }
}
exports.ServiceSpecificationDto = ServiceSpecificationDto;
/** Base interface definition for elements within an ElementContainerBase. */
class IElementDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.projectCatalogues) {
                this.projectCatalogues = [];
                for (let i = 0; i < data.projectCatalogues.length; i++) {
                    let item = data.projectCatalogues[i];
                    this.projectCatalogues[i] = item && !item.toJSON ? new CatalogueDto(item) : item;
                }
            }
            if (data.catalogueReferences) {
                this.catalogueReferences = [];
                for (let i = 0; i < data.catalogueReferences.length; i++) {
                    let item = data.catalogueReferences[i];
                    this.catalogueReferences[i] = item && !item.toJSON ? new CatalogueReferenceDto(item) : item;
                }
            }
        }
        this._discriminator = "IElementDto";
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.gaebXmlId = _data["gaebXmlId"];
            this.addendumNumber = _data["addendumNumber"];
            if (Array.isArray(_data["projectCatalogues"])) {
                this.projectCatalogues = [];
                for (let item of _data["projectCatalogues"])
                    this.projectCatalogues.push(CatalogueDto.fromJS(item));
            }
            if (Array.isArray(_data["catalogueReferences"])) {
                this.catalogueReferences = [];
                for (let item of _data["catalogueReferences"])
                    this.catalogueReferences.push(CatalogueReferenceDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        if (data["elementTypeDiscriminator"] === "PositionDto") {
            let result = new PositionDto();
            result.init(data);
            return result;
        }
        if (data["elementTypeDiscriminator"] === "ExecutionDescriptionDto") {
            let result = new ExecutionDescriptionDto();
            result.init(data);
            return result;
        }
        if (data["elementTypeDiscriminator"] === "NoteTextDto") {
            let result = new NoteTextDto();
            result.init(data);
            return result;
        }
        if (data["elementTypeDiscriminator"] === "ServiceSpecificationGroupDto") {
            let result = new ServiceSpecificationGroupDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'IElementDto' cannot be instantiated.");
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["elementTypeDiscriminator"] = this._discriminator;
        data["id"] = this.id;
        data["gaebXmlId"] = this.gaebXmlId;
        data["addendumNumber"] = this.addendumNumber;
        if (Array.isArray(this.projectCatalogues)) {
            data["projectCatalogues"] = [];
            for (let item of this.projectCatalogues)
                data["projectCatalogues"].push(item.toJSON());
        }
        if (Array.isArray(this.catalogueReferences)) {
            data["catalogueReferences"] = [];
            for (let item of this.catalogueReferences)
                data["catalogueReferences"].push(item.toJSON());
        }
        return data;
    }
}
exports.IElementDto = IElementDto;
/** This class describes an external catalogue. Catalogues, or collections, hold information to categorize and describe items. For example, the German DIN 276 cost group standards describe different types of costs for building projects. When referencing the DIN 276 catalogue and providing an item key or identifier, it is possible to reference data in this catalogue. */
class CatalogueDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.gaebXmlId = _data["gaebXmlId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.catalogueType = _data["catalogueType"];
            this.catalogueTypeDetail = _data["catalogueTypeDetail"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogueDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gaebXmlId"] = this.gaebXmlId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["catalogueType"] = this.catalogueType;
        data["catalogueTypeDetail"] = this.catalogueTypeDetail;
        return data;
    }
}
exports.CatalogueDto = CatalogueDto;
/** This enumeration describes the type of a catalogue. Catalogues, or collections, hold information to categorize and describe items. For example, the German DIN 276 cost group standards describe different types of costs for building projects. When referencing the DIN 276 catalogue and providing an item key or identifier, it is possible to reference data in this catalogue. */
var CatalogueTypeDto;
(function (CatalogueTypeDto) {
    CatalogueTypeDto["Unknown"] = "Unknown";
    CatalogueTypeDto["Location"] = "Location";
    CatalogueTypeDto["DIN276"] = "DIN276";
    CatalogueTypeDto["CostUnit"] = "CostUnit";
    CatalogueTypeDto["WorkCategory"] = "WorkCategory";
    CatalogueTypeDto["OenormB1801CostGroup"] = "OenormB1801CostGroup";
    CatalogueTypeDto["BIM"] = "BIM";
    CatalogueTypeDto["Attachment"] = "Attachment";
})(CatalogueTypeDto = exports.CatalogueTypeDto || (exports.CatalogueTypeDto = {}));
/** This class is used to link data between catalogues and objects. */
class CatalogueReferenceDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.projectCatalogues) {
                this.projectCatalogues = [];
                for (let i = 0; i < data.projectCatalogues.length; i++) {
                    let item = data.projectCatalogues[i];
                    this.projectCatalogues[i] = item && !item.toJSON ? new CatalogueDto(item) : item;
                }
            }
            this.catalogue = data.catalogue && !data.catalogue.toJSON ? new CatalogueDto(data.catalogue) : this.catalogue;
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.catalogueReferenceKey = _data["catalogueReferenceKey"];
            this.catalogueReferenceId = _data["catalogueReferenceId"];
            if (Array.isArray(_data["projectCatalogues"])) {
                this.projectCatalogues = [];
                for (let item of _data["projectCatalogues"])
                    this.projectCatalogues.push(CatalogueDto.fromJS(item));
            }
            this.catalogue = _data["catalogue"] ? CatalogueDto.fromJS(_data["catalogue"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogueReferenceDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["catalogueReferenceKey"] = this.catalogueReferenceKey;
        data["catalogueReferenceId"] = this.catalogueReferenceId;
        if (Array.isArray(this.projectCatalogues)) {
            data["projectCatalogues"] = [];
            for (let item of this.projectCatalogues)
                data["projectCatalogues"].push(item.toJSON());
        }
        data["catalogue"] = this.catalogue ? this.catalogue.toJSON() : undefined;
        return data;
    }
}
exports.CatalogueReferenceDto = CatalogueReferenceDto;
/** A Position is the main item type in a ServiceSpecification, holding information about tasks to be done, their prices, description, amounts etc. */
class PositionDto extends IElementDto {
    constructor(data) {
        super(data);
        if (data) {
            this.labourComponents = data.labourComponents && !data.labourComponents.toJSON ? new LabourPriceComponentDto(data.labourComponents) : this.labourComponents;
            if (data.priceComponents) {
                this.priceComponents = [];
                for (let i = 0; i < data.priceComponents.length; i++) {
                    let item = data.priceComponents[i];
                    this.priceComponents[i] = item && !item.toJSON ? new PriceComponentDto(item) : item;
                }
            }
            if (data.quantityComponents) {
                this.quantityComponents = [];
                for (let i = 0; i < data.quantityComponents.length; i++) {
                    let item = data.quantityComponents[i];
                    this.quantityComponents[i] = item && !item.toJSON ? new CalculationDto(item) : item;
                }
            }
            if (data.subDescriptions) {
                this.subDescriptions = [];
                for (let i = 0; i < data.subDescriptions.length; i++) {
                    let item = data.subDescriptions[i];
                    this.subDescriptions[i] = item && !item.toJSON ? new SubDescriptionDto(item) : item;
                }
            }
            this.itemNumber = data.itemNumber && !data.itemNumber.toJSON ? new ItemNumberDto(data.itemNumber) : this.itemNumber;
            this.productData = data.productData && !data.productData.toJSON ? new ProductDataDto(data.productData) : this.productData;
            if (data.quantityAssignments) {
                this.quantityAssignments = [];
                for (let i = 0; i < data.quantityAssignments.length; i++) {
                    let item = data.quantityAssignments[i];
                    this.quantityAssignments[i] = item && !item.toJSON ? new QuantityAssignmentDto(item) : item;
                }
            }
            this.commerceProperties = data.commerceProperties && !data.commerceProperties.toJSON ? new CommercePropertiesDto(data.commerceProperties) : this.commerceProperties;
            this.standardizedDescription = data.standardizedDescription && !data.standardizedDescription.toJSON ? new StandardizedDescriptionDto(data.standardizedDescription) : this.standardizedDescription;
            if (data.complementedByQuantities) {
                this.complementedByQuantities = [];
                for (let i = 0; i < data.complementedByQuantities.length; i++) {
                    let item = data.complementedByQuantities[i];
                    this.complementedByQuantities[i] = item && !item.toJSON ? new ComplementedByQuantityDto(item) : item;
                }
            }
            this.oenormPositionProperties = data.oenormPositionProperties && !data.oenormPositionProperties.toJSON ? new OenormPositionPropertiesDto(data.oenormPositionProperties) : this.oenormPositionProperties;
            this.holdOutProperties = data.holdOutProperties && !data.holdOutProperties.toJSON ? new PositionHoldOutPropertiesDto(data.holdOutProperties) : this.holdOutProperties;
            this.priceCatalogueData = data.priceCatalogueData && !data.priceCatalogueData.toJSON ? new PriceCatalogueDataDto(data.priceCatalogueData) : this.priceCatalogueData;
        }
        this._discriminator = "PositionDto";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.unitPrice = _data["unitPrice"];
            this.unitPriceOverride = _data["unitPriceOverride"];
            this.quantity = _data["quantity"];
            this.quantityOverride = _data["quantityOverride"];
            this.isComplementingPosition = _data["isComplementingPosition"];
            if (Array.isArray(_data["complementsPositions"])) {
                this.complementsPositions = [];
                for (let item of _data["complementsPositions"])
                    this.complementsPositions.push(item);
            }
            this.complementingPricePercentageOverride = _data["complementingPricePercentageOverride"];
            this.complementingPricePercentage = _data["complementingPricePercentage"];
            this.unitTag = _data["unitTag"];
            this.labourComponents = _data["labourComponents"] ? LabourPriceComponentDto.fromJS(_data["labourComponents"]) : undefined;
            if (Array.isArray(_data["priceComponents"])) {
                this.priceComponents = [];
                for (let item of _data["priceComponents"])
                    this.priceComponents.push(PriceComponentDto.fromJS(item));
            }
            if (Array.isArray(_data["quantityComponents"])) {
                this.quantityComponents = [];
                for (let item of _data["quantityComponents"])
                    this.quantityComponents.push(CalculationDto.fromJS(item));
            }
            if (Array.isArray(_data["subDescriptions"])) {
                this.subDescriptions = [];
                for (let item of _data["subDescriptions"])
                    this.subDescriptions.push(SubDescriptionDto.fromJS(item));
            }
            this.comissionStatus = _data["comissionStatus"];
            if (Array.isArray(_data["complementedBy"])) {
                this.complementedBy = [];
                for (let item of _data["complementedBy"])
                    this.complementedBy.push(item);
            }
            this.complemented = _data["complemented"];
            this.amountToBeEnteredByBidder = _data["amountToBeEnteredByBidder"];
            this.priceCompositionRequired = _data["priceCompositionRequired"];
            this.useDifferentTaxRate = _data["useDifferentTaxRate"];
            this.taxRate = _data["taxRate"];
            this.itemNumber = _data["itemNumber"] ? ItemNumberDto.fromJS(_data["itemNumber"]) : undefined;
            this.deductionFactor = _data["deductionFactor"];
            this.totalPrice = _data["totalPrice"];
            this.totalPriceGross = _data["totalPriceGross"];
            this.totalPriceGrossDeducted = _data["totalPriceGrossDeducted"];
            this.deductedPrice = _data["deductedPrice"];
            this.positionType = _data["positionType"];
            this.priceType = _data["priceType"];
            this.serviceType = _data["serviceType"];
            this.productData = _data["productData"] ? ProductDataDto.fromJS(_data["productData"]) : undefined;
            this.shortText = _data["shortText"];
            this.longText = _data["longText"];
            this.htmlLongText = _data["htmlLongText"];
            this.additionType = _data["additionType"];
            this.elementType = _data["elementType"];
            if (Array.isArray(_data["quantityAssignments"])) {
                this.quantityAssignments = [];
                for (let item of _data["quantityAssignments"])
                    this.quantityAssignments.push(QuantityAssignmentDto.fromJS(item));
            }
            this.commerceProperties = _data["commerceProperties"] ? CommercePropertiesDto.fromJS(_data["commerceProperties"]) : undefined;
            this.alternativeTo = _data["alternativeTo"];
            this.alternativeIdentifier = _data["alternativeIdentifier"];
            this.alternativeGroupIdentifier = _data["alternativeGroupIdentifier"];
            this.isLumpSum = _data["isLumpSum"];
            this.repetitionTo = _data["repetitionTo"];
            this.standardizedDescription = _data["standardizedDescription"] ? StandardizedDescriptionDto.fromJS(_data["standardizedDescription"]) : undefined;
            if (Array.isArray(_data["complementedByQuantities"])) {
                this.complementedByQuantities = [];
                for (let item of _data["complementedByQuantities"])
                    this.complementedByQuantities.push(ComplementedByQuantityDto.fromJS(item));
            }
            this.executionDescriptionReference = _data["executionDescriptionReference"];
            this.notOffered = _data["notOffered"];
            this.oenormPositionProperties = _data["oenormPositionProperties"] ? OenormPositionPropertiesDto.fromJS(_data["oenormPositionProperties"]) : undefined;
            this.descriptionId = _data["descriptionId"];
            this.hierarchyLevel = _data["hierarchyLevel"];
            this.addendumStatus = _data["addendumStatus"];
            this.hasBidderCommentInHtmlLongText = _data["hasBidderCommentInHtmlLongText"];
            this.gaebComplementingType = _data["gaebComplementingType"];
            this.holdOutProperties = _data["holdOutProperties"] ? PositionHoldOutPropertiesDto.fromJS(_data["holdOutProperties"]) : undefined;
            this.estimatedQuantity = _data["estimatedQuantity"];
            this.priceCatalogueData = _data["priceCatalogueData"] ? PriceCatalogueDataDto.fromJS(_data["priceCatalogueData"]) : undefined;
            this.ignoreProjectCataloguePropagation = _data["ignoreProjectCataloguePropagation"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["unitPrice"] = this.unitPrice;
        data["unitPriceOverride"] = this.unitPriceOverride;
        data["quantity"] = this.quantity;
        data["quantityOverride"] = this.quantityOverride;
        data["isComplementingPosition"] = this.isComplementingPosition;
        if (Array.isArray(this.complementsPositions)) {
            data["complementsPositions"] = [];
            for (let item of this.complementsPositions)
                data["complementsPositions"].push(item);
        }
        data["complementingPricePercentageOverride"] = this.complementingPricePercentageOverride;
        data["complementingPricePercentage"] = this.complementingPricePercentage;
        data["unitTag"] = this.unitTag;
        data["labourComponents"] = this.labourComponents ? this.labourComponents.toJSON() : undefined;
        if (Array.isArray(this.priceComponents)) {
            data["priceComponents"] = [];
            for (let item of this.priceComponents)
                data["priceComponents"].push(item.toJSON());
        }
        if (Array.isArray(this.quantityComponents)) {
            data["quantityComponents"] = [];
            for (let item of this.quantityComponents)
                data["quantityComponents"].push(item.toJSON());
        }
        if (Array.isArray(this.subDescriptions)) {
            data["subDescriptions"] = [];
            for (let item of this.subDescriptions)
                data["subDescriptions"].push(item.toJSON());
        }
        data["comissionStatus"] = this.comissionStatus;
        if (Array.isArray(this.complementedBy)) {
            data["complementedBy"] = [];
            for (let item of this.complementedBy)
                data["complementedBy"].push(item);
        }
        data["complemented"] = this.complemented;
        data["amountToBeEnteredByBidder"] = this.amountToBeEnteredByBidder;
        data["priceCompositionRequired"] = this.priceCompositionRequired;
        data["useDifferentTaxRate"] = this.useDifferentTaxRate;
        data["taxRate"] = this.taxRate;
        data["itemNumber"] = this.itemNumber ? this.itemNumber.toJSON() : undefined;
        data["deductionFactor"] = this.deductionFactor;
        data["totalPrice"] = this.totalPrice;
        data["totalPriceGross"] = this.totalPriceGross;
        data["totalPriceGrossDeducted"] = this.totalPriceGrossDeducted;
        data["deductedPrice"] = this.deductedPrice;
        data["positionType"] = this.positionType;
        data["priceType"] = this.priceType;
        data["serviceType"] = this.serviceType;
        data["productData"] = this.productData ? this.productData.toJSON() : undefined;
        data["shortText"] = this.shortText;
        data["longText"] = this.longText;
        data["htmlLongText"] = this.htmlLongText;
        data["additionType"] = this.additionType;
        data["elementType"] = this.elementType;
        if (Array.isArray(this.quantityAssignments)) {
            data["quantityAssignments"] = [];
            for (let item of this.quantityAssignments)
                data["quantityAssignments"].push(item.toJSON());
        }
        data["commerceProperties"] = this.commerceProperties ? this.commerceProperties.toJSON() : undefined;
        data["alternativeTo"] = this.alternativeTo;
        data["alternativeIdentifier"] = this.alternativeIdentifier;
        data["alternativeGroupIdentifier"] = this.alternativeGroupIdentifier;
        data["isLumpSum"] = this.isLumpSum;
        data["repetitionTo"] = this.repetitionTo;
        data["standardizedDescription"] = this.standardizedDescription ? this.standardizedDescription.toJSON() : undefined;
        if (Array.isArray(this.complementedByQuantities)) {
            data["complementedByQuantities"] = [];
            for (let item of this.complementedByQuantities)
                data["complementedByQuantities"].push(item.toJSON());
        }
        data["executionDescriptionReference"] = this.executionDescriptionReference;
        data["notOffered"] = this.notOffered;
        data["oenormPositionProperties"] = this.oenormPositionProperties ? this.oenormPositionProperties.toJSON() : undefined;
        data["descriptionId"] = this.descriptionId;
        data["hierarchyLevel"] = this.hierarchyLevel;
        data["addendumStatus"] = this.addendumStatus;
        data["hasBidderCommentInHtmlLongText"] = this.hasBidderCommentInHtmlLongText;
        data["gaebComplementingType"] = this.gaebComplementingType;
        data["holdOutProperties"] = this.holdOutProperties ? this.holdOutProperties.toJSON() : undefined;
        data["estimatedQuantity"] = this.estimatedQuantity;
        data["priceCatalogueData"] = this.priceCatalogueData ? this.priceCatalogueData.toJSON() : undefined;
        data["ignoreProjectCataloguePropagation"] = this.ignoreProjectCataloguePropagation;
        super.toJSON(data);
        return data;
    }
}
exports.PositionDto = PositionDto;
/** Based on the PriceComponent, this class is responsible for labour time components. */
class LabourPriceComponentDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.values) {
                this.values = [];
                for (let i = 0; i < data.values.length; i++) {
                    let item = data.values[i];
                    this.values[i] = item && !item.toJSON ? new CalculationDto(item) : item;
                }
            }
            if (data.projectCatalogues) {
                this.projectCatalogues = [];
                for (let i = 0; i < data.projectCatalogues.length; i++) {
                    let item = data.projectCatalogues[i];
                    this.projectCatalogues[i] = item && !item.toJSON ? new CatalogueDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.label = _data["label"];
            this.price = _data["price"];
            this.hourlyWage = _data["hourlyWage"];
            if (Array.isArray(_data["values"])) {
                this.values = [];
                for (let item of _data["values"])
                    this.values.push(CalculationDto.fromJS(item));
            }
            this.useOwnHourlyWage = _data["useOwnHourlyWage"];
            this.totalTime = _data["totalTime"];
            if (Array.isArray(_data["projectCatalogues"])) {
                this.projectCatalogues = [];
                for (let item of _data["projectCatalogues"])
                    this.projectCatalogues.push(CatalogueDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LabourPriceComponentDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["price"] = this.price;
        data["hourlyWage"] = this.hourlyWage;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["useOwnHourlyWage"] = this.useOwnHourlyWage;
        data["totalTime"] = this.totalTime;
        if (Array.isArray(this.projectCatalogues)) {
            data["projectCatalogues"] = [];
            for (let item of this.projectCatalogues)
                data["projectCatalogues"].push(item.toJSON());
        }
        return data;
    }
}
exports.LabourPriceComponentDto = LabourPriceComponentDto;
/** This class holds means to calculate mathematical expressions from given strings. */
class CalculationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.projectCatalogues) {
                this.projectCatalogues = [];
                for (let i = 0; i < data.projectCatalogues.length; i++) {
                    let item = data.projectCatalogues[i];
                    this.projectCatalogues[i] = item && !item.toJSON ? new CatalogueDto(item) : item;
                }
            }
            if (data.catalogueReferences) {
                this.catalogueReferences = [];
                for (let i = 0; i < data.catalogueReferences.length; i++) {
                    let item = data.catalogueReferences[i];
                    this.catalogueReferences[i] = item && !item.toJSON ? new CatalogueReferenceDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.description = _data["description"];
            this.formula = _data["formula"];
            this.result = _data["result"];
            this.valid = _data["valid"];
            this.errorPositionInLine = _data["errorPositionInLine"];
            if (Array.isArray(_data["projectCatalogues"])) {
                this.projectCatalogues = [];
                for (let item of _data["projectCatalogues"])
                    this.projectCatalogues.push(CatalogueDto.fromJS(item));
            }
            if (Array.isArray(_data["catalogueReferences"])) {
                this.catalogueReferences = [];
                for (let item of _data["catalogueReferences"])
                    this.catalogueReferences.push(CatalogueReferenceDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["formula"] = this.formula;
        data["result"] = this.result;
        data["valid"] = this.valid;
        data["errorPositionInLine"] = this.errorPositionInLine;
        if (Array.isArray(this.projectCatalogues)) {
            data["projectCatalogues"] = [];
            for (let item of this.projectCatalogues)
                data["projectCatalogues"].push(item.toJSON());
        }
        if (Array.isArray(this.catalogueReferences)) {
            data["catalogueReferences"] = [];
            for (let item of this.catalogueReferences)
                data["catalogueReferences"].push(item.toJSON());
        }
        return data;
    }
}
exports.CalculationDto = CalculationDto;
/** This class provides means to store information about a price and it's composition. Note that this is referencing to a single price component, so for example a Position would have a list of PriceComponents, one for Material, one for Labour etc. */
class PriceComponentDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.values) {
                this.values = [];
                for (let i = 0; i < data.values.length; i++) {
                    let item = data.values[i];
                    this.values[i] = item && !item.toJSON ? new CalculationDto(item) : item;
                }
            }
            if (data.projectCatalogues) {
                this.projectCatalogues = [];
                for (let i = 0; i < data.projectCatalogues.length; i++) {
                    let item = data.projectCatalogues[i];
                    this.projectCatalogues[i] = item && !item.toJSON ? new CatalogueDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.price = _data["price"];
            this.label = _data["label"];
            if (Array.isArray(_data["values"])) {
                this.values = [];
                for (let item of _data["values"])
                    this.values.push(CalculationDto.fromJS(item));
            }
            if (Array.isArray(_data["projectCatalogues"])) {
                this.projectCatalogues = [];
                for (let item of _data["projectCatalogues"])
                    this.projectCatalogues.push(CatalogueDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PriceComponentDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["label"] = this.label;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        if (Array.isArray(this.projectCatalogues)) {
            data["projectCatalogues"] = [];
            for (let item of this.projectCatalogues)
                data["projectCatalogues"].push(item.toJSON());
        }
        return data;
    }
}
exports.PriceComponentDto = PriceComponentDto;
/** This is appended to a Position and is used to separate the complete Position into smaller amounts to be described separately, for example concrete walls could be attached to different building storeys. */
class SubDescriptionDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.quantityComponents) {
                this.quantityComponents = [];
                for (let i = 0; i < data.quantityComponents.length; i++) {
                    let item = data.quantityComponents[i];
                    this.quantityComponents[i] = item && !item.toJSON ? new CalculationDto(item) : item;
                }
            }
            this.standardizedDescription = data.standardizedDescription && !data.standardizedDescription.toJSON ? new StandardizedDescriptionDto(data.standardizedDescription) : this.standardizedDescription;
            if (data.projectCatalogues) {
                this.projectCatalogues = [];
                for (let i = 0; i < data.projectCatalogues.length; i++) {
                    let item = data.projectCatalogues[i];
                    this.projectCatalogues[i] = item && !item.toJSON ? new CatalogueDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            this.quantityOverride = _data["quantityOverride"];
            if (Array.isArray(_data["quantityComponents"])) {
                this.quantityComponents = [];
                for (let item of _data["quantityComponents"])
                    this.quantityComponents.push(CalculationDto.fromJS(item));
            }
            this.amountToBeEnteredByBidder = _data["amountToBeEnteredByBidder"];
            this.identifier = _data["identifier"];
            this.shortText = _data["shortText"];
            this.longText = _data["longText"];
            this.unitTag = _data["unitTag"];
            this.htmlLongText = _data["htmlLongText"];
            this.additionType = _data["additionType"];
            this.standardizedDescription = _data["standardizedDescription"] ? StandardizedDescriptionDto.fromJS(_data["standardizedDescription"]) : undefined;
            this.executionDescriptionReference = _data["executionDescriptionReference"];
            if (Array.isArray(_data["projectCatalogues"])) {
                this.projectCatalogues = [];
                for (let item of _data["projectCatalogues"])
                    this.projectCatalogues.push(CatalogueDto.fromJS(item));
            }
            this.descriptionId = _data["descriptionId"];
            this.hasBidderCommentInHtmlLongText = _data["hasBidderCommentInHtmlLongText"];
            this.elementType = _data["elementType"];
            this.elementTypeDiscriminator = _data["elementTypeDiscriminator"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SubDescriptionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        data["quantityOverride"] = this.quantityOverride;
        if (Array.isArray(this.quantityComponents)) {
            data["quantityComponents"] = [];
            for (let item of this.quantityComponents)
                data["quantityComponents"].push(item.toJSON());
        }
        data["amountToBeEnteredByBidder"] = this.amountToBeEnteredByBidder;
        data["identifier"] = this.identifier;
        data["shortText"] = this.shortText;
        data["longText"] = this.longText;
        data["unitTag"] = this.unitTag;
        data["htmlLongText"] = this.htmlLongText;
        data["additionType"] = this.additionType;
        data["standardizedDescription"] = this.standardizedDescription ? this.standardizedDescription.toJSON() : undefined;
        data["executionDescriptionReference"] = this.executionDescriptionReference;
        if (Array.isArray(this.projectCatalogues)) {
            data["projectCatalogues"] = [];
            for (let item of this.projectCatalogues)
                data["projectCatalogues"].push(item.toJSON());
        }
        data["descriptionId"] = this.descriptionId;
        data["hasBidderCommentInHtmlLongText"] = this.hasBidderCommentInHtmlLongText;
        data["elementType"] = this.elementType;
        data["elementTypeDiscriminator"] = this.elementTypeDiscriminator;
        return data;
    }
}
exports.SubDescriptionDto = SubDescriptionDto;
/** Indicates the origin of an element. */
var AdditionTypeDto;
(function (AdditionTypeDto) {
    AdditionTypeDto["None"] = "None";
    AdditionTypeDto["ByBuyer"] = "ByBuyer";
    AdditionTypeDto["ByBidder"] = "ByBidder";
})(AdditionTypeDto = exports.AdditionTypeDto || (exports.AdditionTypeDto = {}));
/** This class represents a standardized description. This means that instead of solely relying on texts to describe a service, external standards and definitions are referenced for a common understanding. */
class StandardizedDescriptionDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.stlbReference = data.stlbReference && !data.stlbReference.toJSON ? new STLBReferenceDto(data.stlbReference) : this.stlbReference;
        }
    }
    init(_data) {
        if (_data) {
            this.standardReferenceType = _data["standardReferenceType"];
            this.standardReference = _data["standardReference"];
            this.stlbReference = _data["stlbReference"] ? STLBReferenceDto.fromJS(_data["stlbReference"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StandardizedDescriptionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["standardReferenceType"] = this.standardReferenceType;
        data["standardReference"] = this.standardReference;
        data["stlbReference"] = this.stlbReference ? this.stlbReference.toJSON() : undefined;
        return data;
    }
}
exports.StandardizedDescriptionDto = StandardizedDescriptionDto;
/** This enumeration identifies a pre-known standard used for referencing standardized descriptions. */
var StandardReferenceTypeDto;
(function (StandardReferenceTypeDto) {
    StandardReferenceTypeDto["Unknown"] = "Unknown";
    StandardReferenceTypeDto["StLB"] = "StLB";
    StandardReferenceTypeDto["StLK"] = "StLK";
    StandardReferenceTypeDto["STLBBauZ"] = "STLBBauZ";
})(StandardReferenceTypeDto = exports.StandardReferenceTypeDto || (exports.StandardReferenceTypeDto = {}));
/** This class represents a specialized reference to the German STLB "Standardleistungsbuch Bau". The STLB is a commercial offering and describes common services in the construction sector. When this is used, this describes the exact type of a service via a reference to this standard */
class STLBReferenceDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.keys) {
                this.keys = [];
                for (let i = 0; i < data.keys.length; i++) {
                    let item = data.keys[i];
                    this.keys[i] = item && !item.toJSON ? new STLBKeyDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.versionDate = _data["versionDate"] ? new Date(_data["versionDate"].toString()) : undefined;
            this.catalogueName = _data["catalogueName"];
            this.group = _data["group"];
            this.costGroup = _data["costGroup"];
            this.serviceArea = _data["serviceArea"];
            if (Array.isArray(_data["keys"])) {
                this.keys = [];
                for (let item of _data["keys"])
                    this.keys.push(STLBKeyDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new STLBReferenceDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["versionDate"] = this.versionDate ? this.versionDate.toISOString() : undefined;
        data["catalogueName"] = this.catalogueName;
        data["group"] = this.group;
        data["costGroup"] = this.costGroup;
        data["serviceArea"] = this.serviceArea;
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item of this.keys)
                data["keys"].push(item.toJSON());
        }
        return data;
    }
}
exports.STLBReferenceDto = STLBReferenceDto;
/** This class represents a single key reference within the German STLB "Standardleistungsbuch Bau" */
class STLBKeyDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.artIdentifier = _data["artIdentifier"];
            this.artIndex = _data["artIndex"];
            this.kindIdentifier = _data["kindIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new STLBKeyDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["artIdentifier"] = this.artIdentifier;
        data["artIndex"] = this.artIndex;
        data["kindIdentifier"] = this.kindIdentifier;
        return data;
    }
}
exports.STLBKeyDto = STLBKeyDto;
/** Indicates if this service specification item is commissioned (and therefore should be executed), postponed for later or undefined. */
var ComissionStatusDto;
(function (ComissionStatusDto) {
    ComissionStatusDto["Undefined"] = "Undefined";
    ComissionStatusDto["Commissioned"] = "Commissioned";
    ComissionStatusDto["Postponed"] = "Postponed";
    ComissionStatusDto["Removed"] = "Removed";
})(ComissionStatusDto = exports.ComissionStatusDto || (exports.ComissionStatusDto = {}));
/** This class represents as identifier of a certain service specification's element and is uniquely within the service specification. */
class ItemNumberDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.itemNumberSchema = data.itemNumberSchema && !data.itemNumberSchema.toJSON ? new ItemNumberSchemaDto(data.itemNumberSchema) : this.itemNumberSchema;
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.stringRepresentation = _data["stringRepresentation"];
            this.isSchemaCompliant = _data["isSchemaCompliant"];
            this.itemNumberSchema = _data["itemNumberSchema"] ? ItemNumberSchemaDto.fromJS(_data["itemNumberSchema"]) : undefined;
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [];
                for (let item of _data["identifiers"])
                    this.identifiers.push(item);
            }
            this.isLot = _data["isLot"];
            this.hierarchyLevel = _data["hierarchyLevel"];
            this.isAttachedToPosition = _data["isAttachedToPosition"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemNumberDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stringRepresentation"] = this.stringRepresentation;
        data["isSchemaCompliant"] = this.isSchemaCompliant;
        data["itemNumberSchema"] = this.itemNumberSchema ? this.itemNumberSchema.toJSON() : undefined;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item);
        }
        data["isLot"] = this.isLot;
        data["hierarchyLevel"] = this.hierarchyLevel;
        data["isAttachedToPosition"] = this.isAttachedToPosition;
        return data;
    }
}
exports.ItemNumberDto = ItemNumberDto;
/** This is a classification for Position elements. */
var PositionTypeDto;
(function (PositionTypeDto) {
    PositionTypeDto["Regular"] = "Regular";
    PositionTypeDto["Optional"] = "Optional";
    PositionTypeDto["Alternative"] = "Alternative";
})(PositionTypeDto = exports.PositionTypeDto || (exports.PositionTypeDto = {}));
/** This indicates the price type of a IPricedElement. */
var PriceTypeDto;
(function (PriceTypeDto) {
    PriceTypeDto["WithTotal"] = "WithTotal";
    PriceTypeDto["WithoutTotal"] = "WithoutTotal";
})(PriceTypeDto = exports.PriceTypeDto || (exports.PriceTypeDto = {}));
/** The service type describes the type of service a Position represents. */
var ServiceTypeDto;
(function (ServiceTypeDto) {
    ServiceTypeDto["Regular"] = "Regular";
    ServiceTypeDto["HourlyPaidWork"] = "HourlyPaidWork";
})(ServiceTypeDto = exports.ServiceTypeDto || (exports.ServiceTypeDto = {}));
/** This class represents data about products and their vendor */
class ProductDataDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.vendor = data.vendor && !data.vendor.toJSON ? new PartyInformationDto(data.vendor) : this.vendor;
            if (data.articles) {
                this.articles = [];
                for (let i = 0; i < data.articles.length; i++) {
                    let item = data.articles[i];
                    this.articles[i] = item && !item.toJSON ? new ArticleDataDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.vendor = _data["vendor"] ? PartyInformationDto.fromJS(_data["vendor"]) : undefined;
            if (Array.isArray(_data["articles"])) {
                this.articles = [];
                for (let item of _data["articles"])
                    this.articles.push(ArticleDataDto.fromJS(item));
            }
            this.shortText = _data["shortText"];
            this.longText = _data["longText"];
            this.htmlLongText = _data["htmlLongText"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDataDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : undefined;
        if (Array.isArray(this.articles)) {
            data["articles"] = [];
            for (let item of this.articles)
                data["articles"].push(item.toJSON());
        }
        data["shortText"] = this.shortText;
        data["longText"] = this.longText;
        data["htmlLongText"] = this.htmlLongText;
        return data;
    }
}
exports.ProductDataDto = ProductDataDto;
/** This class represents a single article, usually used within ProductData */
class ArticleDataDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.articleNumber = _data["articleNumber"];
            this.quantity = _data["quantity"];
            this.unitTag = _data["unitTag"];
            this.description = _data["description"];
            this.shortText = _data["shortText"];
            this.longText = _data["longText"];
            this.htmlLongText = _data["htmlLongText"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDataDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["articleNumber"] = this.articleNumber;
        data["quantity"] = this.quantity;
        data["unitTag"] = this.unitTag;
        data["description"] = this.description;
        data["shortText"] = this.shortText;
        data["longText"] = this.longText;
        data["htmlLongText"] = this.htmlLongText;
        return data;
    }
}
exports.ArticleDataDto = ArticleDataDto;
/** Quantity assignments are, in contrast to SubDescriptions, used to categorize parts of their parent Position. For example, it could be categorized by cost group - e.g. a Position describing concrete walls could follow the German DIN 276 Cost Groups Standard and specify that of the total 1.000m² wall, 500m² are classified as exterior walls and 500m² are classified as interior walls. They would then have different cost groups associated, e.g. for accounting purposes. */
class QuantityAssignmentDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.projectCatalogues) {
                this.projectCatalogues = [];
                for (let i = 0; i < data.projectCatalogues.length; i++) {
                    let item = data.projectCatalogues[i];
                    this.projectCatalogues[i] = item && !item.toJSON ? new CatalogueDto(item) : item;
                }
            }
            if (data.catalogueReferences) {
                this.catalogueReferences = [];
                for (let i = 0; i < data.catalogueReferences.length; i++) {
                    let item = data.catalogueReferences[i];
                    this.catalogueReferences[i] = item && !item.toJSON ? new CatalogueReferenceDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.quantity = _data["quantity"];
            if (Array.isArray(_data["projectCatalogues"])) {
                this.projectCatalogues = [];
                for (let item of _data["projectCatalogues"])
                    this.projectCatalogues.push(CatalogueDto.fromJS(item));
            }
            if (Array.isArray(_data["catalogueReferences"])) {
                this.catalogueReferences = [];
                for (let item of _data["catalogueReferences"])
                    this.catalogueReferences.push(CatalogueReferenceDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new QuantityAssignmentDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["quantity"] = this.quantity;
        if (Array.isArray(this.projectCatalogues)) {
            data["projectCatalogues"] = [];
            for (let item of this.projectCatalogues)
                data["projectCatalogues"].push(item.toJSON());
        }
        if (Array.isArray(this.catalogueReferences)) {
            data["catalogueReferences"] = [];
            for (let item of this.catalogueReferences)
                data["catalogueReferences"].push(item.toJSON());
        }
        return data;
    }
}
exports.QuantityAssignmentDto = QuantityAssignmentDto;
/** This class holds specialized information that is relevant to trade or commerce based data exchange scenarios, e.g. between customers, vendors, suppliers and distributors. It is used when exporting to GAEB XML 9x exchange phases. */
class CommercePropertiesDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.articleNumber = _data["articleNumber"];
            this.eanGtinArticleNumber = _data["eanGtinArticleNumber"];
            this.ilnArticleNumber = _data["ilnArticleNumber"];
            this.catalogueNumber = _data["catalogueNumber"];
            this.catalogueArticleNumber = _data["catalogueArticleNumber"];
            this.priceBasis = _data["priceBasis"];
            this.subPositionIdentifier = _data["subPositionIdentifier"];
            this.customerBaseItemNumber = _data["customerBaseItemNumber"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CommercePropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["articleNumber"] = this.articleNumber;
        data["eanGtinArticleNumber"] = this.eanGtinArticleNumber;
        data["ilnArticleNumber"] = this.ilnArticleNumber;
        data["catalogueNumber"] = this.catalogueNumber;
        data["catalogueArticleNumber"] = this.catalogueArticleNumber;
        data["priceBasis"] = this.priceBasis;
        data["subPositionIdentifier"] = this.subPositionIdentifier;
        data["customerBaseItemNumber"] = this.customerBaseItemNumber;
        return data;
    }
}
exports.CommercePropertiesDto = CommercePropertiesDto;
/** This class represents the linking to a complementary position with a specific quantity set. For example, Position 'A' could be complementing Position 'B' with a total quantity of 20 units */
class ComplementedByQuantityDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.quantity = _data["quantity"];
            this.complementingPositionId = _data["complementingPositionId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ComplementedByQuantityDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["quantity"] = this.quantity;
        data["complementingPositionId"] = this.complementingPositionId;
        return data;
    }
}
exports.ComplementedByQuantityDto = ComplementedByQuantityDto;
/** This class models special properties that only apply to some exchange scenarios where ÖNorm is used. It is special for Positions and extends the OenormProperties base class. */
class OenormPositionPropertiesDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.originCode = _data["originCode"];
            this.openingTextIsFreeText = _data["openingTextIsFreeText"];
            this.isMainPosition = _data["isMainPosition"];
            this.isUndividedPosition = _data["isUndividedPosition"];
            this.oenormShortText = _data["oenormShortText"];
            this.oenormShortTextAddition = _data["oenormShortTextAddition"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OenormPositionPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["originCode"] = this.originCode;
        data["openingTextIsFreeText"] = this.openingTextIsFreeText;
        data["isMainPosition"] = this.isMainPosition;
        data["isUndividedPosition"] = this.isUndividedPosition;
        data["oenormShortText"] = this.oenormShortText;
        data["oenormShortTextAddition"] = this.oenormShortTextAddition;
        return data;
    }
}
exports.OenormPositionPropertiesDto = OenormPositionPropertiesDto;
/** This indicates where the content of this element originates, if set. It corresponds to 'herkunftskennzeichen' in ÖNorm */
var OenormOriginCodeDto;
(function (OenormOriginCodeDto) {
    OenormOriginCodeDto["Unknown"] = "Unknown";
    OenormOriginCodeDto["FreeText"] = "FreeText";
    OenormOriginCodeDto["AdditionDescription"] = "AdditionDescription";
})(OenormOriginCodeDto = exports.OenormOriginCodeDto || (exports.OenormOriginCodeDto = {}));
/** This enumeration represents the status of an addendum, 'Nachtrag' in German */
var AddendumStatusDto;
(function (AddendumStatusDto) {
    AddendumStatusDto["Unknown"] = "Unknown";
    AddendumStatusDto["Recognized"] = "Recognized";
    AddendumStatusDto["Filed"] = "Filed";
    AddendumStatusDto["Offered"] = "Offered";
    AddendumStatusDto["Withdrawn"] = "Withdrawn";
    AddendumStatusDto["Rejected"] = "Rejected";
    AddendumStatusDto["RejectionObjected"] = "RejectionObjected";
    AddendumStatusDto["FormallyAcknowledged"] = "FormallyAcknowledged";
    AddendumStatusDto["Approved"] = "Approved";
})(AddendumStatusDto = exports.AddendumStatusDto || (exports.AddendumStatusDto = {}));
/** This enum represents the different ways in which a complementing position type can be specified. It is typically only used in GAEB exports, since in Dangl.AVA, complementing positions are always explicitly referenced. */
var PositionComplementingTypeDto;
(function (PositionComplementingTypeDto) {
    PositionComplementingTypeDto["Undefined"] = "Undefined";
    PositionComplementingTypeDto["AllPreviousMarkedPositions"] = "AllPreviousMarkedPositions";
    PositionComplementingTypeDto["AllPreviousPositions"] = "AllPreviousPositions";
    PositionComplementingTypeDto["ReferencedPositions"] = "ReferencedPositions";
})(PositionComplementingTypeDto = exports.PositionComplementingTypeDto || (exports.PositionComplementingTypeDto = {}));
/** This class holds properties that describe retention types in position. Retention / hold out usually means that a service is provided and kept available for a specific amount of time, e.g. fences on a construction site */
class PositionHoldOutPropertiesDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.holdOutType = _data["holdOutType"];
            this.holdOutDuration = _data["holdOutDuration"];
            this.holdOutDurationUnit = _data["holdOutDurationUnit"];
            if (Array.isArray(_data["basePositionReferences"])) {
                this.basePositionReferences = [];
                for (let item of _data["basePositionReferences"])
                    this.basePositionReferences.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PositionHoldOutPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["holdOutType"] = this.holdOutType;
        data["holdOutDuration"] = this.holdOutDuration;
        data["holdOutDurationUnit"] = this.holdOutDurationUnit;
        if (Array.isArray(this.basePositionReferences)) {
            data["basePositionReferences"] = [];
            for (let item of this.basePositionReferences)
                data["basePositionReferences"].push(item);
        }
        return data;
    }
}
exports.PositionHoldOutPropertiesDto = PositionHoldOutPropertiesDto;
/** Types of retentions to be used in positions */
var HoldOutTypeDto;
(function (HoldOutTypeDto) {
    HoldOutTypeDto["Unknown"] = "Unknown";
    HoldOutTypeDto["Base"] = "Base";
    HoldOutTypeDto["Extension"] = "Extension";
    HoldOutTypeDto["Rent"] = "Rent";
})(HoldOutTypeDto = exports.HoldOutTypeDto || (exports.HoldOutTypeDto = {}));
/** Duration used in retention positions */
var HoldOutDurationUnitDto;
(function (HoldOutDurationUnitDto) {
    HoldOutDurationUnitDto["Unknown"] = "Unknown";
    HoldOutDurationUnitDto["Minutes"] = "Minutes";
    HoldOutDurationUnitDto["Hours"] = "Hours";
    HoldOutDurationUnitDto["Days"] = "Days";
    HoldOutDurationUnitDto["Weeks"] = "Weeks";
    HoldOutDurationUnitDto["Months"] = "Months";
})(HoldOutDurationUnitDto = exports.HoldOutDurationUnitDto || (exports.HoldOutDurationUnitDto = {}));
/** Price catalogue data represents assumed or estimated prices from a catalogue source */
class PriceCatalogueDataDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.unitPriceFrom = _data["unitPriceFrom"];
            this.unitPriceTo = _data["unitPriceTo"];
            this.unitPriceAverage = _data["unitPriceAverage"];
            this.wagePriceFrom = _data["wagePriceFrom"];
            this.wagePriceTo = _data["wagePriceTo"];
            this.wagePriceAverage = _data["wagePriceAverage"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PriceCatalogueDataDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitPriceFrom"] = this.unitPriceFrom;
        data["unitPriceTo"] = this.unitPriceTo;
        data["unitPriceAverage"] = this.unitPriceAverage;
        data["wagePriceFrom"] = this.wagePriceFrom;
        data["wagePriceTo"] = this.wagePriceTo;
        data["wagePriceAverage"] = this.wagePriceAverage;
        return data;
    }
}
exports.PriceCatalogueDataDto = PriceCatalogueDataDto;
/** An ExecutionDescription is used to give more details for certain items, especially on how they are meant to be executed. */
class ExecutionDescriptionDto extends IElementDto {
    constructor(data) {
        super(data);
        this._discriminator = "ExecutionDescriptionDto";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["blocks"])) {
                this.blocks = [];
                for (let item of _data["blocks"])
                    this.blocks.push(NoteTextDto.fromJS(item));
            }
            this.label = _data["label"];
            this.identifier = _data["identifier"];
            this.elementType = _data["elementType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutionDescriptionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.blocks)) {
            data["blocks"] = [];
            for (let item of this.blocks)
                data["blocks"].push(item.toJSON());
        }
        data["label"] = this.label;
        data["identifier"] = this.identifier;
        data["elementType"] = this.elementType;
        super.toJSON(data);
        return data;
    }
}
exports.ExecutionDescriptionDto = ExecutionDescriptionDto;
/** Represents an element that holds text information. */
class NoteTextDto extends IElementDto {
    constructor(data) {
        super(data);
        if (data) {
            this.standardizedDescription = data.standardizedDescription && !data.standardizedDescription.toJSON ? new StandardizedDescriptionDto(data.standardizedDescription) : this.standardizedDescription;
            this.oenormNoteTextProperties = data.oenormNoteTextProperties && !data.oenormNoteTextProperties.toJSON ? new OenormNoteTextPropertiesDto(data.oenormNoteTextProperties) : this.oenormNoteTextProperties;
        }
        this._discriminator = "NoteTextDto";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.isOpeningText = _data["isOpeningText"];
            this.isClosingText = _data["isClosingText"];
            this.shortText = _data["shortText"];
            this.additionType = _data["additionType"];
            this.longText = _data["longText"];
            this.htmlLongText = _data["htmlLongText"];
            this.identifier = _data["identifier"];
            this.standardizedDescription = _data["standardizedDescription"] ? StandardizedDescriptionDto.fromJS(_data["standardizedDescription"]) : undefined;
            this.elementType = _data["elementType"];
            this.descriptionId = _data["descriptionId"];
            this.oenormNoteTextProperties = _data["oenormNoteTextProperties"] ? OenormNoteTextPropertiesDto.fromJS(_data["oenormNoteTextProperties"]) : undefined;
            this.hasBidderCommentInHtmlLongText = _data["hasBidderCommentInHtmlLongText"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NoteTextDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isOpeningText"] = this.isOpeningText;
        data["isClosingText"] = this.isClosingText;
        data["shortText"] = this.shortText;
        data["additionType"] = this.additionType;
        data["longText"] = this.longText;
        data["htmlLongText"] = this.htmlLongText;
        data["identifier"] = this.identifier;
        data["standardizedDescription"] = this.standardizedDescription ? this.standardizedDescription.toJSON() : undefined;
        data["elementType"] = this.elementType;
        data["descriptionId"] = this.descriptionId;
        data["oenormNoteTextProperties"] = this.oenormNoteTextProperties ? this.oenormNoteTextProperties.toJSON() : undefined;
        data["hasBidderCommentInHtmlLongText"] = this.hasBidderCommentInHtmlLongText;
        super.toJSON(data);
        return data;
    }
}
exports.NoteTextDto = NoteTextDto;
/** This class models special properties that only apply to some exchange scenarios where ÖNorm is used. It is special for NoteTexts. */
class OenormNoteTextPropertiesDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.originCode = _data["originCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OenormNoteTextPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["originCode"] = this.originCode;
        return data;
    }
}
exports.OenormNoteTextPropertiesDto = OenormNoteTextPropertiesDto;
/** This is a grouping IElement that holds other IElements within. */
class ServiceSpecificationGroupDto extends IElementDto {
    constructor(data) {
        super(data);
        if (data) {
            this.projectItemNumberSchema = data.projectItemNumberSchema && !data.projectItemNumberSchema.toJSON ? new ItemNumberSchemaDto(data.projectItemNumberSchema) : this.projectItemNumberSchema;
            if (data.totalPriceGrossByTaxRate) {
                this.totalPriceGrossByTaxRate = [];
                for (let i = 0; i < data.totalPriceGrossByTaxRate.length; i++) {
                    let item = data.totalPriceGrossByTaxRate[i];
                    this.totalPriceGrossByTaxRate[i] = item && !item.toJSON ? new GrossPriceComponentDto(item) : item;
                }
            }
            this.itemNumber = data.itemNumber && !data.itemNumber.toJSON ? new ItemNumberDto(data.itemNumber) : this.itemNumber;
            this.oenormProperties = data.oenormProperties && !data.oenormProperties.toJSON ? new OenormPropertiesDto(data.oenormProperties) : this.oenormProperties;
        }
        this._discriminator = "ServiceSpecificationGroupDto";
    }
    init(_data) {
        super.init(_data);
        if (_data) {
            this.projectHourlyWage = _data["projectHourlyWage"];
            this.projectTaxRate = _data["projectTaxRate"];
            if (Array.isArray(_data["projectPriceComponents"])) {
                this.projectPriceComponents = [];
                for (let item of _data["projectPriceComponents"])
                    this.projectPriceComponents.push(item);
            }
            this.projectItemNumberSchema = _data["projectItemNumberSchema"] ? ItemNumberSchemaDto.fromJS(_data["projectItemNumberSchema"]) : undefined;
            if (Array.isArray(_data["elements"])) {
                this.elements = [];
                for (let item of _data["elements"])
                    this.elements.push(IElementDto.fromJS(item));
            }
            this.projectLabourTimeLabel = _data["projectLabourTimeLabel"];
            this.containsDuplicateItemNumbers = _data["containsDuplicateItemNumbers"];
            this.containsDuplicateElementIds = _data["containsDuplicateElementIds"];
            this.ignoreDuplicateItemNumbers = _data["ignoreDuplicateItemNumbers"];
            this.ignoreProjectCataloguePropagation = _data["ignoreProjectCataloguePropagation"];
            this.ignoreDuplicateElementIds = _data["ignoreDuplicateElementIds"];
            if (Array.isArray(_data["totalPriceGrossByTaxRate"])) {
                this.totalPriceGrossByTaxRate = [];
                for (let item of _data["totalPriceGrossByTaxRate"])
                    this.totalPriceGrossByTaxRate.push(GrossPriceComponentDto.fromJS(item));
            }
            this.ignoreChildPriceUpdates = _data["ignoreChildPriceUpdates"];
            this.deductedPrice = _data["deductedPrice"];
            this.deductionFactor = _data["deductionFactor"];
            this.absoluteDeduction = _data["absoluteDeduction"];
            this.totalPrice = _data["totalPrice"];
            this.totalPriceGross = _data["totalPriceGross"];
            this.totalPriceGrossDeducted = _data["totalPriceGrossDeducted"];
            this.priceType = _data["priceType"];
            this.shortText = _data["shortText"];
            this.comissionStatus = _data["comissionStatus"];
            this.itemNumber = _data["itemNumber"] ? ItemNumberDto.fromJS(_data["itemNumber"]) : undefined;
            this.elementType = _data["elementType"];
            this.isLot = _data["isLot"];
            this.alternativeTo = _data["alternativeTo"];
            this.oenormProperties = _data["oenormProperties"] ? OenormPropertiesDto.fromJS(_data["oenormProperties"]) : undefined;
            this.hierarchyLevel = _data["hierarchyLevel"];
            this.addendumStatus = _data["addendumStatus"];
            this.alternativeIdentifier = _data["alternativeIdentifier"];
            this.alternativeGroupIdentifier = _data["alternativeGroupIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSpecificationGroupDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["projectHourlyWage"] = this.projectHourlyWage;
        data["projectTaxRate"] = this.projectTaxRate;
        if (Array.isArray(this.projectPriceComponents)) {
            data["projectPriceComponents"] = [];
            for (let item of this.projectPriceComponents)
                data["projectPriceComponents"].push(item);
        }
        data["projectItemNumberSchema"] = this.projectItemNumberSchema ? this.projectItemNumberSchema.toJSON() : undefined;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        data["projectLabourTimeLabel"] = this.projectLabourTimeLabel;
        data["containsDuplicateItemNumbers"] = this.containsDuplicateItemNumbers;
        data["containsDuplicateElementIds"] = this.containsDuplicateElementIds;
        data["ignoreDuplicateItemNumbers"] = this.ignoreDuplicateItemNumbers;
        data["ignoreProjectCataloguePropagation"] = this.ignoreProjectCataloguePropagation;
        data["ignoreDuplicateElementIds"] = this.ignoreDuplicateElementIds;
        if (Array.isArray(this.totalPriceGrossByTaxRate)) {
            data["totalPriceGrossByTaxRate"] = [];
            for (let item of this.totalPriceGrossByTaxRate)
                data["totalPriceGrossByTaxRate"].push(item.toJSON());
        }
        data["ignoreChildPriceUpdates"] = this.ignoreChildPriceUpdates;
        data["deductedPrice"] = this.deductedPrice;
        data["deductionFactor"] = this.deductionFactor;
        data["absoluteDeduction"] = this.absoluteDeduction;
        data["totalPrice"] = this.totalPrice;
        data["totalPriceGross"] = this.totalPriceGross;
        data["totalPriceGrossDeducted"] = this.totalPriceGrossDeducted;
        data["priceType"] = this.priceType;
        data["shortText"] = this.shortText;
        data["comissionStatus"] = this.comissionStatus;
        data["itemNumber"] = this.itemNumber ? this.itemNumber.toJSON() : undefined;
        data["elementType"] = this.elementType;
        data["isLot"] = this.isLot;
        data["alternativeTo"] = this.alternativeTo;
        data["oenormProperties"] = this.oenormProperties ? this.oenormProperties.toJSON() : undefined;
        data["hierarchyLevel"] = this.hierarchyLevel;
        data["addendumStatus"] = this.addendumStatus;
        data["alternativeIdentifier"] = this.alternativeIdentifier;
        data["alternativeGroupIdentifier"] = this.alternativeGroupIdentifier;
        super.toJSON(data);
        return data;
    }
}
exports.ServiceSpecificationGroupDto = ServiceSpecificationGroupDto;
/** This is used in an ElementContainerBase to hold the price composition. */
class GrossPriceComponentDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.taxRate = _data["taxRate"];
            this.deductionFactor = _data["deductionFactor"];
            this.totalNet = _data["totalNet"];
            this.totalDeducted = _data["totalDeducted"];
            this.totalTax = _data["totalTax"];
            this.totalGross = _data["totalGross"];
            this.totalGrossDeducted = _data["totalGrossDeducted"];
            this.totalTaxDeducted = _data["totalTaxDeducted"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GrossPriceComponentDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["taxRate"] = this.taxRate;
        data["deductionFactor"] = this.deductionFactor;
        data["totalNet"] = this.totalNet;
        data["totalDeducted"] = this.totalDeducted;
        data["totalTax"] = this.totalTax;
        data["totalGross"] = this.totalGross;
        data["totalGrossDeducted"] = this.totalGrossDeducted;
        data["totalTaxDeducted"] = this.totalTaxDeducted;
        return data;
    }
}
exports.GrossPriceComponentDto = GrossPriceComponentDto;
/** This class models special properties that only apply to some exchange scenarios where ÖNorm is used. */
class OenormPropertiesDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.originCode = _data["originCode"];
            this.openingTextIsFreeText = _data["openingTextIsFreeText"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OenormPropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["originCode"] = this.originCode;
        data["openingTextIsFreeText"] = this.openingTextIsFreeText;
        return data;
    }
}
exports.OenormPropertiesDto = OenormPropertiesDto;
/** Indicates a ServiceSpecification's exchange phase, based on the GAEB exchange phases. */
var ExchangePhaseDto;
(function (ExchangePhaseDto) {
    ExchangePhaseDto["Undefined"] = "Undefined";
    ExchangePhaseDto["Base"] = "Base";
    ExchangePhaseDto["CostEstimate"] = "CostEstimate";
    ExchangePhaseDto["OfferRequest"] = "OfferRequest";
    ExchangePhaseDto["Offer"] = "Offer";
    ExchangePhaseDto["SideOffer"] = "SideOffer";
    ExchangePhaseDto["Grant"] = "Grant";
})(ExchangePhaseDto = exports.ExchangePhaseDto || (exports.ExchangePhaseDto = {}));
/** Indicates where a service specification was originally created. */
var OriginDto;
(function (OriginDto) {
    OriginDto["Self"] = "Self";
    OriginDto["Gaeb90"] = "Gaeb90";
    OriginDto["Gaeb2000"] = "Gaeb2000";
    OriginDto["GaebXml"] = "GaebXml";
    OriginDto["Oenorm"] = "Oenorm";
    OriginDto["Reb"] = "Reb";
    OriginDto["Sia"] = "Sia";
})(OriginDto = exports.OriginDto || (exports.OriginDto = {}));
/** Holds global price information for a ServiceSpecification */
class PriceInformationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.tradeDiscounts) {
                this.tradeDiscounts = [];
                for (let i = 0; i < data.tradeDiscounts.length; i++) {
                    let item = data.tradeDiscounts[i];
                    this.tradeDiscounts[i] = item && !item.toJSON ? new TradeDiscountDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.hourlyWage = _data["hourlyWage"];
            this.deductionFactor = _data["deductionFactor"];
            this.flatSum = _data["flatSum"];
            this.taxRate = _data["taxRate"];
            this.hasUnsetTaxRate = _data["hasUnsetTaxRate"];
            if (Array.isArray(_data["tradeDiscounts"])) {
                this.tradeDiscounts = [];
                for (let item of _data["tradeDiscounts"])
                    this.tradeDiscounts.push(TradeDiscountDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PriceInformationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hourlyWage"] = this.hourlyWage;
        data["deductionFactor"] = this.deductionFactor;
        data["flatSum"] = this.flatSum;
        data["taxRate"] = this.taxRate;
        data["hasUnsetTaxRate"] = this.hasUnsetTaxRate;
        if (Array.isArray(this.tradeDiscounts)) {
            data["tradeDiscounts"] = [];
            for (let item of this.tradeDiscounts)
                data["tradeDiscounts"].push(item.toJSON());
        }
        return data;
    }
}
exports.PriceInformationDto = PriceInformationDto;
/** This class holds information about offered trade discounts (Skonto in German) */
class TradeDiscountDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.deadline = _data["deadline"];
            this.rate = _data["rate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TradeDiscountDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["deadline"] = this.deadline;
        data["rate"] = this.rate;
        return data;
    }
}
exports.TradeDiscountDto = TradeDiscountDto;
/** This class does not represent a typical `TimeSpan` but has a scalar value int Duration and a DurationUnit Unit to represent durations as typically used in contracts, e.g. 5 Months */
class WarrantyDurationDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.duration = _data["duration"];
            this.unit = _data["unit"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new WarrantyDurationDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration;
        data["unit"] = this.unit;
        return data;
    }
}
exports.WarrantyDurationDto = WarrantyDurationDto;
/** This enumeration represents the unit of a duration */
var DurationUnitDto;
(function (DurationUnitDto) {
    DurationUnitDto["Months"] = "Months";
    DurationUnitDto["Years"] = "Years";
})(DurationUnitDto = exports.DurationUnitDto || (exports.DurationUnitDto = {}));
/** This class represents properties used in commerce exchange scenarios */
class ServiceSpecificationCommercePropertiesDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.fixedPriceDate = _data["fixedPriceDate"] ? new Date(_data["fixedPriceDate"].toString()) : undefined;
            this.deliveryVoucherDate = _data["deliveryVoucherDate"] ? new Date(_data["deliveryVoucherDate"].toString()) : undefined;
            this.deliveryDate = _data["deliveryDate"] ? new Date(_data["deliveryDate"].toString()) : undefined;
            this.inquiryNumber = _data["inquiryNumber"];
            this.offerNumber = _data["offerNumber"];
            this.orderNumber = _data["orderNumber"];
            this.orderConfirmationNumber = _data["orderConfirmationNumber"];
            this.deliveryNumber = _data["deliveryNumber"];
            this.customerReferenceNumber = _data["customerReferenceNumber"];
            this.supplierReferenceNumber = _data["supplierReferenceNumber"];
            this.shippingType = _data["shippingType"];
            this.inquiryType = _data["inquiryType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSpecificationCommercePropertiesDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["fixedPriceDate"] = this.fixedPriceDate ? this.fixedPriceDate.toISOString() : undefined;
        data["deliveryVoucherDate"] = this.deliveryVoucherDate ? this.deliveryVoucherDate.toISOString() : undefined;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["inquiryNumber"] = this.inquiryNumber;
        data["offerNumber"] = this.offerNumber;
        data["orderNumber"] = this.orderNumber;
        data["orderConfirmationNumber"] = this.orderConfirmationNumber;
        data["deliveryNumber"] = this.deliveryNumber;
        data["customerReferenceNumber"] = this.customerReferenceNumber;
        data["supplierReferenceNumber"] = this.supplierReferenceNumber;
        data["shippingType"] = this.shippingType;
        data["inquiryType"] = this.inquiryType;
        return data;
    }
}
exports.ServiceSpecificationCommercePropertiesDto = ServiceSpecificationCommercePropertiesDto;
/** This enum represents types of price inquiries */
var CommerceInquiryTypeDto;
(function (CommerceInquiryTypeDto) {
    CommerceInquiryTypeDto["Unknown"] = "Unknown";
    CommerceInquiryTypeDto["Project"] = "Project";
    CommerceInquiryTypeDto["Immediate"] = "Immediate";
    CommerceInquiryTypeDto["Exhibition"] = "Exhibition";
})(CommerceInquiryTypeDto = exports.CommerceInquiryTypeDto || (exports.CommerceInquiryTypeDto = {}));
/** Data transfer class to convey api errors */
class ApiError {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (_data["errors"]) {
                this.errors = {};
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        this.errors[key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    data["errors"][key] = this.errors[key];
            }
        }
        return data;
    }
}
exports.ApiError = ApiError;
/** This model contains a flattened represention of an AVA project, which makes it easy to use in systems that expect elements in a list form. */
class FlatAvaProject {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.project = data.project && !data.project.toJSON ? new ProjectDto(data.project) : this.project;
            if (data.elements) {
                this.elements = [];
                for (let i = 0; i < data.elements.length; i++) {
                    let item = data.elements[i];
                    this.elements[i] = item && !item.toJSON ? new FlatElementDto(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : undefined;
            if (Array.isArray(_data["elements"])) {
                this.elements = [];
                for (let item of _data["elements"])
                    this.elements.push(FlatElementDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FlatAvaProject();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined;
        if (Array.isArray(this.elements)) {
            data["elements"] = [];
            for (let item of this.elements)
                data["elements"].push(item.toJSON());
        }
        return data;
    }
}
exports.FlatAvaProject = FlatAvaProject;
/** This model contains a flattened represention of an AVA project, which */
class FlatElementDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.previousElementId = _data["previousElementId"];
            this.parentElementId = _data["parentElementId"];
            this.element = _data["element"] ? IElementDto.fromJS(_data["element"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FlatElementDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["previousElementId"] = this.previousElementId;
        data["parentElementId"] = this.parentElementId;
        data["element"] = this.element ? this.element.toJSON() : undefined;
        return data;
    }
}
exports.FlatElementDto = FlatElementDto;
/** Represents valid GAEB target types */
var DestinationGaebType;
(function (DestinationGaebType) {
    DestinationGaebType["Gaeb90"] = "Gaeb90";
    DestinationGaebType["Gaeb2000"] = "Gaeb2000";
    DestinationGaebType["Gaeb2000Commerce"] = "Gaeb2000Commerce";
    DestinationGaebType["GaebXml_V3_1"] = "GaebXml_V3_1";
    DestinationGaebType["GaebXml_V3_2"] = "GaebXml_V3_2";
    DestinationGaebType["GaebXml_V3_2_Commerce"] = "GaebXml_V3_2_Commerce";
    DestinationGaebType["GaebXml_V3_3"] = "GaebXml_V3_3";
    DestinationGaebType["GaebXml_V3_3_Commerce"] = "GaebXml_V3_3_Commerce";
    DestinationGaebType["GaebXml_V3_3_2019"] = "GaebXml_V3_3_2019";
    DestinationGaebType["GaebXml_V3_3_2019_Commerce"] = "GaebXml_V3_3_2019_Commerce";
})(DestinationGaebType = exports.DestinationGaebType || (exports.DestinationGaebType = {}));
/** The GAEB exchange phase to transform to. The phases are: Base = 81 CostEstimate = 82 OfferRequest = 83 Offer = 84 SideOffer = 85 Grant = 86 */
var DestinationGaebExchangePhase;
(function (DestinationGaebExchangePhase) {
    DestinationGaebExchangePhase["None"] = "None";
    DestinationGaebExchangePhase["Base"] = "Base";
    DestinationGaebExchangePhase["OfferRequest"] = "OfferRequest";
    DestinationGaebExchangePhase["Offer"] = "Offer";
    DestinationGaebExchangePhase["Grant"] = "Grant";
    DestinationGaebExchangePhase["CostEstimate"] = "CostEstimate";
    DestinationGaebExchangePhase["SideOffer"] = "SideOffer";
})(DestinationGaebExchangePhase = exports.DestinationGaebExchangePhase || (exports.DestinationGaebExchangePhase = {}));
/** Represents valid Oenorm target types */
var DestinationOenormType;
(function (DestinationOenormType) {
    DestinationOenormType["Lv2015"] = "Lv2015";
    DestinationOenormType["Lb2015"] = "Lb2015";
    DestinationOenormType["B2063"] = "B2063";
    DestinationOenormType["Lv2009"] = "Lv2009";
    DestinationOenormType["Lb2009"] = "Lb2009";
    DestinationOenormType["Lv2021"] = "Lv2021";
    DestinationOenormType["Lb2021"] = "Lb2021";
})(DestinationOenormType = exports.DestinationOenormType || (exports.DestinationOenormType = {}));
/** Represents valid REB target types */
var DestinationRebType;
(function (DestinationRebType) {
    DestinationRebType["D11"] = "D11";
    DestinationRebType["X31GaebXmlV32"] = "X31GaebXmlV32";
    DestinationRebType["X31GaebXmlV33"] = "X31GaebXmlV33";
})(DestinationRebType = exports.DestinationRebType || (exports.DestinationRebType = {}));
/** Represents valid SIA destination types */
var SiaDestinationType;
(function (SiaDestinationType) {
    SiaDestinationType["Sia451"] = "Sia451";
    SiaDestinationType["Ifa18"] = "Ifa18";
})(SiaDestinationType = exports.SiaDestinationType || (exports.SiaDestinationType = {}));
/** Represents valid Datanorm versions for export */
var DatanormDestinationVersion;
(function (DatanormDestinationVersion) {
    DatanormDestinationVersion["V4"] = "V4";
    DatanormDestinationVersion["V5"] = "V5";
})(DatanormDestinationVersion = exports.DatanormDestinationVersion || (exports.DatanormDestinationVersion = {}));
/** Represents valid UGL versions for export */
var UglDestinationVersion;
(function (UglDestinationVersion) {
    UglDestinationVersion["V4"] = "V4";
    UglDestinationVersion["V5"] = "V5";
})(UglDestinationVersion = exports.UglDestinationVersion || (exports.UglDestinationVersion = {}));
/** Represents valid IDS Connect versions for export */
var IdsConnectVersion;
(function (IdsConnectVersion) {
    IdsConnectVersion["V2_5"] = "V2_5";
})(IdsConnectVersion = exports.IdsConnectVersion || (exports.IdsConnectVersion = {}));
/** Indicates the status of the AVACloud service */
class GetStatus {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isHealthy = _data["isHealthy"];
            this.version = _data["version"];
            this.environment = _data["environment"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetStatus();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isHealthy"] = this.isHealthy;
        data["version"] = this.version;
        data["environment"] = this.environment;
        return data;
    }
}
exports.GetStatus = GetStatus;
/** This class represents the result of a validation operation */
class ValidationResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.checkResults) {
                this.checkResults = [];
                for (let i = 0; i < data.checkResults.length; i++) {
                    let item = data.checkResults[i];
                    this.checkResults[i] = item && !item.toJSON ? new ValidationCheckResult(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isSchemaCompliant = _data["isSchemaCompliant"];
            if (Array.isArray(_data["checkResults"])) {
                this.checkResults = [];
                for (let item of _data["checkResults"])
                    this.checkResults.push(ValidationCheckResult.fromJS(item));
            }
            this.validationType = _data["validationType"];
            this.fileName = _data["fileName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isSchemaCompliant"] = this.isSchemaCompliant;
        if (Array.isArray(this.checkResults)) {
            data["checkResults"] = [];
            for (let item of this.checkResults)
                data["checkResults"].push(item.toJSON());
        }
        data["validationType"] = this.validationType;
        data["fileName"] = this.fileName;
        return data;
    }
}
exports.ValidationResult = ValidationResult;
/** This class models the results of a single check performed during a validation action */
class ValidationCheckResult {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.objectValidationCheckDetails = data.objectValidationCheckDetails && !data.objectValidationCheckDetails.toJSON ? new ObjectValidationCheckDetails(data.objectValidationCheckDetails) : this.objectValidationCheckDetails;
            this.xmlSchemaValidationCheckDetails = data.xmlSchemaValidationCheckDetails && !data.xmlSchemaValidationCheckDetails.toJSON ? new XmlSchemaValidationCheckDetails(data.xmlSchemaValidationCheckDetails) : this.xmlSchemaValidationCheckDetails;
            this.projectValidationCheckDetails = data.projectValidationCheckDetails && !data.projectValidationCheckDetails.toJSON ? new ProjectValidationCheckDetails(data.projectValidationCheckDetails) : this.projectValidationCheckDetails;
        }
    }
    init(_data) {
        if (_data) {
            this.severity = _data["severity"];
            this.checkType = _data["checkType"];
            this.message = _data["message"];
            this.objectValidationCheckDetails = _data["objectValidationCheckDetails"] ? ObjectValidationCheckDetails.fromJS(_data["objectValidationCheckDetails"]) : undefined;
            this.xmlSchemaValidationCheckDetails = _data["xmlSchemaValidationCheckDetails"] ? XmlSchemaValidationCheckDetails.fromJS(_data["xmlSchemaValidationCheckDetails"]) : undefined;
            this.projectValidationCheckDetails = _data["projectValidationCheckDetails"] ? ProjectValidationCheckDetails.fromJS(_data["projectValidationCheckDetails"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationCheckResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["severity"] = this.severity;
        data["checkType"] = this.checkType;
        data["message"] = this.message;
        data["objectValidationCheckDetails"] = this.objectValidationCheckDetails ? this.objectValidationCheckDetails.toJSON() : undefined;
        data["xmlSchemaValidationCheckDetails"] = this.xmlSchemaValidationCheckDetails ? this.xmlSchemaValidationCheckDetails.toJSON() : undefined;
        data["projectValidationCheckDetails"] = this.projectValidationCheckDetails ? this.projectValidationCheckDetails.toJSON() : undefined;
        return data;
    }
}
exports.ValidationCheckResult = ValidationCheckResult;
/** Indicates the severity of a check */
var ValidationSeverity;
(function (ValidationSeverity) {
    ValidationSeverity["Information"] = "Information";
    ValidationSeverity["Warning"] = "Warning";
    ValidationSeverity["Error"] = "Error";
    ValidationSeverity["Critical"] = "Critical";
})(ValidationSeverity = exports.ValidationSeverity || (exports.ValidationSeverity = {}));
/** Enumeration for the different types of checks performed */
var ValidationCheckType;
(function (ValidationCheckType) {
    ValidationCheckType["General"] = "General";
    ValidationCheckType["XmlSchemaCheck"] = "XmlSchemaCheck";
    ValidationCheckType["ObjectValidation"] = "ObjectValidation";
    ValidationCheckType["ProjectValidation"] = "ProjectValidation";
})(ValidationCheckType = exports.ValidationCheckType || (exports.ValidationCheckType = {}));
/** Basic information about Object check validation details, commonly used when checking GAEB 2000 files */
class ObjectValidationCheckDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.elementPath = _data["elementPath"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectValidationCheckDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["elementPath"] = this.elementPath;
        return data;
    }
}
exports.ObjectValidationCheckDetails = ObjectValidationCheckDetails;
/** Check details for an XML schema validation result */
class XmlSchemaValidationCheckDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.lineNumber = _data["lineNumber"];
            this.linePosition = _data["linePosition"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new XmlSchemaValidationCheckDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["lineNumber"] = this.lineNumber;
        data["linePosition"] = this.linePosition;
        return data;
    }
}
exports.XmlSchemaValidationCheckDetails = XmlSchemaValidationCheckDetails;
/** Check details specificly for checking ProjectDto objects */
class ProjectValidationCheckDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.elementId = _data["elementId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectValidationCheckDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["elementId"] = this.elementId;
        return data;
    }
}
exports.ProjectValidationCheckDetails = ProjectValidationCheckDetails;
/** This enumeration represents the possible conversion targets when performing a validation */
var ValidationType;
(function (ValidationType) {
    ValidationType["Project"] = "Project";
    ValidationType["Gaeb"] = "Gaeb";
    ValidationType["Oenorm"] = "Oenorm";
})(ValidationType = exports.ValidationType || (exports.ValidationType = {}));
/** This enum represents the source type for a file based validation operation */
var FileValidationSourceType;
(function (FileValidationSourceType) {
    FileValidationSourceType["Gaeb"] = "Gaeb";
    FileValidationSourceType["Oenorm"] = "Oenorm";
})(FileValidationSourceType = exports.FileValidationSourceType || (exports.FileValidationSourceType = {}));
/** Options for validating an AVA project */
class PostAvaProjectValidationSourceOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.avaProject = data.avaProject && !data.avaProject.toJSON ? new ProjectDto(data.avaProject) : this.avaProject;
            this.avaSourceOptions = data.avaSourceOptions && !data.avaSourceOptions.toJSON ? new PostAvaSourceOptions(data.avaSourceOptions) : this.avaSourceOptions;
            this.oenormDestinationOptions = data.oenormDestinationOptions && !data.oenormDestinationOptions.toJSON ? new PostOenormDestinationOptions(data.oenormDestinationOptions) : this.oenormDestinationOptions;
            this.gaebDestinationOptions = data.gaebDestinationOptions && !data.gaebDestinationOptions.toJSON ? new PostGaebDestinationOptions(data.gaebDestinationOptions) : this.gaebDestinationOptions;
        }
        if (!data) {
            this.avaProject = new ProjectDto();
        }
    }
    init(_data) {
        if (_data) {
            this.avaProject = _data["avaProject"] ? ProjectDto.fromJS(_data["avaProject"]) : new ProjectDto();
            this.serviceSpecificationIndex = _data["serviceSpecificationIndex"];
            this.validationType = _data["validationType"];
            this.exchangePhase = _data["exchangePhase"];
            this.avaSourceOptions = _data["avaSourceOptions"] ? PostAvaSourceOptions.fromJS(_data["avaSourceOptions"]) : undefined;
            this.oenormDestinationOptions = _data["oenormDestinationOptions"] ? PostOenormDestinationOptions.fromJS(_data["oenormDestinationOptions"]) : undefined;
            this.gaebDestinationOptions = _data["gaebDestinationOptions"] ? PostGaebDestinationOptions.fromJS(_data["gaebDestinationOptions"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostAvaProjectValidationSourceOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["avaProject"] = this.avaProject ? this.avaProject.toJSON() : undefined;
        data["serviceSpecificationIndex"] = this.serviceSpecificationIndex;
        data["validationType"] = this.validationType;
        data["exchangePhase"] = this.exchangePhase;
        data["avaSourceOptions"] = this.avaSourceOptions ? this.avaSourceOptions.toJSON() : undefined;
        data["oenormDestinationOptions"] = this.oenormDestinationOptions ? this.oenormDestinationOptions.toJSON() : undefined;
        data["gaebDestinationOptions"] = this.gaebDestinationOptions ? this.gaebDestinationOptions.toJSON() : undefined;
        return data;
    }
}
exports.PostAvaProjectValidationSourceOptions = PostAvaProjectValidationSourceOptions;
/** Options for conversions from AVA */
class PostAvaSourceOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.tryAutoGenerateItemNumbersAndSchema = _data["tryAutoGenerateItemNumbersAndSchema"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostAvaSourceOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["tryAutoGenerateItemNumbersAndSchema"] = this.tryAutoGenerateItemNumbersAndSchema;
        return data;
    }
}
exports.PostAvaSourceOptions = PostAvaSourceOptions;
/** Options for conversions to Oenorm */
class PostOenormDestinationOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.destinationOenormType = _data["destinationOenormType"];
            this.tryRepairProjectStructure = _data["tryRepairProjectStructure"];
            this.skipTryEnforceSchemaCompliantXmlOutput = _data["skipTryEnforceSchemaCompliantXmlOutput"];
            this.removeUnprintableCharactersFromTexts = _data["removeUnprintableCharactersFromTexts"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostOenormDestinationOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["destinationOenormType"] = this.destinationOenormType;
        data["tryRepairProjectStructure"] = this.tryRepairProjectStructure;
        data["skipTryEnforceSchemaCompliantXmlOutput"] = this.skipTryEnforceSchemaCompliantXmlOutput;
        data["removeUnprintableCharactersFromTexts"] = this.removeUnprintableCharactersFromTexts;
        return data;
    }
}
exports.PostOenormDestinationOptions = PostOenormDestinationOptions;
/** Options for conversions to GAEB */
class PostGaebDestinationOptions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.destinationGaebType = _data["destinationGaebType"];
            this.targetExchangePhaseTransform = _data["targetExchangePhaseTransform"];
            this.enforceStrictOfferPhaseLongTextOutput = _data["enforceStrictOfferPhaseLongTextOutput"];
            this.exportQuantityDetermination = _data["exportQuantityDetermination"];
            this.removeUnprintableCharactersFromTexts = _data["removeUnprintableCharactersFromTexts"];
            this.forceIncludeDescriptions = _data["forceIncludeDescriptions"];
            this.treatNullItemNumberSchemaAsInvalid = _data["treatNullItemNumberSchemaAsInvalid"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PostGaebDestinationOptions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["destinationGaebType"] = this.destinationGaebType;
        data["targetExchangePhaseTransform"] = this.targetExchangePhaseTransform;
        data["enforceStrictOfferPhaseLongTextOutput"] = this.enforceStrictOfferPhaseLongTextOutput;
        data["exportQuantityDetermination"] = this.exportQuantityDetermination;
        data["removeUnprintableCharactersFromTexts"] = this.removeUnprintableCharactersFromTexts;
        data["forceIncludeDescriptions"] = this.forceIncludeDescriptions;
        data["treatNullItemNumberSchemaAsInvalid"] = this.treatNullItemNumberSchemaAsInvalid;
        return data;
    }
}
exports.PostGaebDestinationOptions = PostGaebDestinationOptions;
/** This class represents an invoice */
class Invoice {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.references = data.references && !data.references.toJSON ? new References(data.references) : this.references;
            if (data.previousInvoices) {
                this.previousInvoices = [];
                for (let i = 0; i < data.previousInvoices.length; i++) {
                    let item = data.previousInvoices[i];
                    this.previousInvoices[i] = item && !item.toJSON ? new PreviousInvoice(item) : item;
                }
            }
            this.buyer = data.buyer && !data.buyer.toJSON ? new Organization(data.buyer) : this.buyer;
            this.seller = data.seller && !data.seller.toJSON ? new Organization(data.seller) : this.seller;
            this.payee = data.payee && !data.payee.toJSON ? new Payee(data.payee) : this.payee;
            if (data.invoiceNotes) {
                this.invoiceNotes = [];
                for (let i = 0; i < data.invoiceNotes.length; i++) {
                    let item = data.invoiceNotes[i];
                    this.invoiceNotes[i] = item && !item.toJSON ? new InvoiceNote(item) : item;
                }
            }
            this.invoicePeriod = data.invoicePeriod && !data.invoicePeriod.toJSON ? new InvoicePeriod(data.invoicePeriod) : this.invoicePeriod;
            this.totals = data.totals && !data.totals.toJSON ? new InvoiceTotals(data.totals) : this.totals;
            this.paymentInstructions = data.paymentInstructions && !data.paymentInstructions.toJSON ? new PaymentInstructions(data.paymentInstructions) : this.paymentInstructions;
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !item.toJSON ? new SupportingDocument(item) : item;
                }
            }
            if (data.vatBreakdown) {
                this.vatBreakdown = [];
                for (let i = 0; i < data.vatBreakdown.length; i++) {
                    let item = data.vatBreakdown[i];
                    this.vatBreakdown[i] = item && !item.toJSON ? new VatBreakdown(item) : item;
                }
            }
            if (data.allowances) {
                this.allowances = [];
                for (let i = 0; i < data.allowances.length; i++) {
                    let item = data.allowances[i];
                    this.allowances[i] = item && !item.toJSON ? new InvoiceAllowance(item) : item;
                }
            }
            if (data.charges) {
                this.charges = [];
                for (let i = 0; i < data.charges.length; i++) {
                    let item = data.charges[i];
                    this.charges[i] = item && !item.toJSON ? new InvoiceCharge(item) : item;
                }
            }
            if (data.lineItems) {
                this.lineItems = [];
                for (let i = 0; i < data.lineItems.length; i++) {
                    let item = data.lineItems[i];
                    this.lineItems[i] = item && !item.toJSON ? new InvoiceLineItem(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
            this.invoiceType = _data["invoiceType"];
            this.currencyCode = _data["currencyCode"];
            this.paymentDueDate = _data["paymentDueDate"] ? new Date(_data["paymentDueDate"].toString()) : undefined;
            this.references = _data["references"] ? References.fromJS(_data["references"]) : undefined;
            this.paymentTerms = _data["paymentTerms"];
            if (Array.isArray(_data["previousInvoices"])) {
                this.previousInvoices = [];
                for (let item of _data["previousInvoices"])
                    this.previousInvoices.push(PreviousInvoice.fromJS(item));
            }
            this.buyer = _data["buyer"] ? Organization.fromJS(_data["buyer"]) : undefined;
            this.seller = _data["seller"] ? Organization.fromJS(_data["seller"]) : undefined;
            this.payee = _data["payee"] ? Payee.fromJS(_data["payee"]) : undefined;
            if (Array.isArray(_data["invoiceNotes"])) {
                this.invoiceNotes = [];
                for (let item of _data["invoiceNotes"])
                    this.invoiceNotes.push(InvoiceNote.fromJS(item));
            }
            this.invoicePeriod = _data["invoicePeriod"] ? InvoicePeriod.fromJS(_data["invoicePeriod"]) : undefined;
            this.totals = _data["totals"] ? InvoiceTotals.fromJS(_data["totals"]) : undefined;
            this.paymentInstructions = _data["paymentInstructions"] ? PaymentInstructions.fromJS(_data["paymentInstructions"]) : undefined;
            if (Array.isArray(_data["documents"])) {
                this.documents = [];
                for (let item of _data["documents"])
                    this.documents.push(SupportingDocument.fromJS(item));
            }
            if (Array.isArray(_data["vatBreakdown"])) {
                this.vatBreakdown = [];
                for (let item of _data["vatBreakdown"])
                    this.vatBreakdown.push(VatBreakdown.fromJS(item));
            }
            if (Array.isArray(_data["allowances"])) {
                this.allowances = [];
                for (let item of _data["allowances"])
                    this.allowances.push(InvoiceAllowance.fromJS(item));
            }
            if (Array.isArray(_data["charges"])) {
                this.charges = [];
                for (let item of _data["charges"])
                    this.charges.push(InvoiceCharge.fromJS(item));
            }
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [];
                for (let item of _data["lineItems"])
                    this.lineItems.push(InvoiceLineItem.fromJS(item));
            }
            this.sourceType = _data["sourceType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["invoiceType"] = this.invoiceType;
        data["currencyCode"] = this.currencyCode;
        data["paymentDueDate"] = this.paymentDueDate ? this.paymentDueDate.toISOString() : undefined;
        data["references"] = this.references ? this.references.toJSON() : undefined;
        data["paymentTerms"] = this.paymentTerms;
        if (Array.isArray(this.previousInvoices)) {
            data["previousInvoices"] = [];
            for (let item of this.previousInvoices)
                data["previousInvoices"].push(item.toJSON());
        }
        data["buyer"] = this.buyer ? this.buyer.toJSON() : undefined;
        data["seller"] = this.seller ? this.seller.toJSON() : undefined;
        data["payee"] = this.payee ? this.payee.toJSON() : undefined;
        if (Array.isArray(this.invoiceNotes)) {
            data["invoiceNotes"] = [];
            for (let item of this.invoiceNotes)
                data["invoiceNotes"].push(item.toJSON());
        }
        data["invoicePeriod"] = this.invoicePeriod ? this.invoicePeriod.toJSON() : undefined;
        data["totals"] = this.totals ? this.totals.toJSON() : undefined;
        data["paymentInstructions"] = this.paymentInstructions ? this.paymentInstructions.toJSON() : undefined;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        if (Array.isArray(this.vatBreakdown)) {
            data["vatBreakdown"] = [];
            for (let item of this.vatBreakdown)
                data["vatBreakdown"].push(item.toJSON());
        }
        if (Array.isArray(this.allowances)) {
            data["allowances"] = [];
            for (let item of this.allowances)
                data["allowances"].push(item.toJSON());
        }
        if (Array.isArray(this.charges)) {
            data["charges"] = [];
            for (let item of this.charges)
                data["charges"].push(item.toJSON());
        }
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        data["sourceType"] = this.sourceType;
        return data;
    }
}
exports.Invoice = Invoice;
/** Type of the invoice */
var InvoiceType;
(function (InvoiceType) {
    InvoiceType["PartialInvoice"] = "PartialInvoice";
    InvoiceType["CommercialInvoice"] = "CommercialInvoice";
    InvoiceType["CreditNote"] = "CreditNote";
    InvoiceType["CorrectedInvoice"] = "CorrectedInvoice";
    InvoiceType["SelfBilledInvoice"] = "SelfBilledInvoice";
    InvoiceType["PartialConstructionInvoice"] = "PartialConstructionInvoice";
    InvoiceType["PartialFinalConstructionInvoice"] = "PartialFinalConstructionInvoice";
    InvoiceType["FinalConstructionInvoice"] = "FinalConstructionInvoice";
})(InvoiceType = exports.InvoiceType || (exports.InvoiceType = {}));
/** This class holds typical references used in an invoice */
class References {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.buyerReference = _data["buyerReference"];
            this.projectReference = _data["projectReference"];
            this.contractReference = _data["contractReference"];
            this.purchaseOrderReference = _data["purchaseOrderReference"];
            this.salesOrderReference = _data["salesOrderReference"];
            this.receivingAdviceReference = _data["receivingAdviceReference"];
            this.dispatchAdviceReference = _data["dispatchAdviceReference"];
            this.tenderOrLotReference = _data["tenderOrLotReference"];
            this.invoicedObjectIdentifier = _data["invoicedObjectIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new References();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["buyerReference"] = this.buyerReference;
        data["projectReference"] = this.projectReference;
        data["contractReference"] = this.contractReference;
        data["purchaseOrderReference"] = this.purchaseOrderReference;
        data["salesOrderReference"] = this.salesOrderReference;
        data["receivingAdviceReference"] = this.receivingAdviceReference;
        data["dispatchAdviceReference"] = this.dispatchAdviceReference;
        data["tenderOrLotReference"] = this.tenderOrLotReference;
        data["invoicedObjectIdentifier"] = this.invoicedObjectIdentifier;
        return data;
    }
}
exports.References = References;
/** References to previous invoices */
class PreviousInvoice {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
            this.invoiceNumber = _data["invoiceNumber"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PreviousInvoice();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    }
}
exports.PreviousInvoice = PreviousInvoice;
/** Represents an organization, e.g. a buyer or a seller */
class Organization {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.vatId = _data["vatId"];
            this.email = _data["email"];
            this.contactPersonName = _data["contactPersonName"];
            this.contactPersonPhone = _data["contactPersonPhone"];
            this.contactPersonEmail = _data["contactPersonEmail"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.countryCode = _data["countryCode"];
            this.state = _data["state"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Organization();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["vatId"] = this.vatId;
        data["email"] = this.email;
        data["contactPersonName"] = this.contactPersonName;
        data["contactPersonPhone"] = this.contactPersonPhone;
        data["contactPersonEmail"] = this.contactPersonEmail;
        data["address"] = this.address;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["countryCode"] = this.countryCode;
        data["state"] = this.state;
        return data;
    }
}
exports.Organization = Organization;
/** Represents a payee, meaning someone that receives the payment */
class Payee {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.legalRegistrationIdentifier = _data["legalRegistrationIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Payee();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["legalRegistrationIdentifier"] = this.legalRegistrationIdentifier;
        return data;
    }
}
exports.Payee = Payee;
/** Represents a note / text in an invoice */
class InvoiceNote {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.shortText = _data["shortText"];
            this.longText = _data["longText"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceNote();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["shortText"] = this.shortText;
        data["longText"] = this.longText;
        return data;
    }
}
exports.InvoiceNote = InvoiceNote;
/** Represents an invoice period with start and end dates */
class InvoicePeriod {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InvoicePeriod();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : undefined;
        data["end"] = this.end ? this.end.toISOString() : undefined;
        return data;
    }
}
exports.InvoicePeriod = InvoicePeriod;
/** Totals for the invoice */
class InvoiceTotals {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalNet = _data["totalNet"];
            this.totalAllowances = _data["totalAllowances"];
            this.totalCharges = _data["totalCharges"];
            this.totalAfterDeductions = _data["totalAfterDeductions"];
            this.totalVatAmount = _data["totalVatAmount"];
            this.totalGross = _data["totalGross"];
            this.alreadyPaidTotal = _data["alreadyPaidTotal"];
            this.totalToBePaid = _data["totalToBePaid"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceTotals();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalNet"] = this.totalNet;
        data["totalAllowances"] = this.totalAllowances;
        data["totalCharges"] = this.totalCharges;
        data["totalAfterDeductions"] = this.totalAfterDeductions;
        data["totalVatAmount"] = this.totalVatAmount;
        data["totalGross"] = this.totalGross;
        data["alreadyPaidTotal"] = this.alreadyPaidTotal;
        data["totalToBePaid"] = this.totalToBePaid;
        return data;
    }
}
exports.InvoiceTotals = InvoiceTotals;
/** Instructions how payment for an invoice should be provided. */
class PaymentInstructions {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.paymentMeans) {
                this.paymentMeans = [];
                for (let i = 0; i < data.paymentMeans.length; i++) {
                    let item = data.paymentMeans[i];
                    this.paymentMeans[i] = item && !item.toJSON ? new PaymentMeans(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.description = _data["description"];
            this.paymentTypeCode = _data["paymentTypeCode"];
            if (Array.isArray(_data["paymentMeans"])) {
                this.paymentMeans = [];
                for (let item of _data["paymentMeans"])
                    this.paymentMeans.push(PaymentMeans.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInstructions();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["paymentTypeCode"] = this.paymentTypeCode;
        if (Array.isArray(this.paymentMeans)) {
            data["paymentMeans"] = [];
            for (let item of this.paymentMeans)
                data["paymentMeans"].push(item.toJSON());
        }
        return data;
    }
}
exports.PaymentInstructions = PaymentInstructions;
/** Represents a payment means for an invoice */
class PaymentMeans {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.accountIdentifier = _data["accountIdentifier"];
            this.accountName = _data["accountName"];
            this.serviceProviderIdentifier = _data["serviceProviderIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMeans();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["accountIdentifier"] = this.accountIdentifier;
        data["accountName"] = this.accountName;
        data["serviceProviderIdentifier"] = this.serviceProviderIdentifier;
        return data;
    }
}
exports.PaymentMeans = PaymentMeans;
/** Represents a document / attachment that is included with the invoice */
class SupportingDocument {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.documentReference = _data["documentReference"];
            this.description = _data["description"];
            this.externalDocumentUrl = _data["externalDocumentUrl"];
            this.documentBase64 = _data["documentBase64"];
            this.fileName = _data["fileName"];
            this.documentMimeType = _data["documentMimeType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SupportingDocument();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["documentReference"] = this.documentReference;
        data["description"] = this.description;
        data["externalDocumentUrl"] = this.externalDocumentUrl;
        data["documentBase64"] = this.documentBase64;
        data["fileName"] = this.fileName;
        data["documentMimeType"] = this.documentMimeType;
        return data;
    }
}
exports.SupportingDocument = SupportingDocument;
/** Describes a mimne type of a document */
var AttachmentMimeType;
(function (AttachmentMimeType) {
    AttachmentMimeType["Unknown"] = "Unknown";
    AttachmentMimeType["Pdf"] = "Pdf";
    AttachmentMimeType["Png"] = "Png";
    AttachmentMimeType["Jpeg"] = "Jpeg";
    AttachmentMimeType["Csv"] = "Csv";
    AttachmentMimeType["Excel"] = "Excel";
    AttachmentMimeType["OpenOfficeSpreadsheet"] = "OpenOfficeSpreadsheet";
})(AttachmentMimeType = exports.AttachmentMimeType || (exports.AttachmentMimeType = {}));
/** Describes the VAT breakdown for an invoice in a single VAT category */
class VatBreakdown {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.netTaxableAmount = _data["netTaxableAmount"];
            this.vatAmount = _data["vatAmount"];
            this.vatCategory = _data["vatCategory"];
            this.taxRate = _data["taxRate"];
            this.vatExemptionReasonText = _data["vatExemptionReasonText"];
            this.vatExemptionReasonCode = _data["vatExemptionReasonCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new VatBreakdown();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["netTaxableAmount"] = this.netTaxableAmount;
        data["vatAmount"] = this.vatAmount;
        data["vatCategory"] = this.vatCategory;
        data["taxRate"] = this.taxRate;
        data["vatExemptionReasonText"] = this.vatExemptionReasonText;
        data["vatExemptionReasonCode"] = this.vatExemptionReasonCode;
        return data;
    }
}
exports.VatBreakdown = VatBreakdown;
/** The category used in a VatBreakdown"/> */
var VatCategory;
(function (VatCategory) {
    VatCategory["Unknown"] = "Unknown";
    VatCategory["StandardRate"] = "StandardRate";
    VatCategory["ZeroRatedGoods"] = "ZeroRatedGoods";
    VatCategory["ExemptFromTax"] = "ExemptFromTax";
    VatCategory["VatReverseCharge"] = "VatReverseCharge";
    VatCategory["VatExemptReverseCharge"] = "VatExemptReverseCharge";
    VatCategory["FreeExportItem"] = "FreeExportItem";
    VatCategory["ServicesOutsideScopeOfTaxation"] = "ServicesOutsideScopeOfTaxation";
    VatCategory["CanaryIslandsGeneralIndirectTax"] = "CanaryIslandsGeneralIndirectTax";
    VatCategory["TaxInCeutaAndMelilla"] = "TaxInCeutaAndMelilla";
})(VatCategory = exports.VatCategory || (exports.VatCategory = {}));
/** This describes an allowance in an invoice, which is a deduction from the total amount */
class InvoiceAllowance {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.netAmount = _data["netAmount"];
            this.relativeAllowanceBaseAmount = _data["relativeAllowanceBaseAmount"];
            this.relativeAllowancePercentage = _data["relativeAllowancePercentage"];
            this.vatCategory = _data["vatCategory"];
            this.vatRate = _data["vatRate"];
            this.reason = _data["reason"];
            this.reasonCode = _data["reasonCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAllowance();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["netAmount"] = this.netAmount;
        data["relativeAllowanceBaseAmount"] = this.relativeAllowanceBaseAmount;
        data["relativeAllowancePercentage"] = this.relativeAllowancePercentage;
        data["vatCategory"] = this.vatCategory;
        data["vatRate"] = this.vatRate;
        data["reason"] = this.reason;
        data["reasonCode"] = this.reasonCode;
        return data;
    }
}
exports.InvoiceAllowance = InvoiceAllowance;
/** This describes an charge in an invoice, which is a surcharge to the total amount */
class InvoiceCharge {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.netAmount = _data["netAmount"];
            this.relativeChargeBaseAmount = _data["relativeChargeBaseAmount"];
            this.relativeChargePercentage = _data["relativeChargePercentage"];
            this.vatCategory = _data["vatCategory"];
            this.vatRate = _data["vatRate"];
            this.reason = _data["reason"];
            this.reasonCode = _data["reasonCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceCharge();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["netAmount"] = this.netAmount;
        data["relativeChargeBaseAmount"] = this.relativeChargeBaseAmount;
        data["relativeChargePercentage"] = this.relativeChargePercentage;
        data["vatCategory"] = this.vatCategory;
        data["vatRate"] = this.vatRate;
        data["reason"] = this.reason;
        data["reasonCode"] = this.reasonCode;
        return data;
    }
}
exports.InvoiceCharge = InvoiceCharge;
/** Represents a single invoice line item */
class InvoiceLineItem {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.lineItemPeriod = data.lineItemPeriod && !data.lineItemPeriod.toJSON ? new InvoicePeriod(data.lineItemPeriod) : this.lineItemPeriod;
            if (data.allowances) {
                this.allowances = [];
                for (let i = 0; i < data.allowances.length; i++) {
                    let item = data.allowances[i];
                    this.allowances[i] = item && !item.toJSON ? new LineItemAllowance(item) : item;
                }
            }
            if (data.charges) {
                this.charges = [];
                for (let i = 0; i < data.charges.length; i++) {
                    let item = data.charges[i];
                    this.charges[i] = item && !item.toJSON ? new LineItemCharge(item) : item;
                }
            }
            this.priceDetails = data.priceDetails && !data.priceDetails.toJSON ? new LineItemPriceDetail(data.priceDetails) : this.priceDetails;
            if (data.vatInformation) {
                this.vatInformation = [];
                for (let i = 0; i < data.vatInformation.length; i++) {
                    let item = data.vatInformation[i];
                    this.vatInformation[i] = item && !item.toJSON ? new LineItemVatInformation(item) : item;
                }
            }
            this.itemInformation = data.itemInformation && !data.itemInformation.toJSON ? new LineItemInformation(data.itemInformation) : this.itemInformation;
            if (data.subItems) {
                this.subItems = [];
                for (let i = 0; i < data.subItems.length; i++) {
                    let item = data.subItems[i];
                    this.subItems[i] = item && !item.toJSON ? new InvoiceLineItem(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.note = _data["note"];
            this.objectIdentifier = _data["objectIdentifier"];
            this.quantity = _data["quantity"];
            this.unitCode = _data["unitCode"];
            this.netAmount = _data["netAmount"];
            this.purchaseOrderReference = _data["purchaseOrderReference"];
            this.lineItemPeriod = _data["lineItemPeriod"] ? InvoicePeriod.fromJS(_data["lineItemPeriod"]) : undefined;
            if (Array.isArray(_data["allowances"])) {
                this.allowances = [];
                for (let item of _data["allowances"])
                    this.allowances.push(LineItemAllowance.fromJS(item));
            }
            if (Array.isArray(_data["charges"])) {
                this.charges = [];
                for (let item of _data["charges"])
                    this.charges.push(LineItemCharge.fromJS(item));
            }
            this.priceDetails = _data["priceDetails"] ? LineItemPriceDetail.fromJS(_data["priceDetails"]) : undefined;
            if (Array.isArray(_data["vatInformation"])) {
                this.vatInformation = [];
                for (let item of _data["vatInformation"])
                    this.vatInformation.push(LineItemVatInformation.fromJS(item));
            }
            this.itemInformation = _data["itemInformation"] ? LineItemInformation.fromJS(_data["itemInformation"]) : undefined;
            if (Array.isArray(_data["subItems"])) {
                this.subItems = [];
                for (let item of _data["subItems"])
                    this.subItems.push(InvoiceLineItem.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLineItem();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["note"] = this.note;
        data["objectIdentifier"] = this.objectIdentifier;
        data["quantity"] = this.quantity;
        data["unitCode"] = this.unitCode;
        data["netAmount"] = this.netAmount;
        data["purchaseOrderReference"] = this.purchaseOrderReference;
        data["lineItemPeriod"] = this.lineItemPeriod ? this.lineItemPeriod.toJSON() : undefined;
        if (Array.isArray(this.allowances)) {
            data["allowances"] = [];
            for (let item of this.allowances)
                data["allowances"].push(item.toJSON());
        }
        if (Array.isArray(this.charges)) {
            data["charges"] = [];
            for (let item of this.charges)
                data["charges"].push(item.toJSON());
        }
        data["priceDetails"] = this.priceDetails ? this.priceDetails.toJSON() : undefined;
        if (Array.isArray(this.vatInformation)) {
            data["vatInformation"] = [];
            for (let item of this.vatInformation)
                data["vatInformation"].push(item.toJSON());
        }
        data["itemInformation"] = this.itemInformation ? this.itemInformation.toJSON() : undefined;
        if (Array.isArray(this.subItems)) {
            data["subItems"] = [];
            for (let item of this.subItems)
                data["subItems"].push(item.toJSON());
        }
        return data;
    }
}
exports.InvoiceLineItem = InvoiceLineItem;
/** Allowance for a single line item */
class LineItemAllowance {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.netAmount = _data["netAmount"];
            this.relativeAllowanceBaseAmount = _data["relativeAllowanceBaseAmount"];
            this.relativeAllowancePercentage = _data["relativeAllowancePercentage"];
            this.reason = _data["reason"];
            this.reasonCode = _data["reasonCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LineItemAllowance();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["netAmount"] = this.netAmount;
        data["relativeAllowanceBaseAmount"] = this.relativeAllowanceBaseAmount;
        data["relativeAllowancePercentage"] = this.relativeAllowancePercentage;
        data["reason"] = this.reason;
        data["reasonCode"] = this.reasonCode;
        return data;
    }
}
exports.LineItemAllowance = LineItemAllowance;
/** Charge for a single line item */
class LineItemCharge {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.netAmount = _data["netAmount"];
            this.relativeChargeBaseAmount = _data["relativeChargeBaseAmount"];
            this.relativeChargePercentage = _data["relativeChargePercentage"];
            this.reason = _data["reason"];
            this.reasonCode = _data["reasonCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LineItemCharge();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["netAmount"] = this.netAmount;
        data["relativeChargeBaseAmount"] = this.relativeChargeBaseAmount;
        data["relativeChargePercentage"] = this.relativeChargePercentage;
        data["reason"] = this.reason;
        data["reasonCode"] = this.reasonCode;
        return data;
    }
}
exports.LineItemCharge = LineItemCharge;
/** Price details about a line item */
class LineItemPriceDetail {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.netPrice = _data["netPrice"];
            this.absoluteDiscountPerItem = _data["absoluteDiscountPerItem"];
            this.grossPrice = _data["grossPrice"];
            this.baseQuantity = _data["baseQuantity"];
            this.baseQuantityUnitCode = _data["baseQuantityUnitCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LineItemPriceDetail();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["netPrice"] = this.netPrice;
        data["absoluteDiscountPerItem"] = this.absoluteDiscountPerItem;
        data["grossPrice"] = this.grossPrice;
        data["baseQuantity"] = this.baseQuantity;
        data["baseQuantityUnitCode"] = this.baseQuantityUnitCode;
        return data;
    }
}
exports.LineItemPriceDetail = LineItemPriceDetail;
/** VAT information for a single line item */
class LineItemVatInformation {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.vatCategory = _data["vatCategory"];
            this.vatRate = _data["vatRate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LineItemVatInformation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["vatCategory"] = this.vatCategory;
        data["vatRate"] = this.vatRate;
        return data;
    }
}
exports.LineItemVatInformation = LineItemVatInformation;
/** Information about a single line item */
class LineItemInformation {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.attributes) {
                this.attributes = [];
                for (let i = 0; i < data.attributes.length; i++) {
                    let item = data.attributes[i];
                    this.attributes[i] = item && !item.toJSON ? new LineItemAttribute(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.sellerIdentifier = _data["sellerIdentifier"];
            this.buyerIdentifier = _data["buyerIdentifier"];
            this.standardIdentifier = _data["standardIdentifier"];
            if (Array.isArray(_data["classificationIdentifiers"])) {
                this.classificationIdentifiers = [];
                for (let item of _data["classificationIdentifiers"])
                    this.classificationIdentifiers.push(item);
            }
            this.countryOfOrigin = _data["countryOfOrigin"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [];
                for (let item of _data["attributes"])
                    this.attributes.push(LineItemAttribute.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LineItemInformation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["sellerIdentifier"] = this.sellerIdentifier;
        data["buyerIdentifier"] = this.buyerIdentifier;
        data["standardIdentifier"] = this.standardIdentifier;
        if (Array.isArray(this.classificationIdentifiers)) {
            data["classificationIdentifiers"] = [];
            for (let item of this.classificationIdentifiers)
                data["classificationIdentifiers"].push(item);
        }
        data["countryOfOrigin"] = this.countryOfOrigin;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item.toJSON());
        }
        return data;
    }
}
exports.LineItemInformation = LineItemInformation;
/** A key-value pair for additional information */
class LineItemAttribute {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LineItemAttribute();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}
exports.LineItemAttribute = LineItemAttribute;
/** This enum represents the source of an invoice, e.g. from which format it was imported */
var SourceType;
(function (SourceType) {
    SourceType["Self"] = "Self";
    SourceType["Ubl"] = "Ubl";
    SourceType["Cii"] = "Cii";
})(SourceType = exports.SourceType || (exports.SourceType = {}));
/** This is a wrapper class that maps Dangl.AVA projects along with additional required information to create invoices */
class AvaProjectWrapper {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            this.project = data.project && !data.project.toJSON ? new ProjectDto(data.project) : this.project;
            if (data.documents) {
                this.documents = [];
                for (let i = 0; i < data.documents.length; i++) {
                    let item = data.documents[i];
                    this.documents[i] = item && !item.toJSON ? new SupportingDocument(item) : item;
                }
            }
            this.invoicePeriod = data.invoicePeriod && !data.invoicePeriod.toJSON ? new InvoicePeriod(data.invoicePeriod) : this.invoicePeriod;
            this.paymentInstructions = data.paymentInstructions && !data.paymentInstructions.toJSON ? new PaymentInstructions(data.paymentInstructions) : this.paymentInstructions;
            if (data.previousInvoices) {
                this.previousInvoices = [];
                for (let i = 0; i < data.previousInvoices.length; i++) {
                    let item = data.previousInvoices[i];
                    this.previousInvoices[i] = item && !item.toJSON ? new PreviousInvoice(item) : item;
                }
            }
            this.references = data.references && !data.references.toJSON ? new References(data.references) : this.references;
        }
        if (!data) {
            this.project = new ProjectDto();
        }
    }
    init(_data) {
        if (_data) {
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : new ProjectDto();
            this.invoiceNumber = _data["invoiceNumber"];
            if (Array.isArray(_data["documents"])) {
                this.documents = [];
                for (let item of _data["documents"])
                    this.documents.push(SupportingDocument.fromJS(item));
            }
            this.invoicePeriod = _data["invoicePeriod"] ? InvoicePeriod.fromJS(_data["invoicePeriod"]) : undefined;
            this.paymentInstructions = _data["paymentInstructions"] ? PaymentInstructions.fromJS(_data["paymentInstructions"]) : undefined;
            this.invoiceType = _data["invoiceType"];
            this.paymentDueDate = _data["paymentDueDate"] ? new Date(_data["paymentDueDate"].toString()) : undefined;
            this.paymentTerms = _data["paymentTerms"];
            if (Array.isArray(_data["previousInvoices"])) {
                this.previousInvoices = [];
                for (let item of _data["previousInvoices"])
                    this.previousInvoices.push(PreviousInvoice.fromJS(item));
            }
            this.alreadyPaidTotalGross = _data["alreadyPaidTotalGross"];
            this.references = _data["references"] ? References.fromJS(_data["references"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AvaProjectWrapper();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["project"] = this.project ? this.project.toJSON() : undefined;
        data["invoiceNumber"] = this.invoiceNumber;
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            for (let item of this.documents)
                data["documents"].push(item.toJSON());
        }
        data["invoicePeriod"] = this.invoicePeriod ? this.invoicePeriod.toJSON() : undefined;
        data["paymentInstructions"] = this.paymentInstructions ? this.paymentInstructions.toJSON() : undefined;
        data["invoiceType"] = this.invoiceType;
        data["paymentDueDate"] = this.paymentDueDate ? this.paymentDueDate.toISOString() : undefined;
        data["paymentTerms"] = this.paymentTerms;
        if (Array.isArray(this.previousInvoices)) {
            data["previousInvoices"] = [];
            for (let item of this.previousInvoices)
                data["previousInvoices"].push(item.toJSON());
        }
        data["alreadyPaidTotalGross"] = this.alreadyPaidTotalGross;
        data["references"] = this.references ? this.references.toJSON() : undefined;
        return data;
    }
}
exports.AvaProjectWrapper = AvaProjectWrapper;
class LoginPost {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.password = _data["password"];
            this.staySignedIn = _data["staySignedIn"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new LoginPost();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["password"] = this.password;
        data["staySignedIn"] = this.staySignedIn;
        return data;
    }
}
exports.LoginPost = LoginPost;
class TokenResponseGet {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.error = _data["error"];
            this.errorDescription = _data["errorDescription"];
            this.expiresIn = _data["expiresIn"];
            this.httpErrorReason = _data["httpErrorReason"];
            this.httpStatusCode = _data["httpStatusCode"];
            this.identityToken = _data["identityToken"];
            this.isError = _data["isError"];
            this.refreshToken = _data["refreshToken"];
            this.tokenType = _data["tokenType"];
            this.errorType = _data["errorType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TokenResponseGet();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["error"] = this.error;
        data["errorDescription"] = this.errorDescription;
        data["expiresIn"] = this.expiresIn;
        data["httpErrorReason"] = this.httpErrorReason;
        data["httpStatusCode"] = this.httpStatusCode;
        data["identityToken"] = this.identityToken;
        data["isError"] = this.isError;
        data["refreshToken"] = this.refreshToken;
        data["tokenType"] = this.tokenType;
        data["errorType"] = this.errorType;
        return data;
    }
}
exports.TokenResponseGet = TokenResponseGet;
var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode["Continue"] = "Continue";
    HttpStatusCode["SwitchingProtocols"] = "SwitchingProtocols";
    HttpStatusCode["Processing"] = "Processing";
    HttpStatusCode["EarlyHints"] = "EarlyHints";
    HttpStatusCode["OK"] = "OK";
    HttpStatusCode["Created"] = "Created";
    HttpStatusCode["Accepted"] = "Accepted";
    HttpStatusCode["NonAuthoritativeInformation"] = "NonAuthoritativeInformation";
    HttpStatusCode["NoContent"] = "NoContent";
    HttpStatusCode["ResetContent"] = "ResetContent";
    HttpStatusCode["PartialContent"] = "PartialContent";
    HttpStatusCode["MultiStatus"] = "MultiStatus";
    HttpStatusCode["AlreadyReported"] = "AlreadyReported";
    HttpStatusCode["IMUsed"] = "IMUsed";
    HttpStatusCode["MultipleChoices"] = "MultipleChoices";
    HttpStatusCode["Ambiguous"] = "MovedPermanently";
    HttpStatusCode["MovedPermanently"] = "Found";
    HttpStatusCode["Moved"] = "SeeOther";
    HttpStatusCode["Found"] = "NotModified";
    HttpStatusCode["Redirect"] = "UseProxy";
    HttpStatusCode["SeeOther"] = "Unused";
    HttpStatusCode["RedirectMethod"] = "RedirectKeepVerb";
    HttpStatusCode["NotModified"] = "PermanentRedirect";
    HttpStatusCode["UseProxy"] = "BadRequest";
    HttpStatusCode["Unused"] = "Unauthorized";
    HttpStatusCode["TemporaryRedirect"] = "PaymentRequired";
    HttpStatusCode["RedirectKeepVerb"] = "Forbidden";
    HttpStatusCode["PermanentRedirect"] = "NotFound";
    HttpStatusCode["BadRequest"] = "MethodNotAllowed";
    HttpStatusCode["Unauthorized"] = "NotAcceptable";
    HttpStatusCode["PaymentRequired"] = "ProxyAuthenticationRequired";
    HttpStatusCode["Forbidden"] = "RequestTimeout";
    HttpStatusCode["NotFound"] = "Conflict";
    HttpStatusCode["MethodNotAllowed"] = "Gone";
    HttpStatusCode["NotAcceptable"] = "LengthRequired";
    HttpStatusCode["ProxyAuthenticationRequired"] = "PreconditionFailed";
    HttpStatusCode["RequestTimeout"] = "RequestEntityTooLarge";
    HttpStatusCode["Conflict"] = "RequestUriTooLong";
    HttpStatusCode["Gone"] = "UnsupportedMediaType";
    HttpStatusCode["LengthRequired"] = "RequestedRangeNotSatisfiable";
    HttpStatusCode["PreconditionFailed"] = "ExpectationFailed";
    HttpStatusCode["RequestEntityTooLarge"] = "MisdirectedRequest";
    HttpStatusCode["RequestUriTooLong"] = "UnprocessableEntity";
    HttpStatusCode["UnsupportedMediaType"] = "Locked";
    HttpStatusCode["RequestedRangeNotSatisfiable"] = "FailedDependency";
    HttpStatusCode["ExpectationFailed"] = "UpgradeRequired";
    HttpStatusCode["MisdirectedRequest"] = "PreconditionRequired";
    HttpStatusCode["UnprocessableEntity"] = "TooManyRequests";
    HttpStatusCode["UnprocessableContent"] = "RequestHeaderFieldsTooLarge";
    HttpStatusCode["Locked"] = "UnavailableForLegalReasons";
    HttpStatusCode["FailedDependency"] = "InternalServerError";
    HttpStatusCode["UpgradeRequired"] = "NotImplemented";
    HttpStatusCode["PreconditionRequired"] = "BadGateway";
    HttpStatusCode["TooManyRequests"] = "ServiceUnavailable";
    HttpStatusCode["RequestHeaderFieldsTooLarge"] = "GatewayTimeout";
    HttpStatusCode["UnavailableForLegalReasons"] = "HttpVersionNotSupported";
    HttpStatusCode["InternalServerError"] = "VariantAlsoNegotiates";
    HttpStatusCode["NotImplemented"] = "InsufficientStorage";
    HttpStatusCode["BadGateway"] = "LoopDetected";
    HttpStatusCode["ServiceUnavailable"] = "NotExtended";
    HttpStatusCode["GatewayTimeout"] = "NetworkAuthenticationRequired";
})(HttpStatusCode = exports.HttpStatusCode || (exports.HttpStatusCode = {}));
var ResponseErrorType;
(function (ResponseErrorType) {
    ResponseErrorType["None"] = "None";
    ResponseErrorType["Protocol"] = "Protocol";
    ResponseErrorType["Http"] = "Http";
    ResponseErrorType["Exception"] = "Exception";
    ResponseErrorType["PolicyViolation"] = "PolicyViolation";
})(ResponseErrorType = exports.ResponseErrorType || (exports.ResponseErrorType = {}));
class TokenLoginPost {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.password = _data["password"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TokenLoginPost();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["password"] = this.password;
        return data;
    }
}
exports.TokenLoginPost = TokenLoginPost;
class TokenRefreshPost {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRefreshPost();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}
exports.TokenRefreshPost = TokenRefreshPost;
class RegisterPost {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.username = _data["username"];
            this.email = _data["email"];
            this.password = _data["password"];
            if (Array.isArray(_data["preferredLanguages"])) {
                this.preferredLanguages = [];
                for (let item of _data["preferredLanguages"])
                    this.preferredLanguages.push(item);
            }
            this.serviceLoginRedirectUri = _data["serviceLoginRedirectUri"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterPost();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["email"] = this.email;
        data["password"] = this.password;
        if (Array.isArray(this.preferredLanguages)) {
            data["preferredLanguages"] = [];
            for (let item of this.preferredLanguages)
                data["preferredLanguages"].push(item);
        }
        data["serviceLoginRedirectUri"] = this.serviceLoginRedirectUri;
        return data;
    }
}
exports.RegisterPost = RegisterPost;
class ForgotPasswordPost {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.identifier = _data["identifier"];
            if (Array.isArray(_data["preferredLanguages"])) {
                this.preferredLanguages = [];
                for (let item of _data["preferredLanguages"])
                    this.preferredLanguages.push(item);
            }
            this.serviceLoginRedirectUri = _data["serviceLoginRedirectUri"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordPost();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        if (Array.isArray(this.preferredLanguages)) {
            data["preferredLanguages"] = [];
            for (let item of this.preferredLanguages)
                data["preferredLanguages"].push(item);
        }
        data["serviceLoginRedirectUri"] = this.serviceLoginRedirectUri;
        return data;
    }
}
exports.ForgotPasswordPost = ForgotPasswordPost;
class UserInfoGet {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
            if (data.userClaims) {
                this.userClaims = [];
                for (let i = 0; i < data.userClaims.length; i++) {
                    let item = data.userClaims[i];
                    this.userClaims[i] = item && !item.toJSON ? new ClaimGet(item) : item;
                }
            }
            if (data.clientClaims) {
                this.clientClaims = [];
                for (let i = 0; i < data.clientClaims.length; i++) {
                    let item = data.clientClaims[i];
                    this.clientClaims[i] = item && !item.toJSON ? new ClaimGet(item) : item;
                }
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userIsAuthenticated = _data["userIsAuthenticated"];
            this.clientIsAuthenticated = _data["clientIsAuthenticated"];
            this.currentUserId = _data["currentUserId"];
            this.currentUserIdenticonId = _data["currentUserIdenticonId"];
            this.currentUserName = _data["currentUserName"];
            this.currentUserEmail = _data["currentUserEmail"];
            this.currentClientId = _data["currentClientId"];
            if (Array.isArray(_data["userClaims"])) {
                this.userClaims = [];
                for (let item of _data["userClaims"])
                    this.userClaims.push(ClaimGet.fromJS(item));
            }
            if (Array.isArray(_data["clientClaims"])) {
                this.clientClaims = [];
                for (let item of _data["clientClaims"])
                    this.clientClaims.push(ClaimGet.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoGet();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userIsAuthenticated"] = this.userIsAuthenticated;
        data["clientIsAuthenticated"] = this.clientIsAuthenticated;
        data["currentUserId"] = this.currentUserId;
        data["currentUserIdenticonId"] = this.currentUserIdenticonId;
        data["currentUserName"] = this.currentUserName;
        data["currentUserEmail"] = this.currentUserEmail;
        data["currentClientId"] = this.currentClientId;
        if (Array.isArray(this.userClaims)) {
            data["userClaims"] = [];
            for (let item of this.userClaims)
                data["userClaims"].push(item.toJSON());
        }
        if (Array.isArray(this.clientClaims)) {
            data["clientClaims"] = [];
            for (let item of this.clientClaims)
                data["clientClaims"].push(item.toJSON());
        }
        return data;
    }
}
exports.UserInfoGet = UserInfoGet;
class ClaimGet {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.issuer = _data["issuer"];
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ClaimGet();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["issuer"] = this.issuer;
        data["type"] = this.type;
        data["value"] = this.value;
        return data;
    }
}
exports.ClaimGet = ClaimGet;
class SwaggerResponse {
    constructor(status, headers, result) {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}
exports.SwaggerResponse = SwaggerResponse;
class ApiException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
//# sourceMappingURL=api.js.map